webpackJsonp([3],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errorHandler__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper__ = __webpack_require__(202);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__bus__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__errorHandler__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__form__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__helper__["a"]; });







/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return localesMap; });
/* unused harmony export getSupportedLanguage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return i18n; });
/* harmony export (immutable) */ __webpack_exports__["b"] = loadLanguageAsync;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_i18n__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__langs__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__(392);








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale___default.a.i18n(function (key, value) {
  return i18n.t(key, value);
});

var DEFAULT_LANGUAGE = 'en';
var loadedLanguages = [DEFAULT_LANGUAGE];
var supportedLanguages = [DEFAULT_LANGUAGE, 'zh'];

var localesMap = {
  zh: 'zh-TW',
  en: 'en'
};

function setI18nLanguage(lang) {
  i18n.locale = lang;
  __WEBPACK_IMPORTED_MODULE_6_vee_validate__["b" /* Validator */].localize(lang);
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

function getSupportedLanguage(language) {
  return [language, window.localStorage.getItem('lang')].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(window.navigator.languages || [window.navigator.language]), [DEFAULT_LANGUAGE]).filter(Boolean).map(function (x) {
    return x.slice(0, 2);
  }).filter(function (x) {
    return supportedLanguages.includes(x);
  }).find(Boolean);
}

var i18n = new __WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]({
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: DEFAULT_LANGUAGE,
  messages: __WEBPACK_IMPORTED_MODULE_5__langs__["default"]
});

function loadLanguageAsync(lang) {
  lang = getSupportedLanguage(lang);

  window.localStorage.setItem('lang', lang);

  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return __webpack_require__(994)("./" + lang).then(function (msgs) {
        i18n.setLocaleMessage(lang, msgs.default);
        loadedLanguages.push(lang);
        return setI18nLanguage(lang);
      });
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(setI18nLanguage(lang));
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(lang);
}

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(851)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(973),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-70497e28",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(850)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(972),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63b75acc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */,
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createResource;
/* harmony export (immutable) */ __webpack_exports__["a"] = updateAuthHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(103);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

function createResource(Vue, url) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return Vue.$resource.apply(Vue, [__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI + url].concat(args));
}

function updateAuthHeader(Vue, token) {
  Vue.http.headers.common['Authorization'] = 'Bearer ' + token;
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  createResource: createResource,
  updateAuthHeader: updateAuthHeader
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  serverURI: location.hostname === 'localhost' ? 'https://hamv2-dev.apps.exosite.io' : location.origin,
  fixedLayout: true,
  hideLogoOnMobile: false,
  noLoginPaths: ['/', '/login', '/legal', '/reset']
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_en__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en_json__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__en_json__);




/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale_lang_en___default.a, __WEBPACK_IMPORTED_MODULE_2__en_json___default.a));

/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(57);



__WEBPACK_IMPORTED_MODULE_0_moment___default.a.updateLocale('en', {
  relativeTime: {
    M: '1 month',
    MM: '%d months',
    d: '1 day',
    dd: '%d days',
    future: 'in %s',
    h: '1 hour',
    hh: '%d hours',
    m: '1 min',
    mm: '%d mins',
    past: '%s ago',
    s: function s(value) {
      var unit = value === 1 || value === 0 ? 'sec' : 'secs';
      return value + ' ' + unit;
    },
    y: '1 year',
    yy: '%d years'
  }
});

function formatDate(date) {
  var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).locale(__WEBPACK_IMPORTED_MODULE_1__i18n__["c" /* localesMap */][__WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* i18n */].locale]);

  if (!m.isValid()) return date;
  return m.format('MM/DD/YYYY, HH:mm:ss') + ' (' + m.fromNow() + ')';
}

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__en__ = __webpack_require__(104);


/* harmony default export */ __webpack_exports__["default"] = ({
  en: __WEBPACK_IMPORTED_MODULE_0__en__["default"]
});

/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(837)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(959),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f2579ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return admin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return device; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return devices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return exports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return firmwareDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return firmwareList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firmwareUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return geolocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return image; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return infoModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return legal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return tsdb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return notifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return onlineTesting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return reset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return serviceConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return session; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return theme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return total; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return user; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return users; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(102);




var vue = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
var admin = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/admin');
var device = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/devices{/id}');
var devices = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/devices');
var exports = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/open/export');
var firmwareDelete = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/fw/delete', {}, {}, {
  headers: {
    'content-type': 'application/x-www-form-urlencoded'
  }
});
var firmwareList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/fw/list');
var firmwareUpload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/fw/upload');
var geolocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/geolocation{/ip}');
var image = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/image');
var infoModel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/info-model');
var legal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/term_of_service');
var tsdb = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/tsdb/query');
var notifications = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/ruleTemplate{/id}');
var onlineTesting = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/online_testing_tool');
var reset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/reset');
var serviceConfig = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/serviceConfig/{service}');
var session = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/session');
var theme = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/theme');
var total = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/total');
var user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/users{/id}');
var users = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["b" /* createResource */])(vue, '/api:1/users');

/* unused harmony default export */ var _unused_webpack_default_export = ({
  admin: admin,
  device: device,
  devices: devices,
  exports: exports,
  firmwareDelete: firmwareDelete,
  firmwareList: firmwareList,
  firmwareUpload: firmwareUpload,
  geolocation: geolocation,
  image: image,
  infoModel: infoModel,
  legal: legal,
  tsdb: tsdb,
  notifications: notifications,
  onlineTesting: onlineTesting,
  reset: reset,
  serviceConfig: serviceConfig,
  session: session,
  theme: theme,
  total: total,
  user: user,
  users: users
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_App_vue__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__App_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dash_Dash_vue__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dash_Dash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Dash_Dash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Device_Device_vue__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Device_Device_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Device_Device_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dialog_Dialog_vue__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dialog_Dialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Dialog_Dialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Export_Export_vue__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Export_Export_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Export_Export_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Firmware_Firmware_vue__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Firmware_Firmware_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Firmware_Firmware_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfoBox_InfoBox_vue__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfoBox_InfoBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__InfoBox_InfoBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InformationModel_InformationModel_vue__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InformationModel_InformationModel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__InformationModel_InformationModel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Login_Login_vue__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Login_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Login_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NotFound_NotFound_vue__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NotFound_NotFound_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__NotFound_NotFound_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Notifications_Notifications_vue__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Notifications_Notifications_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Notifications_Notifications_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ResetPassword_ResetPassword_vue__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ResetPassword_ResetPassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ResetPassword_ResetPassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Sidebar_Sidebar_vue__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Sidebar_Sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Sidebar_Sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Theme_Theme_vue__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Theme_Theme_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Theme_Theme_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Timeline_Timeline_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Timeline_Timeline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__Timeline_Timeline_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TimelineLog_TimelineLog_vue__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TimelineLog_TimelineLog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__TimelineLog_TimelineLog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__User_User_vue__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__User_User_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__User_User_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__UserInfo_UserInfo_vue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__UserInfo_UserInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__UserInfo_UserInfo_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__App_App_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__Dash_Dash_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__Device_Device_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__Dialog_Dialog_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_4__Export_Export_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__Firmware_Firmware_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__InfoBox_InfoBox_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_7__InformationModel_InformationModel_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__Login_Login_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_9__NotFound_NotFound_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__Notifications_Notifications_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_11__ResetPassword_ResetPassword_vue___default.a; });
/* unused harmony reexport Sidebar */
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_13__Theme_Theme_vue___default.a; });
/* unused harmony reexport Timeline */
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_15__TimelineLog_TimelineLog_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_16__User_User_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_17__UserInfo_UserInfo_vue___default.a; });





















/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_pages__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(199);




var routes = [{
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_1__components__["f" /* Login */]
}, {
  path: '/reset',
  component: __WEBPACK_IMPORTED_MODULE_1__components__["g" /* ResetPassword */]
}, {
  path: '/legal',
  component: __WEBPACK_IMPORTED_MODULE_0__assets_pages__["a" /* Legal */]
}, {
  path: '/reset/:code',
  component: __WEBPACK_IMPORTED_MODULE_0__assets_pages__["b" /* Reset */]
}, {
  path: '/confirmation/:token',
  component: __WEBPACK_IMPORTED_MODULE_0__assets_pages__["c" /* Confirmation */]
}, {
  path: '/welcome',
  component: __WEBPACK_IMPORTED_MODULE_0__assets_pages__["d" /* Welcome */]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_1__components__["h" /* Dash */],
  children: [{
    path: 'device',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_1__components__["i" /* Device */],
    name: 'Device List',
    meta: { description: '' }
  }, {
    path: 'device/:sn',
    component: __WEBPACK_IMPORTED_MODULE_1__components__["i" /* Device */],
    name: 'Device List',
    meta: { description: '' }
  }, {
    path: 'export',
    component: __WEBPACK_IMPORTED_MODULE_1__components__["j" /* Export */],
    name: 'Export',
    meta: { description: '' }
  }, {
    path: 'firmware',
    component: __WEBPACK_IMPORTED_MODULE_1__components__["k" /* Firmware */],
    name: 'Firmware List',
    meta: { description: '' }
  }, {
    path: 'informationModel',
    component: __WEBPACK_IMPORTED_MODULE_1__components__["l" /* InformationModel */],
    name: 'Information Model',
    meta: {
      description: ''
    }
  }, {
    path: 'notifications',
    component: __WEBPACK_IMPORTED_MODULE_1__components__["m" /* Notifications */],
    name: 'Notifications',
    meta: {
      description: ''
    }
  }, {
    path: 'theme',
    component: __WEBPACK_IMPORTED_MODULE_1__components__["n" /* Theme */],
    name: 'Theme',
    meta: { description: '' }
  }, {
    path: 'theme/:id',
    component: __WEBPACK_IMPORTED_MODULE_1__components__["n" /* Theme */],
    name: 'Theme',
    meta: { description: '' }
  }, {
    path: 'user',
    component: __WEBPACK_IMPORTED_MODULE_1__components__["o" /* User */],
    name: 'User List',
    meta: { description: '' }
  }, {
    path: 'user/:email',
    component: __WEBPACK_IMPORTED_MODULE_1__components__["o" /* User */],
    name: 'User List',
    meta: { description: '' }
  }]
}, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_1__components__["p" /* NotFound */]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var error = {
  general: {
    403: 'errorHandlerGeneralStatusCode403'
  },
  firmwareDelete: {
    default: 'errorHandlerFirmwareDeleteDefault'
  },
  firmwareUpload: {
    default: 'errorHandlerFirmwareUploadDefault'
  },
  informationModelDelete: {
    428: 'errorHandlerInformationModelDeleteStatusCode428',
    default: 'errorHandlerInformationModelDeleteDefault'
  },
  informationModelUpload: {
    400: 'The information model limit reached.',
    428: 'errorHandlerInformationModelUploadStatusCode428',
    default: 'errorHandlerInformationModelUploadDefault'
  },
  informationModelImagesUpload: {
    default: 'errorHandlerInformationModelImagesUploadDefault'
  },
  legal: {
    default: 'errorHandlerLegalDefault'
  },
  notifications: {
    default: 'errorHandlerNotificationsDefault'
  },
  notificationsDelete: {
    default: 'errorHandlerNotificationsDeleteDefault'
  },
  notificationsEdit: {
    default: 'errorHandlerNotificationsEditDefault'
  },
  solutionStatusTest: {
    default: 'errorHandlerSolutionStatusTestDefault'
  },
  timeline: {
    default: 'errorHandlerTimelineDefault'
  },
  timelineModel: {
    default: 'errorHandlerTimelineModelDefault'
  },
  theme: {
    default: 'errorHandlerThemeDefault'
  },
  themeLegal: {
    default: 'errorHandlerThemeLegalDefault'
  },
  themeView: {
    default: 'errorHandlerThemeViewDefault'
  },
  user: {
    default: 'errorHandlerUserDefault'
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function (component, status) {
  return error[component][status] || error[component].default;
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_helper__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__errorHandler__ = __webpack_require__(201);









/* harmony default export */ __webpack_exports__["a"] = ({
  appendToHtmlAttribute: function appendToHtmlAttribute(message, error) {
    return '<div data-more-details="' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(error) + '">' + message + '</div>';
  },
  clearLoginData: function clearLoginData(current) {
    if (!current) {
      throw new Error('Please provide a global class.');
    }

    current.$store.commit('SET_TOKEN', null);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_helper__["a" /* updateAuthHeader */])(__WEBPACK_IMPORTED_MODULE_3_vue__["default"], null);

    current.$store.commit('SET_USER', '');
    if (current.$cookie) {
      current.$cookie.delete('sid');
    } else if (current.$router.app.$cookie) {
      current.$router.app.$cookie.delete('sid');
    }

    window.localStorage.removeItem('uid');
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('token');
  },
  isMobile: function isMobile() {
    return (/(Android|iPhone|iPad)/.test(navigator.userAgent)
    );
  },

  notShowAlertList: [403, 405],
  parseStartTime: function parseStartTime() {
    var retention = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (retention === 'infinity') {
      return new Date(0).toJSON();
    }

    var _retention$trim$match = retention.trim().match(/(\d*)(\w*)/),
        _retention$trim$match2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_retention$trim$match, 3),
        number = _retention$trim$match2[1],
        unit = _retention$trim$match2[2];

    if (unit === 'm') {
      unit = 'M';
    }

    var formatRetention = ['d', 'w', 'M', 'y'].indexOf(unit) > -1 ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, unit, number) : { d: 31 };

    return __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(formatRetention).toJSON();
  },
  showErrorMessage: function showErrorMessage(current, component, error) {
    var message = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    if (!current) {
      throw new Error('Please provide a global class.');
    }

    if (this.notShowAlertList.includes(error.status) && component !== 'general') return;
    if (!message) {
      message = current.$t ? current.$t(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__errorHandler__["a" /* default */])(component, error.status, message)) : __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* i18n */].t(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__errorHandler__["a" /* default */])(component, error.status, message));
    }

    message = this.appendToHtmlAttribute(message, error);

    var data = {
      dangerouslyUseHTMLString: true,
      duration: 0,
      message: message,
      showClose: true,
      type: 'error'
    };

    current.$message ? current.$message(data) : current.Message(data);
  }
});

/***/ }),
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(844)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(966),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42f42a78",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(855)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(977),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8000a62c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */,
/* 396 */
/***/ (function(module, exports) {

module.exports = {"All":"All","Analytics":"Analytics","ComponentTitle":{"Device List":"Device List","Export":"Export","Firmware List":"Firmware List","Information Model":"Information Model","Notifications":"Notifications","Theme":"Theme","User List":"User List"},"LogType":{"DEBUG":"DEBUG","ERROR":"ERROR","EVENT":"EVENT"},"NoFileChosen":"No file chosen","NotificationsCreateFailedMessage":"There was an issue completing your request. Please check the format of the notification rule you are trying to save and try again.","NotificationsCreateFailedNoOwnerIdMessage":"Failed to create notification without owner id, please try to login and logout again.","NotificationsEditFailedNoOwnerIdMessage":"Failed to update notification without owner id, please try to login and logout again.","NotificationsLimitedBlockNotificationsBody":"Push notifications allow products to send reminders and communicate with their users when a certain criteria is met.{br}For example, you may want to let users know when a device experiences an issue and needs a check-up.{p}If you’re interested in adding notifications to your solution, please contact {support}.","NotificationsLimitedBlockNotificationsTitle":"IT LOOKS LIKE YOUR PLAN CURRENTLY DOES NOT SUPPORT NOTIFICATIONS","Offline":"Offline","Online":"Online","Owner":"Owner","dashFooterCopyRightText":"All rights reserved.","dashFooterDocumentationText":"Documentation","dashFooterPrivacyText":"Privacy","dashFooterSupportText":"Support","dashFooterTermsText":"Terms","dashFooterVersionText":"Version {0}","dashUserDropDownSignOutText":"Sign Out","dashUserDropDownSolutionTestText":"Solution Status Test","deviceInfoBoxesTitleDevicesText":"Devices","deviceInfoBoxesTitleOnlineText":"Online","deviceInfoCardHeader":"Users","deviceInfoLabelGuestsText":"Guests","deviceInfoLabelOwnerText":"Owner","deviceInputSearchBarSNPlaceholder":"Search SN","deviceInputSearchBarModelPlaceholder":"Search Model","deviceInputSearchBarOnlinePlaceholder":"Online","deviceInputSearchBarOfflinePlaceholder":"Offline","deviceLockDialogButtonCloseText":"Close","deviceLockDialogButtonDeleteText":"Delete","deviceLockDialogConfirmText":"Are you sure you want to delete {id} ? Deleting a device will remove all access and will need to be provisioned again. You cannot undo this action.","deviceLockDialogTitle":"Delete Device","deviceTableColConnectivityStatusLabel":"Connectivity Status","deviceTableColFirmwareVerLabel":"Firmware Ver.","deviceTableColLastSeenLabel":"Last Seen","deviceTableColModelLabel":"Model","deviceTableColProvisionedDateLabel":"Provisioned Date","deviceTableColSNLabel":"SN","deviceTableEmptyMessageBody":"If you need help getting started or have any questions, contact our support at {support}","deviceTableEmptyMessageTitle":"No Devices Found","deviceTableLoadingText":"Loading...","deviceTableNeedSearchTips":"If you cannot find the device you are searching for in the list, please utilize the search function above.","deviceTooltipDeleteText":"Delete","exportPeriodError":"The range of start and end time should be between {min} to {max} hours.","errorHandlerFirmwareDeleteDefault":"There was an issue deleting firmware, please try again later.","errorHandlerFirmwareUploadDefault":"There was an issue uploading firmware, please try again later.","errorHandlerGeneralStatusCode403":"Your authentication is out of date. Please log in and try again.","errorHandlerInformationModelDeleteDefault":"There was an issue deleting information model. Please make sure the change won’t affect notification settings and try again.","errorHandlerInformationModelDeleteStatusCode428":"There was an issue deleting information model. Please make sure the change won’t affect notification settings and try again.","errorHandlerInformationModelImagesUploadDefault":"There was an issue uploading information model images, please try again later.","errorHandlerInformationModelUploadDefault":"There was an issue uploading information model, please try again later.","errorHandlerInformationModelUploadStatusCode428":"familyMembers is changed in this information model that will affect notification settings. Please update notification settings related to this information model and upload the file again.","errorHandlerLegalDefault":"Failed to get data, please try again later.","errorHandlerNotificationsDefault":"Failed to get notifications, please try again later.","errorHandlerNotificationsDeleteDefault":"There was an issue completing your request. Please refresh the admin page and try again.","errorHandlerNotificationsEditDefault":"Failed to get notification data, please try again later","errorHandlerSolutionStatusTestDefault":"Failed to trigger online testing, please try again later.","errorHandlerThemeDefault":"Failed to get theme, please try again later.","errorHandlerThemeLegalDefault":"Failed to save legal, please try again later.","errorHandlerThemeViewDefault":"Failed to save theme, please try again later.","errorHandlerTimelineDefault":"Failed to get logs, please try again later.","errorHandlerTimelineModelDefault":"Failed to get logs, please try again later.","errorHandlerUserDefault":"Failed to get users, please try again later.","exportButton":"Export","firmwareButtonAddFirmwareText":"Add Firmware","firmwareDeleteDialogButtonCloseText":"Close","firmwareDeleteDialogButtonDeleteText":"Delete","firmwareDeleteDialogConfirmText":"Are you sure you want to delete {version} ?","firmwareDeleteDialogTitle":"Delete Firmware","firmwareTableColModelLabel":"Model","firmwareTableColTriggerLabel":"Trigger","firmwareTableColPreviousVersionLabel":"Previous Version","firmwareTableColSHA1Label":"SHA1","firmwareTableColSizeLabel":"Size","firmwareTableColVersionLabel":"Version","firmwareTableLoadingText":"Loading...","firmwareTooltipDeleteText":"Delete","firmwareTooltipDownloadText":"Download","firmwareUploadDialogButtonCloseText":"Close","firmwareUploadDialogButtonUploadText":"Upload","firmwareUploadDialogTitle":"Firmware Upload","firmwareUploadInputImageLabel":"Firmware Image","firmwareUploadInputModelError":"The Model field is required.","firmwareUploadInputModelLabel":"Model","firmwareUploadInputTriggerLabel":"Immediate Update","firmwareUploadInputPreviousError":"Must be semver (X.X.X)","firmwareUploadInputPreviousLabel":"Previous Version","firmwareUploadInputPreviousPlaceholder":"Previous Version","firmwareUploadInputSHA1Error":"Must be sha1 (40 hex characters)","firmwareUploadInputSHA1Label":"SHA1","firmwareUploadInputUploadFieldNameLabel":"Upload","firmwareUploadInputVersionError":"Must be semver (X.X.X)","firmwareUploadInputVersionLabel":"New Version","firmwareUploadInputVersionPlaceholder":"Version","firmwareUploadTipImage":"The firmware file is required and the size must be less than 4 MB.","informationModelButtonAddInfomationModelText":"Add Information Model","informationModelButtonEditImagesText":"Edit Images","informationModelButtonUploadImagesText":"Upload Images","informationModelDeleteConfirmText":"Are you sure you want to delete {familyName} ?","informationModelDeleteDialogButtonCloseText":"Close","informationModelDeleteDialogButtonDeleteText":"Delete","informationModelDeleteDialogTitle":"Delete Information Model","informationModelImagesUploadButtonRemoveImageText":"Remove Image","informationModelImagesUploadButtonUploadImageText":"Upload Image","informationModelImagesUploadDialogButtonCloseText":"Close","informationModelImagesUploadDialogButtonSaveText":"Save","informationModelImagesUploadDialogTitle":"Add Model Images","informationModelImagesUploadInputBannerDescription":"Displays in app templates that support banner images. Tip: Images should be at least 750 px wide by 240 px tall (you can change the height to fit your image), in PNG, JPG or GIF format and under 2MB.","informationModelImagesUploadInputBannerError":"Images should be at least 750 px wide by 240 px tall","informationModelImagesUploadInputBannerLabel":"Model Image Banner","informationModelImagesUploadInputThumbnailDescription":"Displays in app templates that support thumbnails images. Tip: Images should be in a square resolution of at least 240 x 240 px, in PNG, JPG or GIF format with a transparent background and under 2MB.","informationModelImagesUploadInputThumbnailError":"Images should be at least 240 x 240 px","informationModelImagesUploadInputThumbnailLabel":"Model Image Thumbnail","informationModelTableColActionLabel":"Action","informationModelTableColFamilyNameLabel":"Family Name","informationModelTableColFileNameLabel":"File Name","informationModelTableColLastModifiedLabel":"Last Modified","informationModelTableColModelImageLabel":"Model Image","informationModelTableLoadingText":"Loading...","informationModelTooltipDeleteText":"Delete","informationModelTooltipDownloadText":"Download","informationModelUploadButtonUploadText":"Upload","informationModelUploadDialogButtonCloseText":"Close","informationModelUploadDialogButtonUploadText":"Upload","informationModelUploadDialogTitle":"Add New Information Models","informationModelUploadErrorMessageInvalidFile":"Invalid JSON or YAML. Please check the format and upload the file again.","informationModelUploadInputUploadError":"Please choose at least one file","informationModelUploadInputUploadLabel":"Upload","informationModelUploadMessageUploadSuccessful":"Information model uploaded.","loginButtonSignInText":"Sign In","loginErrorResponseTitle":"Error","loginFormTitle":"Admin Sign In","loginInputEmailPlaceholder":"Email","loginInputPasswordPlaceholder":"Password","loginLinkForgotPasswordText":"Forgot your password?","loginResetResponseMessage":"Please check your inbox for an email with instructions to finish resetting your account's password.","loginResetResponseTitle":"Password Reset Sent","messageFirmwareDelete":"Firmware deleted.","messageFirmwareUpload":"Firmware uploaded.","messageInformationModelDelete":"Information model deleted.","messageLegalSave":"Legal saved.","messageNotificationCreate":"Notification created.","messageNotificationDelete":"Notification deleted.","messageNotificationUpdate":"Notification updated.","notFoundButtonHomeText":"Home","notFoundButtonSupportText":"Support","notFoundDescription":"Here are some helpful links:","notFoundTitle":"Sorry, the page you're looking for could not be found or doesn't exist.","notificationsButtonAddNotificationText":"Add Notification","notificationsCreateBodyNoQuota":"You reached your plan’s limit for notification rules. If you would like to add a new notification, please contact {support} or delete an existing notification rule first.","notificationsCreateDialogButtonCloseText":"Close","notificationsCreateDialogButtonOKText":"OK","notificationsCreateDialogButtonSaveText":"Save","notificationsCreateInputFamilyNameHint":"The notification will only apply to the selected Family Name(s).","notificationsCreateInputFamilyNameLabel":"Family Name","notificationsCreateInputFamilyNamePlaceholder":"-- Select Family Name --","notificationsCreateInputKeyError":"The key field is required and should has correct format (e.g. H00).","notificationsCreateInputKeyPlaceholder":"H Field","notificationsCreateInputMessageHint1":"Defines the message shown in the notification.","notificationsCreateInputMessageHint2":"Tip: Messages must be 160 characters or less.","notificationsCreateInputMessageLabel":"Notification Message","notificationsCreateInputMessagePlaceholder":"Your notification message","notificationsCreateInputOperatorPlaceholder":"Operator","notificationsCreateInputRuleTypeHint":"Defines the condition for a notification to be sent.","notificationsCreateInputRuleTypeLabel":"Rule Type","notificationsCreateInputRuleTypePlaceholder":"-- Select Rule Type --","notificationsCreateInputTargetPlaceholder":"Value","notificationsCreateInputTitleHint1":"Defines the title shown in the notification.","notificationsCreateInputTitleHint2":"Tip: Titles must be 40 characters or less.","notificationsCreateInputTitleLabel":"Notification Title","notificationsCreateInputTitlePlaceholder":"Your notification title","notificationsCreateRuleTypesOptionStates":"Device Status","notificationsCreateTitleAdd":"Add New Notification Rule","notificationsCreateTitleNoQuota":"Notification rules limit reached","notificationsDeleteDialogButtonCancelText":"Cancel","notificationsDeleteDialogButtonDeleteText":"Delete","notificationsDeleteDialogConfirmText":"Are you sure you want to delete this notification?","notificationsDeleteDialogTitle":"Delete Notification","notificationsEditDialogButtonCloseText":"Close","notificationsEditDialogButtonOKText":"OK","notificationsEditDialogButtonSaveText":"Save","notificationsEditInputFamilyNameHint":"The notification will only apply to the selected Family Name(s).","notificationsEditInputFamilyNameLabel":"Family Name","notificationsEditInputFamilyNamePlaceholder":"-- Select Family Name --","notificationsEditInputKeyError":"The key field is required and should has correct format (e.g. H00).","notificationsEditInputKeyPlaceholder":"H Field","notificationsEditInputMessageHint1":"Defines the message shown in the notification.","notificationsEditInputMessageHint2":"Tip: Messages must be 160 characters or less.","notificationsEditInputMessageLabel":"Notification Message","notificationsEditInputMessagePlaceholder":"Your notification message","notificationsEditInputOperatorPlaceholder":"Operator","notificationsEditInputRecipientsHint":"Defines which user roles receive the notification.","notificationsEditInputRecipientsLabel":"Recipients","notificationsEditInputRecipientsPlaceholder":"-- Select Recipients --","notificationsEditInputRuleTypeHint":"Defines the condition for a notification to be sent.","notificationsEditInputRuleTypeLabel":"Rule Type","notificationsEditInputRuleTypePlaceholder":"-- Select Rule Type --","notificationsEditInputTargetPlaceholder":"Value","notificationsEditInputTitleHint1":"Defines the title shown in the notification.","notificationsEditInputTitleHint2":"Tip: Titles must be 40 characters or less.","notificationsEditInputTitleLabel":"Notification Title","notificationsEditInputTitlePlaceholder":"Your notification title","notificationsEditRuleTypesOptionStates":"Device Status","notificationsEditTitleEdit":"Edit New Notification Rule","notificationsLimitationText":"{ownRules} / {limitRules} Notifications","notificationsTableColInfoModelLabel":"Info. Model","notificationsTableColMessageLabel":"Message","notificationsTableColRecipientsLabel":"Recipients","notificationsTableColRuleLabel":"Rule","notificationsTableColTitleLabel":"Title","notificationsTableEmptyText":"No notification rules found.","notificationsTableLoadingText":"Loading...","notificationsTooltipDeleteText":"Delete","notificationsTooltipEditText":"Edit","resetButtonSignInText":"Reset Password","resetErrorResponseTitle":"Error","resetFormDescription":"Please enter your email address to reset your password.","resetFormTitle":"Reset Password","resetInputEmailPlaceholder":"Email","resetLinkSignInText":"Back to the Admin Sign In","sidebarMenuDevices":"Devices","sidebarMenuExport":"Export","sidebarMenuFirmware":"Firmware List","sidebarMenuInformationModel":"Information Model","sidebarMenuNotifications":"Notifications","sidebarMenuTheme":"Theme","sidebarMenuUsers":"Users","solutionStatusTestDialogButtonCloseText":"Close","solutionStatusTestDialogButtonOKText":"OK","solutionStatusTestDialogDescription":"This test covers phone and device connection to the solution. It may take a while to run the test. If you want to know the progress, please contact","solutionStatusTestDialogSupport":"support","solutionStatusTestDialogTitle":"Solution status test report","solutionStatusTestInputAccountError":"The Admin account field is required.","solutionStatusTestInputAccountLabel":"Admin account","solutionStatusTestInputPasswordError":"The Admin password field is required.","solutionStatusTestInputPasswordLabel":"Admin password","solutionStatusTestInputRecipientLabel":"Recipient","solutionStatusTestInputRecipientsTip":"You can send the report to several people by using comma to separate email addresses.","solutionStatusTestSuccessMessage":"Online Testing running...","themeLegalButtonSaveText":"Save","themeLegalFormLoadingText":"Loading...","themeTabAppAppFileNavbarDescription":"The Navbar Logo is shown in the app at the center of the top banner and in the top of the side navigation. TIP: The file should be lightweight, with alpha transparent background, and at least 200 x 200 pixels. This image may also be on a dark background where a lighter variation will have a better performance.","themeTabAppAppFileNavbarLabel":"Navbar Logo","themeTabAppAppTextNewsDescription":"The content of News is shown in an in-app message and end-user can receive the notice when he opens the mobile app. If you want to withdraw the notice, please clear the content and save the changes.","themeTabAppAppTextNewsLabel":"News","themeTabAppAppTextWifiNameDescription":"The Wi-Fi Pattern Name is shown in the app “Connect to Your Device\" screen as a reference for your end-user experience. It must be shorter than 32 characters.","themeTabAppAppTextWifiNameLabel":"Wi-Fi Pattern Name","themeTabAppText":"App","themeTabEmailEmailBasicTextAppNameDescription":"Your app name to be displayed in email and web pages to direct users to open your app.","themeTabEmailEmailBasicTextAppNameLabel":"App Name","themeTabEmailEmailBasicTextAppNamePlaceholder":"myProduct","themeTabEmailEmailBasicTextAppUrlSchemeDescription":"The URL scheme of your app, which allows users to be redirected to your app from email and web pages. This should match the “ionic-plugin-deeplinks” setup in your app’s “config.xml” and “package.json” files.","themeTabEmailEmailBasicTextAppUrlSchemeLabel":"App Url Scheme","themeTabEmailEmailBasicTextAppUrlSchemePlaceholder":"myproduct://","themeTabEmailEmailBasicTextAppleStoreDescription":"The web address of your app in the Apple App Store, which users will be directed to from email and web pages.","themeTabEmailEmailBasicTextAppleStoreLabel":"Apple Store Url","themeTabEmailEmailBasicTextAppleStorePlaceholder":"https://itunes.apple.com/us/app/exosite-excite/id1090866808","themeTabEmailEmailBasicTextCompanyAddressDescription":"Your company address to be displayed in the footer.","themeTabEmailEmailBasicTextCompanyAddressLabel":"Company Address","themeTabEmailEmailBasicTextCompanyAddressPlaceholder":"275 Market St, Suite 535, Minneapolis, MN 55405","themeTabEmailEmailBasicTextCompanyContactDescription":"Your company contact information to be displayed in the footer.","themeTabEmailEmailBasicTextCompanyContactLabel":"Company Contact","themeTabEmailEmailBasicTextCompanyContactPlaceholder":"1-612-353-2161","themeTabEmailEmailBasicTextCompanyNameDescription":"Your company name to be displayed in the footer.","themeTabEmailEmailBasicTextCompanyNameLabel":"Company Name","themeTabEmailEmailBasicTextCompanyNamePlaceholder":"My Company","themeTabEmailEmailBasicTextCompanyUrlDescription":"The web address, which users will be directed to from the footer.","themeTabEmailEmailBasicTextCompanyUrlLabel":"Company Website Url","themeTabEmailEmailBasicTextCompanyUrlPlaceholder":"#","themeTabEmailEmailBasicTextGooglePlayDescription":"The web address of your app in the Google Play Store, which users will be directed to from email and web pages.","themeTabEmailEmailBasicTextGooglePlayLabel":"Google Play Url","themeTabEmailEmailBasicTextGooglePlayPlaceholder":"https://play.google.com/store/apps/details?id=com.exosite.excite","themeTabEmailEmailBasicTextSupportEmailAccountDescription":"Your support email to be used for app feedback to let user contact your support team.","themeTabEmailEmailBasicTextSupportEmailAccountLabel":"Support Email","themeTabEmailEmailBasicTextSupportEmailAccountPlaceholder":"support@exosite.com","themeTabEmailEmailSenderTextConnectionPasswordLabel":"Connection Password","themeTabEmailEmailSenderTextConnectionPasswordPlaceholder":"Password","themeTabEmailEmailSenderTextConnectionPortLabel":"Connection Port","themeTabEmailEmailSenderTextConnectionPortPlaceholder":"465","themeTabEmailEmailSenderTextConnectionSchemeLabel":"Connection Scheme","themeTabEmailEmailSenderTextConnectionSchemePlaceholder":"smtp or smtps","themeTabEmailEmailSenderTextConnectionServerLabel":"Connection Server","themeTabEmailEmailSenderTextConnectionServerPlaceholder":"smtp.gmail.com","themeTabEmailEmailSenderTextConnectionUserLabel":"Connection User","themeTabEmailEmailSenderTextConnectionUserPlaceholder":"example@email.com","themeTabEmailEmailTemplateTextWelcomeEmailBodyLabel":"Welcome Email Body","themeTabEmailEmailTemplateTextWelcomeEmailBodyPlaceholder":"Thanks for creating a {{product_name}} account. With the {{app_name}} app, you can control your smart AC from anywhere and set schedules to fit your daily routine.","themeTabEmailEmailTemplateTextWelcomeEmailHeadlineLabel":"Welcome Email Headline","themeTabEmailEmailTemplateTextWelcomeEmailHeadlinePlaceholder":"Welcome to {{product_name}}!","themeTabEmailEmailTemplateTextWelcomeEmailSubjectLabel":"Welcome Email Subject","themeTabEmailEmailTemplateTextWelcomeEmailSubjectPlaceholder":"Welcome to {{product_name}}!","themeTabEmailEmailTemplateTextWelcomeWebBodyLabel":"Welcome Web Body","themeTabEmailEmailTemplateTextWelcomeWebBodyPlaceholder":"With the {{app_name}} app, you can control your smart AC from anywhere and set schedules to fit your daily routine. If you haven’t yet, make sure to download the {{app_name}} app on any device you wish to use.","themeTabEmailEmailTemplateTextWelcomeWebHeadlineLabel":"Welcome Web Headline","themeTabEmailEmailTemplateTextWelcomeWebHeadlinePlaceholder":"Welcome to {{product_name}}!","themeTabEmailClaimDevicesTemplateTextClaimDeviceTitleLabel":"Claim Device Page Title","themeTabEmailClaimDevicesTemplateTextClaimDeviceTitlePlaceholder":"Your {{product_name}} is Ready!","themeTabEmailClaimDevicesTemplateTextClaimDeviceBodyLabel":"Claim Device Page Body","themeTabEmailClaimDevicesTemplateTexttClaimDeviceBodyPlaceholder":"{{email}} is inviting you to use their {{product_name}}. If you don’t have an account yet, make sure to download the {{app_name}} app and create your account first.","themeTabEmailText":"Email & Web","themeTabGeneralSettingsFileDescription":"The App Logo is shown to users, where applicable, such as the \"Start\", \"Sign In\", \"Create Account\" screens, and the welcome template for new users. TIP: The file should be lightweight, with alpha transparent background, and 500 x 500 pixels. Remember that .png images provide best performances with text and shapes logos.","themeTabGeneralSettingsFileLabel":"App Logo","themeTabGeneralSettingsTextPrimaryColorDescription":"The Primary Color is used to style the application header bar, primary buttons, device popit UI control items, and several text styles. Currently, only hexadecimal color values are supported.","themeTabGeneralSettingsTextPrimaryColorLabel":"Primary Color","themeTabGeneralSettingsTextPrimaryColorPlaceholder":"#00BAFF","themeTabGeneralSettingsTextProductNameDescription":"The Product Name is used as a reference to your product for the end-user experience. It will be shown to users, where applicable, such as the \"Add Device\" process and the welcome template for new users.","themeTabGeneralSettingsTextProductNameLabel":"Product Name","themeTabGeneralSettingsTextProductNamePlaceholder":"My Product","themeTabGeneralText":"General Settings","themeTabLegalContentBody":"The legal content you provide here will appear at  this location in the end-user interface: {legalUrl}. The terms and conditions and privacy policy template below is only an example; please consult with a legal resource to ensure you develop terms and conditions and privacy policy that are appropriate for your company and your product. The terms and conditions and privacy policy below are applicable only between you and your end-users; Exosite cannot and will not warrant or promise any terms provided, nor will Exosite accept any responsibility or liability for the accuracy, content, completeness, legality, or reliability of the information you provide to your customers on this page. To the extent that the legal content provided on this page conflicts with the {muranoTermsUrl} or the Exosite Service Agreement you signed with us, the Murano Terms and Conditions or Exosite Service Agreement shall supersede all content.","themeTabLegalContentTitle":"EXOSITE DISCLAIMER","themeTabLegalLegalPoliciesTextBodyDescription":"The legal content to be displayed in the legal web page.","themeTabLegalLegalPoliciesTextBodyLabel":"Web Body","themeTabLegalLegalPoliciesTextTitleDescription":"The headline to be displayed in the legal web page.","themeTabLegalLegalPoliciesTextTitleLabel":"Web Headline","themeTabLegalLegalPoliciesTextTitlePlaceholder":"Terms & Conditions and Privacy Policy","themeTabLegalText":"Legal","themeTabLegalToSText":"Murano Terms and Conditions","themeThemeViewBasicSettingsTitle":"Basic Settings","themeThemeViewLegalPoliciesTitle":"Legal Policies","themeThemeViewSenderConfigureTitle":"Email Settings","themeThemeViewWelcomeTemplateTitle":"Welcome Template","themeThemeViewClaimDevicesTemplateTitle":"Claim Device Page Template","themeViewButtonRemoveImageText":"Remove Image","themeViewButtonSaveText":"Save","themeViewButtonUploadImageText":"Upload Image","themeViewFormLoadingText":"Loading...","themeViewThemeSavedSuccessMessage":"Theme saved.","timelineButtonViewAllText":"View All","timelineComponentTitle":"Timeline","timelineFilterLabelAllText":"All","timelineFilterLabelDebugText":"Debugs","timelineFilterLabelErrorText":"Errors","timelineFilterPlaceholder":"Type","timelineLogEmptyMessage":"No logs found.","timelineLogLinkViewInfoText":"View Info ","timelineLogTooltipLocationText":"Location","userDeleteDialogButtonCloseText":"Close","userDeleteDialogButtonDeleteText":"Delete","userDeleteDialogConfirmText":"Are you sure you want to delete {email} ?","userDeleteDialogTitle":"Delete User","userInfoBoxTitleUsersText":"Users","userInfoCardDevicesEmptyText":"No devices found.","userInfoCardDevicesHeaderText":"Devices ({devicesCount})","userInfoCardGroupEmptyText":"No groups found.","userInfoCardGroupsHeaderText":"My Groups ({groupsCount})","userInputSearchBarError":"The search field must be at least 4 characters.","userInputSearchBarPlaceholder":"Search Email","userTableColEmailLabel":"Email","userTableColRegisteredTimeLabel":"Registered Time","userTableEmptyText":"No Users Found","userTableLoadingText":"Loading...","userTooltipDeleteText":"Delete"}

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__theme_index_css__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__theme_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__theme_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_router__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_infinite_scroll__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routes__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__filters__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__api__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vee_validate_dist_locale_zh_TW__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vee_validate_dist_locale_zh_TW___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vee_validate_dist_locale_zh_TW__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vee_validate_dist_locale_en__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vee_validate_dist_locale_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vee_validate_dist_locale_en__);

























__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('hamv-dialog', __WEBPACK_IMPORTED_MODULE_14__components__["a" /* Dialog */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('hamv-info-box', __WEBPACK_IMPORTED_MODULE_14__components__["b" /* InfoBox */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('timeline-log', __WEBPACK_IMPORTED_MODULE_14__components__["c" /* TimelineLog */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('user-info', __WEBPACK_IMPORTED_MODULE_14__components__["d" /* UserInfo */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* default */].Validator.extend('emails', {
  validate: function validate(value) {
    return value.split(',').every(function (x) {
      return __WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* default */].Validator.rules.email.validate(x);
    });
  }
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* default */], {
  dictionary: {
    en: __WEBPACK_IMPORTED_MODULE_18_vee_validate_dist_locale_en___default.a,
    zh: __WEBPACK_IMPORTED_MODULE_17_vee_validate_dist_locale_zh_TW___default.a
  },
  events: 'input|blur',
  fieldsBagName: 'formFields'
});
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16__api__["a" /* plugin */]);

var router = new __WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_9__routes__["a" /* default */],

  linkExactActiveClass: 'active',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('formatDate', __WEBPACK_IMPORTED_MODULE_12__filters__["a" /* formatDate */]);

var clearAuth = function clearAuth() {
  window.console.log('Not authenticated');
  __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('SET_TOKEN', null);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__api__["b" /* updateAuthHeader */])(__WEBPACK_IMPORTED_MODULE_3_vue__["default"], null);
  __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('SET_USER', '');
  router.app.$cookie.delete('sid');

  window.localStorage.removeItem('uid');
  window.localStorage.removeItem('user');
  window.localStorage.removeItem('token');
};

router.beforeEach(function (to, from, next) {
  var storeToken = router.app.$store.state.token;
  storeToken = null;
  if (router.app.$cookie.get('sid')) {
    storeToken = router.app.$cookie.get('sid');
  }

  var localStorageToken = window.localStorage.getItem('token');
  var noLoginPaths = __WEBPACK_IMPORTED_MODULE_15__config__["a" /* default */].noLoginPaths;

  if (noLoginPaths.indexOf(to.path) === -1 && (!storeToken || !localStorageToken)) {
    clearAuth();
    next();
  } else if ((to.path === '/login/' || to.path === '/login') && storeToken) {
    next({ path: '/device' });
  } else {
    next();
  }
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.interceptors.push(function (request) {
  if (request.method === 'GET' && document.documentMode) {
    request.headers.set('Cache-Control', 'no-cache');
    request.headers.set('Pragma', 'no-cache');
  }

  return function (response) {
    if (response.status === 403) {
      __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* helper */].showErrorMessage(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a, 'general', response);

      clearAuth();
      router.push('/login');
    }
  };
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */], router);

new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
  el: '#root',
  i18n: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* i18n */],
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_14__components__["e" /* App */]);
  }
});

if (window.localStorage) {
  var localUserToken = window.localStorage.getItem('token') || null;
  var username = window.localStorage.getItem('user') || null;

  if (localUserToken && __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.token !== localUserToken) {
    __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('SET_TOKEN', window.localStorage.getItem('token'));
  }

  if (username) __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('SET_USER', username);
}

window.onbeforeunload = function () {
  var sid = router.app.$cookie.get('sid');
  if (sid) {
    router.app.$cookie.set('sid', sid, { expires: '30D' });
  }
};

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports = {"properties":{"components":{"description":"Component repository","title":"Component Repository","patternProperties":{".*":{"properties":{"hideFromGroup":{"description":"Set true if you want to hide this component from the group control. If you set the value as false, the result would be the same as without this property.","title":"HideFromGroup","type":"boolean"},"models":{"description":"Models for Control Items","items":{"properties":{"default":{"description":"default setting of a control item","title":"Default","type":"number"},"dependency":{"description":"rules to describe the interdependent relationship between different keys","items":{"properties":{"conditions":{"$ref":"#/definitions/conditions"}},"required":["conditions"],"type":"object"},"title":"Dependency Rules","type":"array"},"disable":{"items":{"properties":{"conditions":{"$ref":"#/definitions/conditions"}},"required":["conditions"],"type":"object"},"type":"array"},"key":{"$ref":"#/definitions/esh","description":"The field the control item interacts with.","title":"Key"},"values":{"$ref":"#/definitions/values"}},"required":["key"],"type":"object"},"title":"Models","type":"array"},"title":{"description":"Title to be displayed","title":"Title","type":"string"},"type":{"description":"UI component types","pattern":"^(?!\\s*$).+","title":"Type","type":"string"}},"required":["models","type"],"type":"object"}},"type":"object"},"controlLayout":{"$ref":"#/definitions/layout","title":"Control Layout"},"deviceId":{"description":"Device ID","title":"Device ID","type":["number","string"]},"errorFields":{"description":"List of fields that carry error information","items":{"properties":{"key":{"$ref":"#/definitions/esh"},"values":{"$ref":"#/definitions/values"}},"type":"object"},"title":"Error Fields","type":"array"},"eventCollections":{"items":{"properties":{"conditions":{"$ref":"#/definitions/conditions"},"name":{"type":"string"},"type":{"enum":["triggerEvent"]}},"required":["conditions","name","type"],"type":"object"},"type":"array"},"familyMembers":{"description":"Definition: Supported devices under this family.","items":{"type":"string"},"title":"Family Members","type":"array"},"familyName":{"description":"Name of individual config files","title":"Family Name","type":"string"},"hiddenFields":{"description":"List of hidden control items","items":{"type":"string"},"title":"Hidden Fields","type":"array"},"integration":{"properties":{"traits":{"anyOf":[{"items":{"$ref":"#/definitions/trait"},"maxItems":1,"title":"Traits","type":"array"},{"items":{"$ref":"#/definitions/traits"},"title":"Traits","type":"array"}]}},"required":["traits"],"title":"Integration schema","type":"object"},"images":{"patternProperties":{".*":{"properties":{"uri":{"description":"images location U.R.I","type":"string"}},"type":"object","required":["uri"]}},"type":"object"},"scheduleLayout":{"$ref":"#/definitions/layout","description":"Layout of the Control Items in the Schedule page.","title":"Schedule Layout"},"chartLayout":{"$ref":"#/definitions/chartLayout","title":"Chart Layout"},"chartComponents":{"description":"Chart component repository","title":"Chart component Repository","patternProperties":{".*":{"properties":{"hideFromGroup":{"description":"Set true if you want to hide this component from the group control. If you set the value as false, the result would be the same as without this property.","title":"HideFromGroup","type":"boolean"},"models":{"description":"Models for Control Items","items":{"properties":{"default":{"description":"default setting of a control item","title":"Default","type":"number"},"dependency":{"description":"rules to describe the interdependent relationship between different keys","items":{"properties":{"conditions":{"$ref":"#/definitions/conditions"}},"required":["conditions"],"type":"object"},"title":"Dependency Rules","type":"array"},"disable":{"items":{"properties":{"conditions":{"$ref":"#/definitions/conditions"}},"required":["conditions"],"type":"object"},"type":"array"},"key":{"$ref":"#/definitions/esh","description":"The field the control item interacts with.","title":"Key"},"values":{"$ref":"#/definitions/values"}},"required":["key"],"type":"object"},"title":"Models","type":"array"},"title":{"description":"Title to be displayed","title":"Title","type":"string"},"type":{"description":"UI component types","pattern":"line-chart|bar-chart","title":"Type","type":"string"},"options":{"description":"Chart library options/configs","title":"Options","type":"object"}},"required":["models","type"],"type":"object"}},"type":"object"}},"required":["components","controlLayout","deviceId","familyMembers","familyName","scheduleLayout"],"type":"object","definitions":{"before-key-max-min":{"properties":{"before":{"items":{"properties":{"key":{"$ref":"#/definitions/esh"},"value":{"type":"number"}}},"type":"array"},"key":{"$ref":"#/definitions/esh"},"max":{"$ref":"#/definitions/number-0-100"},"min":{"$ref":"#/definitions/number-0-100"}},"type":"object"},"conditions":{"items":{"properties":{"key":{"$ref":"#/definitions/esh"},"op":{"enum":["eq","neq","lt","lte","gt","gte"]},"target":{"type":"number"}},"required":["key","op","target"],"type":"object"},"type":"array"},"esh":{"pattern":"H[0-9A-F]+|\\*","type":"string"},"layout":{"description":"Layout of the Control Items in the Device UI.","properties":{"primary":{"items":{"type":"string"},"type":"array"},"secondary":{"items":{"type":"string"},"type":"array"}},"required":["primary"],"type":"object"},"chartLayout":{"description":"Layout of the Control Items in the Device UI.","properties":{"main":{"items":{"type":"string"},"type":"array"}},"required":["main"],"type":"object"},"number-0-100":{"maximum":100,"minimum":0,"type":"number"},"number-1000-10000":{"maximum":10000,"minimum":1000,"type":"number"},"temperature":{"properties":{"key":{"$ref":"#/definitions/esh"},"unit":{"enum":["celsius","fahrenheit"]}},"type":"object"},"fan_speed":{"properties":{"key":{"$ref":"#/definitions/esh"},"values":{"type":"array","minItems":1,"items":{"type":"object","properties":{"speed_name":{"type":"string"},"value":{"type":"integer"},"speed_values":{"type":"array","minItems":1,"items":{"type":"object","properties":{"speed_synonym":{"type":"array","minItems":1,"items":{"type":"string"}},"lang":{"type":"string"}},"required":["speed_synonym","lang"]}}},"required":["speed_name","value","speed_values"]}},"reversible":{"type":"object","properties":{"key":{"$ref":"#/definitions/esh"},"values":{"type":"object","properties":{"normal":{"type":"integer"},"reverse":{"type":"integer"}},"required":["normal","reverse"]}},"required":["key","values"]}},"type":"object"},"appliedDomain":{"type":"array","items":{"type":"string","enum":["alexa","googlehome","ifttt","smartthings"]}},"trait":{"properties":{"id":{"type":"string"},"type":{"$ref":"#/definitions/trait-type"},"append_name":{"type":"string"},"appliedDomain":{"$ref":"#/definitions/appliedDomain"},"description":{"type":"string"},"attributes":{"$ref":"#/definitions/trait-attributes"}},"required":["id","type","attributes"],"type":"object"},"traits":{"properties":{"id":{"type":"string"},"type":{"$ref":"#/definitions/trait-type"},"append_name":{"type":"string"},"appliedDomain":{"$ref":"#/definitions/appliedDomain"},"description":{"type":"string"},"attributes":{"$ref":"#/definitions/trait-attributes"}},"required":["id","type","append_name","attributes"],"type":"object"},"trait-attributes":{"properties":{"ac_mode":{"properties":{"key":{"$ref":"#/definitions/esh"},"values":{"properties":{"auto":{"type":"number"},"cool":{"type":"number"},"eco":{"type":"number"},"heat":{"type":"number"},"off":{"type":"number"}},"type":"object"}},"type":"object"},"on_off":{"properties":{"key":{"$ref":"#/definitions/esh"},"values":{"properties":{"off":{"type":"number"},"on":{"type":"number"}},"type":"object"}},"type":"object"},"percentage":{"$ref":"#/definitions/before-key-max-min"},"temperature":{"$ref":"#/definitions/temperature"},"target_temperature":{"$ref":"#/definitions/temperature"},"low_target_temperature":{"$ref":"#/definitions/temperature"},"high_target_temperature":{"$ref":"#/definitions/temperature"},"fan_speed":{"$ref":"#/definitions/fan_speed"},"humidity":{"properties":{"key":{"$ref":"#/definitions/esh"}},"type":"object"},"color":{"properties":{"key":{"$ref":"#/definitions/esh"},"unit":{"enum":["rgb"]}}},"color_temperature":{"properties":{"key":{"$ref":"#/definitions/esh"},"unit":{"enum":["kelvin"]},"max":{"$ref":"#/definitions/number-1000-10000"},"min":{"$ref":"#/definitions/number-1000-10000"}}},"brightness":{"$ref":"#/definitions/before-key-max-min"}},"type":"object"},"trait-type":{"enum":["light","switch","smartplug","thermostat","smartlock","fan","ac","airpurifier","dehumidifier"]},"values":{"anyOf":[{"type":"array"},{"required":["max","min","step"],"type":"object"},{"required":["func"],"type":"object"},{"required":["rules"],"type":"object"}],"items":{"properties":{"text":{"type":"string"},"value":{"oneOf":[{"enum":["*"]},{"type":"number"}]}},"required":["value"],"type":"object"},"properties":{"max":{"type":"number"},"min":{"type":"number"},"step":{"type":"number"},"func":{"type":"string"},"rules":{"items":{"properties":{"conditions":{"$ref":"#/definitions/conditions"}},"required":["conditions"],"type":"object"},"type":"array"}},"title":"Values"}}}

/***/ }),
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */
/***/ (function(module, exports) {

module.exports = {"$schema":"http://json-schema.org/draft-06/schema#","$id":"https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/$data.json#","description":"Meta-schema for $data reference (JSON-schema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports = {"$schema":"http://json-schema.org/draft-06/schema#","$id":"http://json-schema.org/draft-06/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"title":{"type":"string"},"description":{"type":"string"},"default":{},"examples":{"type":"array","items":{}},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":{}},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":{},"enum":{"type":"array","minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":{}}

/***/ }),
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugin__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources__ = __webpack_require__(198);
/* unused harmony reexport admin */
/* unused harmony reexport createResource */
/* unused harmony reexport device */
/* unused harmony reexport devices */
/* unused harmony reexport exports */
/* unused harmony reexport firmwareDelete */
/* unused harmony reexport firmwareList */
/* unused harmony reexport firmwareUpload */
/* unused harmony reexport geolocation */
/* unused harmony reexport image */
/* unused harmony reexport infoModel */
/* unused harmony reexport legal */
/* unused harmony reexport notifications */
/* unused harmony reexport onlineTesting */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__plugin__["a"]; });
/* unused harmony reexport reset */
/* unused harmony reexport serviceConfig */
/* unused harmony reexport session */
/* unused harmony reexport theme */
/* unused harmony reexport tsdb */
/* unused harmony reexport total */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__helper__["a"]; });
/* unused harmony reexport user */
/* unused harmony reexport users */








/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return plugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resources__ = __webpack_require__(198);







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

var plugin = {};
plugin.install = function (Vue, options) {
  if (localStorage.token) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper__["a" /* updateAuthHeader */])(Vue, localStorage.token);
  }

  Vue.prototype.$api = {
    addFirmware: function addFirmware(data) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["a" /* firmwareUpload */].save({}, data);
    },
    addNotification: function addNotification(data) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["b" /* notifications */].save({}, data);
    },
    exportData: function exportData(data) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["c" /* exports */].save(data);
    },
    checkToken: function checkToken() {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["d" /* admin */].get();
    },
    getGeoip: function getGeoip(ip) {
      if (!ip || ip === 'none') {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({
          country_name: '--',
          region_name: '--'
        });
      }

      var fields = 'country,city';
      return __WEBPACK_IMPORTED_MODULE_4__resources__["e" /* geolocation */].get({ ip: ip, fields: fields }).then(function (_ref) {
        var _ref$body = _ref.body,
            country = _ref$body.country,
            city = _ref$body.city;
        return {
          country_name: country || '--',
          region_name: city || '--'
        };
      }).catch(function () {
        return {
          country_name: '--',
          region_name: '--'
        };
      });
    },
    getDevices: function getDevices(query) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["f" /* devices */].get(query);
    },
    getInfoModels: function getInfoModels() {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["g" /* infoModel */].get();
    },
    getLegal: function getLegal() {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["h" /* legal */].get();
    },
    getLogs: function getLogs(query) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["i" /* tsdb */].get(query);
    },
    getFirmwareList: function getFirmwareList() {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["j" /* firmwareList */].get();
    },
    getNotification: function getNotification(id) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["b" /* notifications */].get({ id: id }).then(function (_ref2) {
        var data = _ref2.data;
        return data;
      });
    },
    getNotificationsList: function getNotificationsList() {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["b" /* notifications */].get().then(function (_ref3) {
        var data = _ref3.data;
        return data;
      });
    },
    getServiceConfig: function getServiceConfig(service) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["k" /* serviceConfig */].get(service);
    },
    getTheme: function getTheme() {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["l" /* theme */].get();
    },
    getTotal: function getTotal(query) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["m" /* total */].get(query);
    },
    getUsers: function getUsers(query) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["n" /* users */].get(query);
    },
    getUser: function getUser(id) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["o" /* user */].get(id);
    },
    login: function login(params) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["p" /* session */].save({}, params).then(function (res) {
        var token = res.data.token;
        var id = res.data.id;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helper__["a" /* updateAuthHeader */])(Vue, token);
        return { id: id, token: token };
      });
    },
    lockDevice: function lockDevice(id) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["q" /* device */].delete({ id: id }, { headers: { 'content-type': 'application/json' } });
    },
    removeFirmware: function removeFirmware(data) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["r" /* firmwareDelete */].save({}, data);
    },
    removeInfoModelImages: function removeInfoModelImages(data) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["s" /* image */].delete({}, data);
    },
    removeInfoModel: function removeInfoModel(data) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["g" /* infoModel */].delete({}, data);
    },
    removeNotification: function removeNotification(id) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["b" /* notifications */].delete({ id: id }, { headers: { 'content-type': 'application/json' } });
    },
    removeUser: function removeUser(id) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["o" /* user */].delete({ id: id }, { headers: { 'content-type': 'application/json' } });
    },
    resetPassword: function resetPassword(email) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["t" /* reset */].save({}, { email: email });
    },
    activeUser: function activeUser(code) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["n" /* users */].save({}, { code: code });
    },
    triggerOnlineTesting: function triggerOnlineTesting(data) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["u" /* onlineTesting */].save({}, data);
    },
    updateInfoModelImages: function updateInfoModelImages(data) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["s" /* image */].save({}, data);
    },
    updateInfoModel: function updateInfoModel(data) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["g" /* infoModel */].update(data);
    },
    updateLegal: function updateLegal(data) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["h" /* legal */].update(data);
    },
    updateNotification: function updateNotification(data) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["b" /* notifications */].update(data);
    },
    updatePassword: function updatePassword(code, password) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["t" /* reset */].update({
        new_password: password,
        reset_token: code
      });
    },
    updateServiceConfig: function updateServiceConfig(service, data) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["k" /* serviceConfig */].save({ service: service }, data);
    },
    updateTheme: function updateTheme(form) {
      return __WEBPACK_IMPORTED_MODULE_4__resources__["l" /* theme */].save(form);
    }
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (plugin);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Company',
  props: ['address', 'contact', 'name', 'primaryColor', 'url']
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logo_Logo_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logo_Logo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Logo_Logo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Company_Company_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Company_Company_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Company_Company_vue__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Confirmation',
  components: { Company: __WEBPACK_IMPORTED_MODULE_2__Company_Company_vue___default.a, Logo: __WEBPACK_IMPORTED_MODULE_1__Logo_Logo_vue___default.a },
  computed: {
    isMobile: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* helper */].isMobile
  },
  data: function data() {
    return {
      appleStore: '',
      component: 'confirmation',
      footer: {},
      googlePlay: '',
      primaryColor: '#00BAFF',
      title: '',
      url: '',
      welcomeBody: ''
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      return this.getTheme().then(function (theme) {
        _this.footer = {
          companyAddress: theme.company_address,
          companyContact: theme.company_contact,
          companyName: theme.company_name,
          companyUrl: theme.company_url
        };
        _this.primaryColor = theme.primary_color;
        _this.googlePlay = theme.google_play;
        _this.appleStore = theme.apple_store;
        _this.url = theme.app_url_scheme + location.host;
        _this.title = _this.getReplacedString('welcome_web_headline', theme);
        _this.welcomeBody = _this.getReplacedString('welcome_web_body', theme);
      }).then(function () {
        return _this.activeUser(_this.$route.params.token);
      }).catch(function (error) {
        _this.$router.push('/404');
        __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* helper */].showErrorMessage(_this, _this.component, error);
      });
    },
    getTheme: function getTheme() {
      return this.$api.getTheme().then(function (_ref) {
        var body = _ref.body;
        return body;
      });
    },
    getReplacedString: function getReplacedString(key, theme) {
      return (theme[key] || '').replace(/{{product_name}}/g, theme.product_name).replace(/{{app_name}}/g, theme.app_name);
    },
    activeUser: function activeUser(token) {
      return this.$api.activeUser(token).then(function (_ref2) {
        var body = _ref2.body;
        return body;
      });
    }
  },
  mounted: function mounted() {
    this.getData();
  }
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Logo_Logo_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Logo_Logo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Logo_Logo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Company_Company_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Company_Company_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Company_Company_vue__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Legal',
  components: { Company: __WEBPACK_IMPORTED_MODULE_5__Company_Company_vue___default.a, Logo: __WEBPACK_IMPORTED_MODULE_4__Logo_Logo_vue___default.a },
  computed: {
    isUpdated: function isUpdated() {
      return this.legal.lastUpdate + '' !== '0';
    }
  },
  data: function data() {
    return {
      component: 'legal',
      footer: {},
      legal: {},
      primaryColor: '#00BAFF'
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.getTheme(), this.getLegal()]).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            theme = _ref2[0],
            legal = _ref2[1];

        _this.footer = {
          companyAddress: theme.company_address,
          companyContact: theme.company_contact,
          companyName: theme.company_name,
          companyUrl: theme.company_url
        };
        _this.primaryColor = theme.primary_color;

        _this.legal = {
          content: legal.content,
          lastUpdate: legal.last_update,
          title: legal.title
        };
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* helper */].showErrorMessage(_this, _this.component, error);
      });
    },
    getLegal: function getLegal() {
      var _this2 = this;

      return this.$api.getLegal().then(function (_ref3) {
        var values = _ref3.body;
        return {
          content: values.body,
          last_update: _this2.setLastUpdated(values.last_update),
          title: values.title
        };
      });
    },
    getTheme: function getTheme() {
      return this.$api.getTheme().then(function (_ref4) {
        var body = _ref4.body;
        return body;
      });
    },
    setLastUpdated: function setLastUpdated(ts) {
      return ts ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(ts).format('MMMM, D, YYYY') : 0;
    }
  },
  mounted: function mounted() {
    this.getData();
  }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Logo',
  data: function data() {
    return {
      imgUrl: '/theme/logo.png'
    };
  },

  methods: {
    useDefaultImage: function useDefaultImage() {
      this.imgUrl = '/src/assets/img/logo.png';
    }
  },
  props: ['primaryColor', 'title']
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logo_Logo_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logo_Logo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Logo_Logo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Company_Company_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Company_Company_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Company_Company_vue__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Reset',
  components: { Company: __WEBPACK_IMPORTED_MODULE_2__Company_Company_vue___default.a, Logo: __WEBPACK_IMPORTED_MODULE_1__Logo_Logo_vue___default.a },
  data: function data() {
    return {
      component: 'reset',
      footer: {},
      primaryColor: '#00BAFF',
      pw_new1: '',
      pw_new2: '',
      reset_error1: false,
      reset_error2: false,
      reset_error3: false,
      state: 'reset',
      title: 'Set New Password'
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      return this.getTheme().then(function (theme) {
        _this.footer = {
          companyAddress: theme.company_address,
          companyContact: theme.company_contact,
          companyName: theme.company_name,
          companyUrl: theme.company_url
        };
        _this.primaryColor = theme.primary_color;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* helper */].showErrorMessage(_this, _this.component, error);
      });
    },
    getTheme: function getTheme() {
      return this.$api.getTheme().then(function (_ref) {
        var body = _ref.body;
        return body;
      });
    },
    submit: function submit() {
      var _this2 = this;

      this.reset_error1 = false;
      this.reset_error2 = false;
      this.reset_error3 = false;

      if (this.pw_new1.length < 8 || this.pw_new1.length > 20) {
        this.reset_error1 = true;
        return false;
      }
      if (this.pw_new1 !== this.pw_new2) {
        this.reset_error2 = true;
        return false;
      }

      this.$api.updatePassword(this.$route.params.code, this.pw_new1).then(function (data) {
        _this2.state = 'done';
        _this2.title = 'Password Changed';
      }).catch(function (error) {
        if (error.status === 400) {
          _this2.state = 'expired';
          _this2.title = 'This password reset link is no longer available';
        } else {
          _this2.reset_error3 = true;
        }
      });
    }
  },
  mounted: function mounted() {
    this.getData();
  }
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logo_Logo_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logo_Logo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Logo_Logo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Company_Company_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Company_Company_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Company_Company_vue__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Welcome',
  components: { Company: __WEBPACK_IMPORTED_MODULE_2__Company_Company_vue___default.a, Logo: __WEBPACK_IMPORTED_MODULE_1__Logo_Logo_vue___default.a },
  computed: {
    isMobile: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* helper */].isMobile
  },
  data: function data() {
    return {
      appleStore: '',
      component: 'welcome',
      footer: {},
      googlePlay: '',
      primaryColor: '#00BAFF',
      title: '',
      url: '',
      welcomeBody: ''
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      return this.getTheme().then(function (theme) {
        _this.footer = {
          companyAddress: theme.company_address,
          companyContact: theme.company_contact,
          companyName: theme.company_name,
          companyUrl: theme.company_url
        };
        _this.primaryColor = theme.primary_color;
        _this.googlePlay = theme.google_play;
        _this.appleStore = theme.apple_store;
        _this.url = theme.app_url_scheme + location.host;
        _this.title = _this.getReplacedString('welcome_web_headline', theme);
        _this.welcomeBody = _this.getReplacedString('welcome_web_body', theme);
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* helper */].showErrorMessage(_this, _this.component, error);
      });
    },
    getTheme: function getTheme() {
      return this.$api.getTheme().then(function (_ref) {
        var body = _ref.body;
        return body;
      });
    },
    getReplacedString: function getReplacedString(key, theme) {
      return (theme[key] || '').replace(/{{product_name}}/g, theme.product_name).replace(/{{app_name}}/g, theme.app_name);
    }
  },
  mounted: function mounted() {
    this.getData();
  }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Company_Company_vue__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Company_Company_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Company_Company_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Confirmation_Confirmation_vue__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Confirmation_Confirmation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Confirmation_Confirmation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Legal_Legal_vue__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Legal_Legal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Legal_Legal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Logo_Logo_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Logo_Logo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Logo_Logo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Reset_Reset_vue__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Reset_Reset_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Reset_Reset_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Welcome_Welcome_vue__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Welcome_Welcome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Welcome_Welcome_vue__);
/* unused harmony reexport Company */
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__Confirmation_Confirmation_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Legal_Legal_vue___default.a; });
/* unused harmony reexport Logo */
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__Reset_Reset_vue___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__Welcome_Welcome_vue___default.a; });









/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App'
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar_Sidebar_vue__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar_Sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Sidebar_Sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SolutionStatusTest_SolutionStatusTest_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SolutionStatusTest_SolutionStatusTest_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SolutionStatusTest_SolutionStatusTest_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n__ = __webpack_require__(57);










var ROOT_PATH = '/';

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Sidebar: __WEBPACK_IMPORTED_MODULE_4__Sidebar_Sidebar_vue___default.a, SolutionStatusTest: __WEBPACK_IMPORTED_MODULE_5__SolutionStatusTest_SolutionStatusTest_vue___default.a },
  computed: {
    currentLang: function currentLang() {
      return this.languages[__WEBPACK_IMPORTED_MODULE_7__i18n__["a" /* i18n */].locale];
    },
    currentVersion: function currentVersion() {
      return this.$t('dashFooterVersionText', [this.footer.version]);
    },
    hasVersion: function hasVersion() {
      var version = this.footer.version;
      return !!version;
    },
    isAnalyticsEnabled: function isAnalyticsEnabled() {
      return this.analytics.enabled;
    },
    username: function username() {
      return this.$store.state.user;
    }
  },
  methods: {
    checkValidToken: function checkValidToken() {
      var _this = this;

      return this.$api.checkToken().catch(function (error) {
        _this.cleanData();
        if (error.status === 403) {
          _this.$router.push('/login');
        } else {
          _this.$router.push('/404');
        }
      });
    },
    cleanData: function cleanData() {
      return __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* helper */].clearLoginData(this);
    },
    getSolutionConfig: function getSolutionConfig() {
      var _this2 = this;

      return this.$api.getTheme().then(function (_ref) {
        var body = _ref.body;

        _this2.analytics.enabled = body.analytics_enabled;
        _this2.footer.version = body.solution_version.replace(/-[\da-f]{7}$/, '');
        _this2.$store.commit('SET_DATA_RETENTION', body.data_retention || '31d');
      });
    },
    goToCompanyUrl: function goToCompanyUrl() {
      var _this3 = this;

      var validPaths = this.getValidPaths();
      return this.$api.getTheme().then(function (_ref2) {
        var body = _ref2.body;

        var companyUrl = body && body.company_url;
        if (companyUrl && !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(companyUrl) && _this3.$route.path === ROOT_PATH) {
          window.location.assign(companyUrl);
        } else if (_this3.$route.path !== ROOT_PATH && _this3.isValidPath(validPaths)) {
          _this3.checkValidToken();
        } else {
          _this3.$router.push('/404');
        }
      }).catch(function (e) {
        _this3.$router.push('/404');
      });
    },
    handleCommand: function handleCommand(command) {
      switch (command) {
        case 'signOut':
          return this.onSignOut();
        case 'solutionStatusTest':
          return this.onSolutionStatusTest();
        default:
          throw new Error('command is required.');
      }
    },
    isValidPath: function isValidPath(validPaths) {
      var _this4 = this;

      var arr = [];
      arr = validPaths.map(function (path) {
        var regex = new RegExp('/' + path + '(?:/(?=$))?');
        return regex.test(_this4.$route.path);
      });
      return arr.some(function (key) {
        return key;
      });
    },
    getValidPaths: function getValidPaths() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_6__routes__["a" /* default */];

      var validPaths = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var route = _step.value;

          var children = route.children;
          var path = route.path;

          if (path === '*') {
            continue;
          }

          if (children) {
            validPaths = validPaths.concat(this.getValidPaths(children));
          } else if (path !== '/') {
            validPaths.push(path);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return validPaths;
    },
    onSignOut: function onSignOut() {
      this.cleanData();
      this.$router.push('/login');
    },
    onSolutionStatusTest: function onSolutionStatusTest() {
      __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* bus */].$emit('show-solution-status-test', {
        show: true
      });
    }
  },
  name: 'Dash',
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n__["b" /* loadLanguageAsync */])();
    var token = this.$cookie.get('sid');
    if (!token) {
      this.loading = true;
      return this.goToCompanyUrl();
    }

    this.getSolutionConfig();
    this.loading = false;

    var validPaths = this.getValidPaths();
    if (this.isValidPath(validPaths)) {
      this.$router.push(this.$route.path);
    } else {
      this.$router.push('/device');
    }
  },
  data: function data() {
    return {
      analytics: {
        enabled: false,
        href: '/analytics',
        target: '_blank',
        text: 'Analytics'
      },
      dropdown: {
        lang: {
          class: 'lang-dropdown',
          command: __WEBPACK_IMPORTED_MODULE_7__i18n__["b" /* loadLanguageAsync */],
          items: [{
            command: 'en',
            'data-qa': 'Header-LangDropdown-Item-EN',
            id: 'lang-en',
            text: 'English'
          }, {
            command: 'zh',
            'data-qa': 'Header-LangDropdown-Item-zh',
            id: 'lang-zh',
            text: '中文'
          }],
          trigger: 'click'
        }
      },
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].fixedLayout,
        hide_logo: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].hideLogoOnMobile
      },
      footer: {
        copyRight: {
          text: 'dashFooterCopyRightText'
        },
        documentation: {
          href: 'https://exohome-docs.exosite.io/',
          target: '_blank',
          text: 'dashFooterDocumentationText'
        },
        exosite: {
          href: 'https://www.exosite.com',
          target: '_blank',
          text: 'Exosite'
        },
        privacy: {
          href: 'https://www.exosite.com/data-privacy-policy',
          text: 'dashFooterPrivacyText'
        },
        support: {
          href: 'https://support.exosite.com/hc/en-us/requests/new',
          text: 'dashFooterSupportText'
        },
        terms: {
          href: 'https://www.exosite.com/terms-conditions',
          text: 'dashFooterTermsText'
        },
        version: null
      },
      isCollapse: false,
      languages: {
        en: 'English',
        zh: '中文'
      },
      loading: true
    };
  }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DeviceInfo_DeviceInfo_vue__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DeviceInfo_DeviceInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DeviceInfo_DeviceInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DeviceInfoBoxes_DeviceInfoBoxes_vue__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DeviceInfoBoxes_DeviceInfoBoxes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__DeviceInfoBoxes_DeviceInfoBoxes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DeviceLock_DeviceLock_vue__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DeviceLock_DeviceLock_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__DeviceLock_DeviceLock_vue__);











/* harmony default export */ __webpack_exports__["a"] = ({
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* bus */].$off('update-locked-device-list');
  },

  components: { DeviceInfo: __WEBPACK_IMPORTED_MODULE_7__DeviceInfo_DeviceInfo_vue___default.a, DeviceInfoBoxes: __WEBPACK_IMPORTED_MODULE_8__DeviceInfoBoxes_DeviceInfoBoxes_vue___default.a, DeviceLock: __WEBPACK_IMPORTED_MODULE_9__DeviceLock_DeviceLock_vue___default.a },
  computed: {
    componentTitle: function componentTitle() {
      return this.$t('ComponentTitle.' + this.$route.name);
    },
    showPagination: function showPagination() {
      return !!this.deviceList.length;
    },
    searchBarPlaceholder: function searchBarPlaceholder() {
      var _this = this;

      if (this.selectedFilter === 'sn') {
        return this.$t('deviceInputSearchBarSNPlaceholder');
      } else if (this.selectedFilter === 'model') {
        return this.$t('deviceInputSearchBarModelPlaceholder');
      } else if (this.selectedFilter === 'online') {
        return this.$t('deviceInputSearchBarOnlinePlaceholder');
      } else if (this.selectedFilter === 'offline') {
        return this.$t('deviceInputSearchBarOfflinePlaceholder');
      } else {
        var selected = this.filterOptions.find(function (o) {
          return o.value === _this.selectedFilter;
        });
        return selected ? selected.label : '';
      }
    },
    isSearchBarDisabled: function isSearchBarDisabled() {
      return this.searchBarDisabled;
    }
  },
  methods: {
    confirmLock: function confirmLock(id, sn) {
      __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* bus */].$emit('show-lock-device', {
        show: true,
        info: { id: id, sn: sn }
      });
    },
    convertSecTime: function convertSecTime(s) {
      var ms = s * 1000;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__filters__["a" /* formatDate */])(ms);
    },
    convertUsTime: function convertUsTime(us) {
      var ms = us / 1000;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__filters__["a" /* formatDate */])(ms);
    },
    deviceSearch: function deviceSearch(query) {
      this.deviceList = [];
      this.expanded = [];
      this.pagination.offset = 0;
      this.pagination.currentPage = 1;

      return this.getDevices(query);
    },
    onSelectionChanged: function onSelectionChanged(selectedValue) {
      var query = this.searchQuery;

      if (this.selectedFilter === 'online' || this.selectedFilter === 'offline') {
        query = this.selectedFilter === 'online' ? '1' : '0';

        this.deviceSearch(query);

        this.searchQuery = '';
        this.searchBarDisabled = true;
      } else {
        if (query && selectedValue === this.prevSelectedFilter) {
          this.deviceSearch(query);
        }

        this.searchBarDisabled = false;
      }

      this.prevSelectedFilter = selectedValue;
    },
    getConnectedStatus: function getConnectedStatus(connected) {
      return connected ? this.$t('Online') : this.$t('Offline');
    },
    getConnectedStatusIcon: function getConnectedStatusIcon(connected) {
      return connected ? 'fa fa-circle device-online-icon' : 'fa fa-circle device-offline-icon';
    },
    getCurrentPageDevice: function getCurrentPageDevice(pageNumber) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.pagination.offset = _this2.pagination.limit * (pageNumber - 1);
                _context.next = 3;
                return _this2.getDevices(_this2.searchQuery + _this2.prevOrder);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getDevices: function getDevices() {
      var _this3 = this;

      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var queryParams, queryExtract, devices, mayLoadMore, res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.isLoading = true;

                queryParams = {
                  limit: 500,
                  offset: _this3.pagination.offset
                };

                if (typeof query === 'string') {
                  queryExtract = query.split('__%ORDER%__');

                  if (queryExtract.length > 1) {
                    queryParams.order = queryExtract[1] + queryExtract[2];
                    query = queryExtract[0];
                  }
                }

                devices = [];
                mayLoadMore = true;


                if (_this3.selectedFilter) {
                  if (_this3.selectedFilter === 'sn' && query) {
                    queryParams.identity = query;
                  } else if (_this3.selectedFilter === 'model' && query) {
                    queryParams['tag.name'] = 'model';
                    queryParams['tag.value'] = query;
                  } else if (_this3.selectedFilter === 'online' || _this3.selectedFilter === 'offline') {
                    queryParams['tag.name'] = 'connected';
                    _this3.hideQuery = _this3.selectedFilter === 'online' ? 1 : 0;
                    queryParams['tag.value'] = _this3.hideQuery;
                  }
                }

                if (!mayLoadMore) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 9;
                return _this3.$api.getDevices(queryParams).then(function (_ref) {
                  var data = _ref.data;
                  return data;
                }).catch(function (e) {
                  console.log(e);
                  return { devices: [], mayLoadMore: false };
                });

              case 9:
                res = _context2.sent;


                devices = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(devices), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(res.devices));

              case 11:
                return _context2.abrupt('return', _this3.showList(devices));

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getDeviceModel: function getDeviceModel(model) {
      return model || '--';
    },
    getTotal: function getTotal() {
      var _this4 = this;

      var query = {
        fields: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(['connected_devices', 'devices'])
      };
      return this.$api.getTotal(query).then(function (ret) {
        _this4.total = ret.data;
      }).catch(function (e) {
        return console.log(e);
      });
    },
    handleExpand: function handleExpand(row, expanded) {
      var _this5 = this;

      var arr = [];
      expanded.forEach(function (_ref2) {
        var identity = _ref2.identity;

        var alreadyIn = _this5.expanded.indexOf(identity) !== -1;
        if (!alreadyIn) {
          arr.push(identity);
        }
      });

      this.expanded = arr;
      return expanded;
    },
    handleSortChange: function handleSortChange(val) {
      if (val.column) {
        if (val.prop === 'last_seen') {
          val.prop = 'lastseen';
        }
        if (!['identity', 'lastseen'].includes(val.prop)) {
          val.prop = 'state.' + val.prop;
        }
        var sortOrder = val.order === 'ascending' ? '.asc' : '.desc';
        this.prevOrder = '__%ORDER%__' + val.prop + '__%ORDER%__' + sortOrder;
        var query = this.searchQuery + this.prevOrder;
        this.deviceSearch(query);
      }
    },
    getRowKey: function getRowKey(row) {
      return row.identity;
    },
    showList: function showList(devices) {
      this.isLoading = false;
      this.deviceList = devices.slice(0, this.pagination.limit);

      if (this.searchQuery !== '') {
        this.hideQuery = this.searchQuery;
      }
      this.searchedTotal = this.hideQuery ? devices.length + this.pagination.limit * (this.pagination.currentPage - 1) : this.total.devices;
      return devices;
    },
    toggleRowExpansion: function toggleRowExpansion(row) {
      var expandRow = this.expanded.some(function (id) {
        return row.identity === id;
      });
      var expandedArray = expandRow ? [] : [row];

      this.handleExpand(row, expandedArray);
    }
  },
  name: 'DeviceList',
  created: function created() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this6.getTotal();

            case 2:
              _context3.next = 4;
              return _this6.getDevices(_this6.searchQuery);

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this6);
    }))();
  },
  data: function data() {
    return {
      deviceList: [],
      expanded: [],
      isLoading: true,
      pagination: {
        currentPage: 1,
        layout: 'prev, pager, next',
        limit: 50,
        offset: 0
      },
      searchedTotal: 0,
      searchQuery: this.$route.params.sn || '',
      total: {},
      filterOptions: [],
      prevSelectedFilter: '',
      selectedFilter: 'sn',
      searchBarDisabled: false,
      prevOrder: '',
      hideQuery: ''
    };
  },
  mounted: function mounted() {
    var _this7 = this;

    this.filterOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* getFilterOptions */])();

    __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* bus */].$on('update-locked-device-list', function (sn) {
      var device = _this7.deviceList.find(function (item) {
        return item.sn === sn;
      });
      device.locked = true;
    });
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFilterOptions;
function getFilterOptions() {
  return [{
    key: 'sn',
    label: 'SN',
    value: 'sn'
  }, {
    key: 'model',
    label: 'Model',
    value: 'model'
  }, {
    key: 'online',
    label: 'Status - Online',
    value: 'online'
  }, {
    key: 'offline',
    label: 'Status - Offline',
    value: 'offline'
  }];
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  getFilterOptions: getFilterOptions
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Timeline_Timeline_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Timeline_Timeline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Timeline_Timeline_vue__);


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { TimeLine: __WEBPACK_IMPORTED_MODULE_0__Timeline_Timeline_vue___default.a },
  name: 'DeviceInfo',
  props: {
    identity: {
      required: true,
      type: String
    },
    owner: String,
    guests: Array,
    fields: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DeviceInfoBoxes',
  computed: {
    numberOfConnection: function numberOfConnection() {
      return this.total.connected_devices || this.total.connected_devices === 0 ? this.total.connected_devices : '--';
    },
    numberOfDevices: function numberOfDevices() {
      return this.total.devices || this.total.devices === 0 ? this.total.devices : '--';
    }
  },
  props: {
    total: {
      required: true,
      type: Object
    }
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* bus */].$off('show-lock-device');
  },

  computed: {
    id: function id() {
      return this.info.id;
    }
  },
  methods: {
    closePopup: function closePopup() {
      this.showModal = false;
    },
    lockDevice: function lockDevice(sn) {
      return this.$api.lockDevice(sn).then(function () {
        return __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* bus */].$emit('update-locked-device-list', sn);
      }).catch(function (error) {
        return new Error('Failed to delete device, please try again later (Error: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error) + ')');
      });
    }
  },
  name: 'DeviceLock',
  data: function data() {
    var _this = this;

    return {
      buttons: [{
        class: 'btn-close',
        id: 'Close',
        text: 'deviceLockDialogButtonCloseText',
        type: 'text',
        click: function click() {
          _this.closePopup();
        }
      }, {
        id: 'Delete',
        text: 'deviceLockDialogButtonDeleteText',
        type: 'warning',
        click: function click() {
          _this.lockDevice(_this.info.sn);
          _this.closePopup();
        }
      }],
      dialogProps: {
        beforeClose: function beforeClose() {
          return _this.closePopup();
        }
      },
      info: {},
      showModal: false
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* bus */].$on('show-lock-device', function (_ref) {
      var show = _ref.show,
          info = _ref.info;

      if (show) {
        _this2.showModal = true;
      }

      if (info) {
        _this2.info = info;
      }
    });
  }
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dialogProps: Object,
    showModal: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    showModal: function showModal() {
      this.show = this.showModal;
    }
  },
  data: function data() {
    var _this = this;

    return {
      beforeClose: function beforeClose() {
        return _this.dialogProps.beforeClose();
      },
      show: this.showModal
    };
  },
  render: function render(h) {
    var _this2 = this;

    var args = {
      on: {
        'update:visible': function updateVisible(val) {
          _this2.show = val;
        }
      },
      props: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.dialogProps, {
        beforeClose: this.beforeClose,
        visible: this.show
      })
    };
    return h(
      "el-dialog",
      args,
      [h(
        "span",
        { slot: "title" },
        [this.$slots.header]
      ), this.$slots.default, h(
        "span",
        { slot: "footer" },
        [h(
          "div",
          { "class": "footer-content" },
          [this.$slots['footer-content']]
        ), this.$slots.actions]
      )]
    );
  }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Export',
  computed: {
    componentTitle: function componentTitle() {
      return this.$t('ComponentTitle.' + this.$route.name);
    },
    isExportDisabled: function isExportDisabled() {
      if (!this.dateRange) return true;
      return !!this.error;
    }
  },
  data: function data() {
    var _this = this;

    return {
      component: 'export',
      dateRange: null,
      error: '',
      pickerOptions: {
        disabledDate: function disabledDate(date) {
          var now = Date.now();
          if (now < date) return true;

          var relativeStart = _this.theme.export.relative_start;
          if (isNaN(relativeStart)) return;
          if (now > +date + relativeStart * 1000) return true;
        }
      },
      theme: {}
    };
  },

  methods: {
    onPickerChange: function onPickerChange(_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          minDate = _ref2[0],
          maxDate = _ref2[1];

      var period = +maxDate + 86400000 - +minDate;
      var max = this.theme.export.period_max;
      var min = this.theme.export.period_min;
      if (period > max * 1000 || period < min * 1000) {
        this.error = this.$t('exportPeriodError', {
          min: min / 60 / 60,
          max: max / 60 / 60
        });
      } else {
        this.error = '';
      }
    },
    exportData: function exportData(_ref3) {
      var _this2 = this;

      var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
          minDate = _ref4[0],
          maxDate = _ref4[1];

      this.$api.exportData({
        startTime: +minDate / 1000,
        endTime: +maxDate / 1000
      }).then(function (_ref5) {
        var body = _ref5.body;
        return _this2.$alert(body, 'Job ID');
      }).catch(function (_ref6) {
        var body = _ref6.body;
        return _this2.$alert(body, 'Error');
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return this.$api.getTheme().then(function (_ref7) {
      var body = _ref7.body;

      _this3.theme = body;
    });
  }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FirmwareUpload_FirmwareUpload_vue__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FirmwareUpload_FirmwareUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FirmwareUpload_FirmwareUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FirmwareDelete_FirmwareDelete_vue__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FirmwareDelete_FirmwareDelete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FirmwareDelete_FirmwareDelete_vue__);








/* harmony default export */ __webpack_exports__["a"] = ({
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$off('get-firmware-list');
  },

  components: { FirmwareUpload: __WEBPACK_IMPORTED_MODULE_4__FirmwareUpload_FirmwareUpload_vue___default.a, FirmwareDelete: __WEBPACK_IMPORTED_MODULE_5__FirmwareDelete_FirmwareDelete_vue___default.a },
  computed: {
    componentTitle: function componentTitle() {
      return this.$t('ComponentTitle.' + this.$route.name);
    },
    defaultSort: function defaultSort() {
      return { prop: 'version', order: 'descending' };
    }
  },
  methods: {
    getFirmwareList: function getFirmwareList() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var list;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;

                _context.next = 3;
                return _this.$api.getFirmwareList();

              case 3:
                list = _context.sent;

                list.data = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(list.data, function (value, index) {
                  value.index = index;
                });
                _this.firmwareList = list.data;
                _this.loading = false;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    delFirmware: function delFirmware(info) {
      __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$emit('show-delete-firmware', {
        show: true,
        info: info
      });
    },
    showAddFirmware: function showAddFirmware() {
      __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$emit('show-add-firmware', true);
    }
  },
  name: 'Firmware',
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$on('get-firmware-list', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.getFirmwareList();

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    })));
  },
  data: function data() {
    return {
      active: 0,
      firmwareList: [],
      loading: true,
      popData: {},
      showDeletePopup: false,
      showModal: false
    };
  },
  mounted: function mounted() {
    this.getFirmwareList();
  }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FirmwareDelete',
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* bus */].$off('show-delete-firmware');
  },

  computed: {
    version: function version() {
      return this.firmware.version;
    }
  },
  methods: {
    closePopup: function closePopup() {
      this.showModal = false;
    },
    deleteFirmware: function deleteFirmware(id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = 'id=' + id;
                _context.next = 3;
                return _this.$api.removeFirmware(data).then(function () {
                  return __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* bus */].$emit('get-firmware-list');
                }).then(function () {
                  return _this.closePopup();
                }).then(function () {
                  return _this.$message({
                    message: _this.$t('messageFirmwareDelete'),
                    showClose: true,
                    type: 'success'
                  });
                }).catch(function (error) {
                  return __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* helper */].showErrorMessage(_this, _this.component, error);
                });

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  data: function data() {
    var _this2 = this;

    return {
      buttons: [{
        id: 'Close',
        class: 'btn-close',
        text: 'firmwareDeleteDialogButtonCloseText',
        type: 'text',
        click: function click() {
          _this2.closePopup();
        }
      }, {
        id: 'Delete',
        text: 'firmwareDeleteDialogButtonDeleteText',
        type: 'warning',
        click: function click() {
          _this2.deleteFirmware(_this2.firmware.name);
        }
      }],
      component: 'firmwareDelete',
      dialogProps: {
        beforeClose: function beforeClose() {
          return _this2.closePopup();
        }
      },
      firmware: {},
      showModal: false
    };
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* bus */].$on('show-delete-firmware', function (_ref) {
      var show = _ref.show,
          info = _ref.info;

      if (show) {
        _this3.showModal = true;
      }

      if (info) {
        _this3.firmware = info;
      }
    });
  }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["a"] = ({
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* bus */].$off('show-add-firmware');
  },

  computed: {
    getFileName: function getFileName() {
      return this.selectedFileName || this.$t('NoFileChosen');
    }
  },
  methods: {
    appendFormData: function appendFormData() {
      var formData = new FormData();
      var _uploadedFirmware = this.uploadedFirmware,
          name = _uploadedFirmware.name,
          list = _uploadedFirmware.list,
          fileName = _uploadedFirmware.fileName;


      formData.append('inputVersion', this.data.version);
      formData.append('inputLastVersion', this.data.lastVersion);
      formData.append('inputSHA1', this.data.sha1);
      formData.append('inputModel', this.data.model);
      formData.append(name, list, fileName);
      if (this.data.trigger) {
        formData.append('trigger', 'trigger');
      }

      return formData;
    },
    closePopup: function closePopup() {
      this.reset();
      this.showModal = false;
    },
    filesChange: function filesChange(fieldName, fileList) {
      var fileExist = !!(fileList && fileList[0]);
      this.selectedFileName = fileExist && fileList[0].name ? fileList[0].name : '';

      if (fileExist) {
        this.uploadedFirmware = {
          name: fieldName,
          list: fileList[0],
          fileName: fileList[0].name
        };
      }
    },
    reset: function reset() {
      var _this = this;

      this.data = {
        formData: null,
        imgFile: null,
        lastVersion: null,
        model: null,
        trigger: null,
        sha1: null,
        version: null
      };
      this.loading = false;
      this.selectedFileName = '';
      this.uploadedFirmware = {};
      document.getElementById(this.uploadFieldName).value = '';
      this.$nextTick(function () {
        _this.$validator.reset();
        _this.$validator.errors.clear();
      });
    },
    uploadFirmware: function uploadFirmware() {
      var _this2 = this;

      return this.$validator.validateAll().then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var upload;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!result) {
                    _context.next = 17;
                    break;
                  }

                  _this2.loading = true;

                  _context.prev = 2;

                  _this2.data.formData = _this2.appendFormData();
                  _context.next = 6;
                  return _this2.$api.addFirmware(_this2.data.formData);

                case 6:
                  upload = _context.sent;

                  if (!(upload.status !== 200)) {
                    _context.next = 9;
                    break;
                  }

                  return _context.abrupt('return');

                case 9:
                  _this2.$message({
                    message: _this2.$t('messageFirmwareUpload'),
                    showClose: true,
                    type: 'success'
                  });
                  _context.next = 15;
                  break;

                case 12:
                  _context.prev = 12;
                  _context.t0 = _context['catch'](2);

                  __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* helper */].showErrorMessage(_this2, _this2.component, _context.t0);

                case 15:

                  __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* bus */].$emit('get-firmware-list');
                  _this2.closePopup();

                case 17:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2, [[2, 12]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  },
  name: 'FirmwareUpload',
  data: function data() {
    var _this3 = this;

    return {
      component: 'firmwareUpload',
      data: {
        formData: null,
        imgFile: null,
        lastVersion: null,
        model: null,
        trigger: null,
        sha1: null,
        version: null
      },
      dialogProps: {
        beforeClose: function beforeClose() {
          return _this3.closePopup();
        }
      },
      labelWidth: '150px',
      loading: false,
      selectedFileName: '',
      showModal: false,
      uploadedFirmware: {},
      uploadFieldName: 'firmwareFile',
      validate: {
        semver: /[0-9]+\.[0-9]+\.[0-9]+/,
        sha1: /^([0-9a-f]){40}$/
      }
    };
  },
  mounted: function mounted() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_2__utils__["b" /* bus */].$on('show-add-firmware', function (show) {
      if (show) {
        _this4.showModal = true;
      }
    });
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InfoBox',
  props: {
    classes: {
      default: '',
      type: String
    },
    title: {
      default: '',
      type: String
    },
    total: {
      required: true,
      type: [Number, String]
    }
  }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_yaml__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_yaml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_yaml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InformationModelDelete_InformationModelDelete_vue__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InformationModelDelete_InformationModelDelete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__InformationModelDelete_InformationModelDelete_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InformationModelImagesUpload_InformationModelImagesUpload_vue__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InformationModelImagesUpload_InformationModelImagesUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__InformationModelImagesUpload_InformationModelImagesUpload_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InformationModelUpload_InformationModelUpload_vue__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InformationModelUpload_InformationModelUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__InformationModelUpload_InformationModelUpload_vue__);











/* harmony default export */ __webpack_exports__["a"] = ({
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* bus */].$off('get-information-model-list');
  },

  components: { InformationModelDelete: __WEBPACK_IMPORTED_MODULE_6__InformationModelDelete_InformationModelDelete_vue___default.a, InformationModelImagesUpload: __WEBPACK_IMPORTED_MODULE_7__InformationModelImagesUpload_InformationModelImagesUpload_vue___default.a, InformationModelUpload: __WEBPACK_IMPORTED_MODULE_8__InformationModelUpload_InformationModelUpload_vue___default.a },
  computed: {
    componentTitle: function componentTitle() {
      return this.$t('ComponentTitle.' + this.$route.name);
    },
    defaultSort: function defaultSort() {
      return { prop: 'timestamp', order: 'descending' };
    }
  },
  methods: {
    addInformationModal: function addInformationModal() {
      __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* bus */].$emit('add-information-modal', true);
    },
    convertToArray: function convertToArray(im) {
      var arrayData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(im).map(function (key) {
        var value = im[key];
        value.formatedDate = value.timestamp;
        value.index = key;

        var fileType = value.name.split('.').pop();
        var infoModel = value.informationModel;
        var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(infoModel);
        if (fileType === 'yaml' || fileType === 'yml') {
          data = __WEBPACK_IMPORTED_MODULE_4_js_yaml___default.a.safeDump(infoModel);
        }
        var blob = new Blob([data], { type: 'octet/stream' });
        value.downloadLink = window.URL.createObjectURL(blob);

        return value;
      });

      return arrayData;
    },
    getImageSrc: function getImageSrc() {
      var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (this.hasNoImages(model)) {
        return null;
      }
      var images = model.images;
      return images.thumbnail && images.thumbnail.uri || images.banner && images.banner.uri;
    },
    getInformationModels: function getInformationModels() {
      var _this = this;

      this.loading = true;
      return this.$api.getInfoModels().then(function (_ref) {
        var informationModels = _ref.data;
        return _this.updateModelList(informationModels);
      }).catch(function () {
        return _this.updateModelList([]);
      });
    },
    hasNoImages: function hasNoImages() {
      var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var images = model.images || {
        banner: {},
        thumbnail: {}
      };

      var noImages = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(images).length === 0;
      if (noImages) {
        return true;
      }

      var noBanner = !images.banner || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(images.banner).length === 0;
      var noThumbnail = !images.thumbnail || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(images.thumbnail).length === 0;

      return noBanner && noThumbnail;
    },
    removeInformationModel: function removeInformationModel(familyName) {
      __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* bus */].$emit('show-delete-information-model', {
        show: true,
        familyName: familyName
      });
    },
    showSetImagePopup: function showSetImagePopup(model, isEdit) {
      __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* bus */].$emit('show-upload-information-model-images', {
        familyName: model.familyName,
        images: model.images,
        show: true
      });
    },
    updateModelList: function updateModelList(models) {
      var arrayIM = this.convertToArray(models);
      this.informationModels = arrayIM;
      this.loading = false;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.getInformationModels();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },
  created: function created() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* bus */].$on('get-information-model-list', function () {
      return _this3.getInformationModels();
    });
  },
  data: function data() {
    return {
      downloadData: {
        name: '',
        url: undefined
      },
      informationModels: [],
      loading: true
    };
  }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InformationModelDelete',
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* bus */].$off('show-delete-information-model');
  },

  methods: {
    alert: function alert(type, message) {
      this.alert$.type = type;
      this.alert$.message = message;
      this.alert$.show = true;
    },
    closePopup: function closePopup() {
      this.loading = false;
      this.alert$.show = false;
      this.showModal = false;
    },
    deleteInformationModel: function deleteInformationModel(familyName) {
      var _this = this;

      return this.$api.removeInfoModel({ familyName: familyName }).then(function () {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* bus */].$emit('get-information-model-list');
      }).then(function () {
        return _this.successCallback();
      }).catch(function (e) {
        return _this.failedCallback(e);
      });
    },
    failedCallback: function failedCallback(e) {
      var errorMessage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* errorHandler */])(this.component, e.status);

      errorMessage = typeof errorMessage !== 'string' ? e.body : this.$t(errorMessage);

      this.loading = false;
      this.alert('error', errorMessage);
    },
    successCallback: function successCallback() {
      this.closePopup();
      this.$message({
        message: this.$t('messageInformationModelDelete'),
        showClose: true,
        type: 'success'
      });
    }
  },
  data: function data() {
    var _this2 = this;

    return {
      alert$: {
        type: '',
        show: false,
        message: ''
      },
      buttons: [{
        dataQA: 'Dialog-DeleteInformationModel-Button-Close',
        class: 'btn-close',
        text: 'informationModelDeleteDialogButtonCloseText',
        type: 'text',
        click: function click() {
          _this2.closePopup();
        }
      }, {
        dataQA: 'Dialog-DeleteInformationModel-Button-Delete',
        text: 'informationModelDeleteDialogButtonDeleteText',
        type: 'warning',
        click: function click() {
          _this2.loading = true;
          _this2.deleteInformationModel(_this2.familyName);
        }
      }],
      component: 'informationModelDelete',
      dialogProps: {
        beforeClose: function beforeClose() {
          return _this2.closePopup();
        }
      },
      familyName: '',
      loading: false,
      showModal: false
    };
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* bus */].$on('show-delete-information-model', function (_ref) {
      var show = _ref.show,
          familyName = _ref.familyName;

      if (show) {
        _this3.showModal = true;
      }

      if (familyName) {
        _this3.familyName = familyName;
      }
    });
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["a"] = ({
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$off('show-upload-information-model-images');
  },

  computed: {
    bannerName: function bannerName() {
      return this.getFieldName('banner');
    },
    bannerUri: function bannerUri() {
      return this.images.banner && this.images.banner.uri;
    },
    setFieldData: function setFieldData() {
      return {
        Thumbnail: {
          currentImgSrc: this.thumbnailUri,
          description: this.$t('informationModelImagesUploadInputThumbnailDescription'),
          imageErrorMsg: this.$t('informationModelImagesUploadInputThumbnailError'),
          isLocal: false,
          isValidImageSize: true,
          label: this.$t('informationModelImagesUploadInputThumbnailLabel'),
          minimumHeight: 240,
          minimumWidth: 240,
          model: this.data.thumbnail,
          name: this.thumbnailName,
          selectedFileName: this.thumbnailFileName || this.$t('NoFileChosen'),
          uri: this.thumbnailUri,
          validate: 'mimes:image/jpg,image/jpeg,image/png,image/gif|size:2048'
        },
        Banner: {
          currentImgSrc: this.bannerUri,
          description: this.$t('informationModelImagesUploadInputBannerDescription'),
          imageErrorMsg: this.$t('informationModelImagesUploadInputBannerError'),
          isLocal: false,
          isValidImageSize: true,
          label: this.$t('informationModelImagesUploadInputBannerLabel'),
          minimumHeight: 240,
          minimumWidth: 750,
          model: this.data.banner,
          name: this.bannerName,
          selectedFileName: this.bannerFileName || this.$t('NoFileChosen'),
          uri: this.bannerUri,
          validate: 'mimes:image/jpg,image/jpeg,image/png,image/gif|size:2048'
        }
      };
    },
    thumbnailName: function thumbnailName() {
      return this.getFieldName('thumbnail');
    },
    thumbnailUri: function thumbnailUri() {
      return this.images.thumbnail && this.images.thumbnail.uri;
    }
  },
  methods: {
    uploadImages: function uploadImages() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var id, file, name, list, fileName, apiArr;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                for (id in _this.uploadData) {
                  file = _this.uploadData[id];

                  if (file) {
                    name = file.name, list = file.list, fileName = file.fileName;

                    _this.data.formData.append(name, list, fileName);
                  }
                }

                apiArr = [_this.$api.updateInfoModelImages(_this.data.formData)];

                if (_this.removedImages.imageTypes.length) {
                  apiArr.push(_this.$api.removeInfoModelImages(_this.removedImages));
                }

                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(apiArr).then(function () {
                  return _this.successCallback();
                }).catch(function (error) {
                  return _this.failedCallback(error);
                }));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    closePopup: function closePopup() {
      this.reset();
      this.showModal = false;
    },
    failedCallback: function failedCallback(error) {
      this.loading = false;
      __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* helper */].showErrorMessage(this, this.component, error);
    },
    filesChange: function filesChange(id, fieldName, fileList) {
      var fileExist = !!(fileList && fileList[0]);
      var currentFileName = fileExist && fileList[0].name ? fileList[0].name : this.$t('NoFileChosen');
      var field = this.fieldsData[id];

      if (fileExist) {
        field.selectedFileName = currentFileName;
        var reader = new FileReader();
        reader.onload = function () {
          field.currentImgSrc = reader.result;

          var image = new Image();
          image.src = reader.result;
          image.onload = function () {
            var isValid = field.minimumHeight <= image.height && field.minimumWidth <= image.width;
            field.isValidImageSize = isValid;
          };
        };
        reader.readAsDataURL(fileList[0]);

        this.uploadData[id] = {
          name: fieldName,
          list: fileList[0],
          fileName: fileList[0].name
        };

        var newId = id.toLowerCase();
        var imageTypes = this.removedImages.imageTypes;
        var index = imageTypes.indexOf(newId);
        if (index !== -1) {
          imageTypes.splice(index, 1);
        }
      }
    },
    getFieldName: function getFieldName(name) {
      if (!name || typeof name !== 'string') {
        throw new Error('The filed name is required and it should be a string.');
      }
      return this.familyName + '-' + name;
    },
    removeImage: function removeImage(id, name) {
      this.fieldsData[id].isLocal = true;
      document.getElementById(name).value = '';

      this.fieldsData[id].currentImgSrc = null;
      this.fieldsData[id].selectedFileName = this.$t('NoFileChosen');

      var newId = id.toLowerCase();
      var removedImages = this.removedImages;
      var imageTypes = removedImages.imageTypes;
      if (!imageTypes.includes(newId)) {
        removedImages.familyName = this.familyName;
        imageTypes.push(newId);
        delete this.uploadData[id];
      }
    },
    reset: function reset() {
      var _this2 = this;

      document.getElementById(this.bannerName).value = '';
      document.getElementById(this.thumbnailName).value = '';

      this.bannerFileName = '';
      this.data = {
        thumbnail: null,
        banner: null,
        formData: new FormData()
      };
      this.fieldsData = {};
      this.images = {};
      this.removedImages = {
        familyName: null,
        imageTypes: []
      };
      this.thumbnailFileName = '';
      this.uploadData = {};
      this.$nextTick(function () {
        _this2.$validator.reset();
        _this2.$validator.errors.clear();
      });
    },
    save: function save() {
      var _this3 = this;

      return this.$validator.validateAll().then(function (result) {
        if (result) {
          _this3.loading = true;
          _this3.uploadImages();
        }
      });
    },
    successCallback: function successCallback() {
      __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$emit('get-information-model-list');
      this.loading = false;
      this.closePopup();
    },
    whenImageNotFound: function whenImageNotFound(id) {
      this.fieldsData[id].isLocal = true;
    }
  },
  name: 'InformationModelImagesUpload',
  data: function data() {
    var _this4 = this;

    return {
      bannerFileName: '',
      component: 'informationModelImagesUpload',
      data: {
        thumbnail: null,
        banner: null,
        formData: new FormData()
      },
      dialogProps: {
        beforeClose: function beforeClose() {
          return _this4.closePopup();
        }
      },
      familyName: '',
      fieldsData: {},
      i18n: {
        informationModelImagesUploadButtonRemoveImageText: this.$t('informationModelImagesUploadButtonRemoveImageText'),
        informationModelImagesUploadButtonUploadImageText: this.$t('informationModelImagesUploadButtonUploadImageText'),
        informationModelImagesUploadDialogButtonCloseText: this.$t('informationModelImagesUploadDialogButtonCloseText'),
        informationModelImagesUploadDialogButtonSaveText: this.$t('informationModelImagesUploadDialogButtonSaveText'),
        informationModelImagesUploadDialogTitle: this.$t('informationModelImagesUploadDialogTitle'),
        informationModelImagesUploadInputBannerDescription: this.$t('informationModelImagesUploadInputBannerDescription'),
        informationModelImagesUploadInputBannerError: this.$t('informationModelImagesUploadInputBannerError'),
        informationModelImagesUploadInputBannerLabel: this.$t('informationModelImagesUploadInputBannerLabel'),
        informationModelImagesUploadInputThumbnailDescription: this.$t('informationModelImagesUploadInputThumbnailDescription'),
        informationModelImagesUploadInputThumbnailError: this.$t('informationModelImagesUploadInputThumbnailError'),
        informationModelImagesUploadInputThumbnailLabel: this.$t('informationModelImagesUploadInputThumbnailLabel')
      },
      images: {},
      labelWidth: '150px',
      loading: false,
      removedImages: {
        familyName: null,
        imageTypes: []
      },
      showModal: false,
      thumbnailFileName: '',
      uploadData: {}
    };
  },
  mounted: function mounted() {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$on('show-upload-information-model-images', function (_ref) {
      var familyName = _ref.familyName,
          show = _ref.show,
          images = _ref.images;

      if (familyName) {
        _this5.familyName = familyName;
      }

      if (show) {
        _this5.showModal = true;
      }

      if (images) {
        _this5.images = images;
      }

      _this5.fieldsData = _this5.setFieldData;
    });
  }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ajv__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ajv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_ajv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_js_yaml__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_js_yaml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_js_yaml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_helper_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__information_model_json_schema_json__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__information_model_json_schema_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__information_model_json_schema_json__);















var ajv = new __WEBPACK_IMPORTED_MODULE_8_ajv___default.a({
  allErrors: true
});
ajv.addSchema(__WEBPACK_IMPORTED_MODULE_12__information_model_json_schema_json___default.a, 'im');

/* harmony default export */ __webpack_exports__["a"] = ({
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_10__utils__["b" /* bus */].$off('add-information-modal');
  },

  computed: {
    setFieldData: function setFieldData() {
      return {
        UploadField: {
          label: this.$t('informationModelUploadButtonUploadText'),
          model: this.data.files,
          name: 'InformationModel',
          selectedFileName: this.selectedFileName || this.$t('NoFileChosen'),
          validate: 'required'
        }
      };
    }
  },
  methods: {
    updateInformationModels: function updateInformationModels() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.all(_this.filterFiles(_this.data.files)).then(function (arr) {
                  return _this.validateFiles(arr);
                }).then(function (data) {
                  return _this.$api.updateInfoModel(data);
                }).then(function () {
                  __WEBPACK_IMPORTED_MODULE_10__utils__["b" /* bus */].$emit('get-information-model-list');
                  return _this.successCallback();
                }).catch(function (error) {
                  return _this.failedCallback(error);
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    alert: function alert(type, message) {
      this.alert$.type = type;
      this.alert$.errors = message;
      this.alert$.show = true;
    },
    closePopup: function closePopup() {
      this.reset();
      this.alert$.show = false;
      this.showModal = false;
    },
    failedCallback: function failedCallback(e) {
      this.loading = false;
      if (__WEBPACK_IMPORTED_MODULE_11__utils_helper_js__["a" /* default */].notShowAlertList.includes(e.status)) return;

      var errorMessage = typeof e.status === 'number' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils__["d" /* errorHandler */])(this.component, e.status) : e;

      if (typeof errorMessage === 'string') {
        errorMessage = [this.$t(errorMessage)];
      }

      if (!Array.isArray(errorMessage)) {
        errorMessage = [e.message || e.body];
      }

      this.alert('error', errorMessage);
    },
    filesChange: function filesChange(id, fieldName, fileList) {
      this.data.formData = new FormData();
      var fileExist = fileList && fileList.length > 0;
      var field = this.fieldsData[id];

      field.selectedFileName = '';
      if (fileExist) {
        field.selectedFileName = fileList.length > 1 ? fileList.length + ' files' : fileList[0].name;

        this.data.files = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(fileList).map(function (key) {
          return fileList[key];
        });

        for (var key in fileList) {
          this.data.formData.append(fieldName, fileList[key], fileList[key].name);
        }
      }
    },
    filterFiles: function filterFiles(files) {
      var _this2 = this;

      return files.filter(function (file) {
        return _this2.isValidFileType(file.type);
      }).map(function (file) {
        return _this2.readFiles(file);
      });
    },
    isJsonFile: function isJsonFile(type) {
      return type === 'application/json';
    },
    isValidFileType: function isValidFileType(type) {
      return this.isJsonFile(type) || this.isYamlFile(type) || type === '';
    },
    isYamlFile: function isYamlFile(type) {
      return type === 'application/x-yaml';
    },
    readFiles: function readFiles(file) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var reader = new FileReader();

        reader.onload = function () {
          var result = void 0;

          try {
            result = _this3.isJsonFile(file.type) ? JSON.parse(reader.result) : __WEBPACK_IMPORTED_MODULE_9_js_yaml___default.a.safeLoad(reader.result);
          } catch (error) {
            reject({ message: _this3.$t('informationModelUploadErrorMessageInvalidFile') });
          }
          var text = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(result);

          resolve({
            lastModified: file.lastModified,
            name: file.name,
            size: file.size,
            text: text
          });
        };

        reader.readAsText(file);
      });
    },
    reset: function reset() {
      var _this4 = this;

      document.getElementById('InformationModel').value = '';
      this.data = {
        files: [],
        formData: null
      };
      this.fieldsData = {};
      this.selectedFileName = '';
      this.$nextTick(function () {
        _this4.$validator.reset();
        _this4.$validator.errors.clear();
      });
    },
    save: function save() {
      var _this5 = this;

      return this.$validator.validateAll().then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!result) {
                    _context2.next = 4;
                    break;
                  }

                  _this5.loading = true;
                  _context2.next = 4;
                  return _this5.updateInformationModels();

                case 4:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this5);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    successCallback: function successCallback() {
      this.loading = false;
      this.closePopup();
      this.$message({
        message: this.$t('informationModelUploadMessageUploadSuccessful'),
        showClose: true,
        type: 'success'
      });
    },
    validateFiles: function validateFiles(array) {
      var errorMessages = [];
      var allModel = array.reduce(function (acc, val) {
        var model = {};

        try {
          model = JSON.parse(val.text);
        } catch (e) {
          model = __WEBPACK_IMPORTED_MODULE_9_js_yaml___default.a.safeLoad(val.text);
        }

        var valid = ajv.validate('im', model);
        if (valid) {
          acc = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(val, { familyName: model.familyName });
        } else {
          errorMessages = ajv.errors.map(function (_ref2) {
            var dataPath = _ref2.dataPath,
                message = _ref2.message;
            return val.name + ': ' + dataPath + ' ' + message;
          });
          errorMessages = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(errorMessages));
        }

        return acc;
      }, {});
      if (errorMessages.length !== 0) {
        throw errorMessages;
      }

      return allModel;
    }
  },
  name: 'InformationModelUpload',
  data: function data() {
    var _this6 = this;

    return {
      alert$: {
        errors: '',
        show: false,
        type: ''
      },
      component: 'informationModelUpload',
      data: {
        files: [],
        formData: null
      },
      dialogProps: {
        beforeClose: function beforeClose() {
          return _this6.closePopup();
        }
      },
      fieldsData: {},
      labelWidth: '150px',
      loading: false,
      selectedFileName: '',
      showModal: false
    };
  },
  mounted: function mounted() {
    var _this7 = this;

    __WEBPACK_IMPORTED_MODULE_10__utils__["b" /* bus */].$on('add-information-modal', function (show) {
      if (show) {
        _this7.showModal = true;
      }

      _this7.fieldsData = _this7.setFieldData;
    });
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(57);



/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__i18n__["b" /* loadLanguageAsync */])();
  },

  computed: {
    resetPwdMsg: function resetPwdMsg() {
      return this.$store.state.resetPwdDone;
    }
  },
  methods: {
    checkCreds: function checkCreds(email, password) {
      var _this = this;

      var username = email;

      this.resetResponse();
      this.$store.commit('SET_USER', username);
      return this.$api.login({ email: email, password: password }).then(function (_ref) {
        var id = _ref.id,
            token = _ref.token;

        _this.$store.commit('SET_TOKEN', token);
        _this.$cookie.set('sid', token, { expires: '30D' });
        if (window.localStorage) {
          window.localStorage.setItem('uid', id);
          window.localStorage.setItem('user', username);
          window.localStorage.setItem('token', token);
        }
      }).then(function () {
        return _this.$api.checkToken();
      }).then(function () {
        return _this.$message.closeAll();
      }).then(function () {
        return _this.$router.push('/device');
      }).catch(function (error) {
        _this.response = error.data;
        __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* helper */].clearLoginData(_this);
        _this.loading = false;
      });
    },
    forgetPwd: function forgetPwd() {
      this.$store.commit('RESET_PWD_DONE', false);
      this.$router.push('/reset');
    },
    resetResponse: function resetResponse() {
      this.$store.commit('RESET_PWD_DONE', false);
      this.response = '';
    },
    validateForm: function validateForm() {
      var _this2 = this;

      return this.$validator.validateAll().then(function (valid) {
        if (valid) {
          var email = _this2.email,
              password = _this2.password;

          _this2.loading = true;
          return _this2.checkCreds(email, password);
        }
      });
    }
  },
  name: 'Login',
  data: function data(router) {
    return {
      email: '',
      loading: false,
      password: '',
      response: '',
      section: 'Login'
    };
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__(57);


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__i18n__["b" /* loadLanguageAsync */])();
  },

  computed: {
    goSupportPage: function goSupportPage() {
      return 'https://support.exosite.com/hc/en-us/requests/new';
    }
  },
  name: 'NotFound'
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NotificationsCreate_NotificationsCreate_vue__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NotificationsCreate_NotificationsCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__NotificationsCreate_NotificationsCreate_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NotificationsDelete_NotificationsDelete_vue__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NotificationsDelete_NotificationsDelete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__NotificationsDelete_NotificationsDelete_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NotificationsEdit_NotificationsEdit_vue__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NotificationsEdit_NotificationsEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__NotificationsEdit_NotificationsEdit_vue__);












/* harmony default export */ __webpack_exports__["a"] = ({
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_7__utils__["b" /* bus */].$off('get-notifications-list');
  },

  components: {
    NotificationsCreate: __WEBPACK_IMPORTED_MODULE_8__NotificationsCreate_NotificationsCreate_vue___default.a,
    NotificationsDelete: __WEBPACK_IMPORTED_MODULE_9__NotificationsDelete_NotificationsDelete_vue___default.a,
    NotificationsEdit: __WEBPACK_IMPORTED_MODULE_10__NotificationsEdit_NotificationsEdit_vue___default.a
  },
  computed: {
    canAddNotification: function canAddNotification() {
      return this.limitRules;
    },
    componentTitle: function componentTitle() {
      return this.$t('ComponentTitle.' + this.$route.name);
    },
    defaultSort: function defaultSort() {
      return { prop: 'rule', order: 'descending' };
    },
    isRulesLimitReached: function isRulesLimitReached() {
      return this.ownRules >= this.limitRules;
    },
    noQuotaBlockShows: function noQuotaBlockShows() {
      return this.limitRules <= 0;
    }
  },
  methods: {
    editNotification: function editNotification(id) {
      __WEBPACK_IMPORTED_MODULE_7__utils__["b" /* bus */].$emit('show-edit-notification', {
        show: true,
        id: id
      });
    },
    delNotification: function delNotification(id) {
      __WEBPACK_IMPORTED_MODULE_7__utils__["b" /* bus */].$emit('show-delete-notification', {
        show: true,
        id: id
      });
    },
    getFamilyMembers: function getFamilyMembers() {
      var models = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(models).reduce(function (acc, curr) {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(acc, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({}, curr, models[curr].informationModel.familyMembers || []));
      }, {});
    },
    getFamilyNames: function getFamilyNames() {
      var models = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(models).map(function (model) {
        return model;
      });
    },
    getNotificationsList: function getNotificationsList() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var themeData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;

                _context.next = 3;
                return _this.$api.getTheme().then(function (_ref) {
                  var data = _ref.data;
                  return data;
                }).catch(function (error) {
                  return console.error(error);
                });

              case 3:
                themeData = _context.sent;
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([_this.$api.getNotificationsList(), _this.$api.getInfoModels()]).then(function (_ref2) {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
                      rules = _ref3[0],
                      models = _ref3[1];

                  var list = rules.map(function (_ref4) {
                    var actions = _ref4.actions,
                        conditions = _ref4.event.conditions,
                        familyName = _ref4.familyName,
                        id = _ref4.id;

                    return actions.map(function (action) {
                      var familyNames = familyName.join(', ');
                      var title = action.title,
                          message = action.body;

                      var newConditions = conditions.map(function (condition) {
                        var key = condition.key,
                            op = condition.op,
                            target = condition.target;

                        var operation = _this.getOperation(op);
                        return key + ' ' + operation + ' ' + target;
                      });

                      return {
                        familyNames: familyNames,
                        id: id,
                        message: message,
                        rule: newConditions.join(', '),
                        title: title
                      };
                    });
                  }).reduce(function (accumulator, currentValue) {
                    return accumulator.concat(currentValue);
                  }, []);

                  _this.limitRules = themeData.notification_rule_limit;
                  _this.familyNames = _this.getFamilyNames(models.data);
                  _this.familyMembers = _this.getFamilyMembers(models.data);
                  _this.notificationsList = list;
                  _this.ownRules = list.length;
                  _this.loading = false;
                }).catch(function (error) {
                  _this.loading = false;
                  _this.limitRules = status === 405 ? 0 : themeData.notification_rule_limit;

                  __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* helper */].showErrorMessage(_this, _this.component, error);
                }));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getOperation: function getOperation(op) {
      if (!op) {
        throw new Error('Operation is required.');
      }

      var operators = {
        eq: '=',
        gt: '>',
        geq: '≥',
        lt: '<',
        leq: '≤',
        neq: '≠'
      };

      if (!operators[op]) {
        throw new Error('No matched operation found.');
      }
      return operators[op];
    },
    getRecipients: function getRecipients(recipients) {
      var hasOwner = recipients && Array.isArray(recipients) && recipients.includes('owner');
      var hasGuest = recipients && Array.isArray(recipients) && recipients.includes('guest');

      if (hasOwner && hasGuest) {
        return 'All';
      } else if (hasOwner) {
        return 'Owner';
      }
      return '--';
    },
    showAddNotification: function showAddNotification() {
      __WEBPACK_IMPORTED_MODULE_7__utils__["b" /* bus */].$emit('show-add-notification', true);
    }
  },
  name: 'Notifications',
  created: function created() {
    var _this2 = this;

    var uid = window.localStorage.getItem('uid');
    this.uid = uid ? +uid : null;

    __WEBPACK_IMPORTED_MODULE_7__utils__["b" /* bus */].$on('get-notifications-list', function () {
      _this2.getNotificationsList();
    });
  },
  data: function data() {
    return {
      component: 'notifications',
      familyMembers: {},
      familyNames: [],
      ownRules: 0,
      notificationsList: [],
      limitRules: 10,
      loading: true,
      showDeletePopup: false,
      showModal: false,
      uid: null
    };
  },
  mounted: function mounted() {
    this.getNotificationsList();
  }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(483);






/* harmony default export */ __webpack_exports__["a"] = ({
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$off('show-add-notification');
  },

  computed: {
    hasConditionsError: function hasConditionsError() {
      return this.errors.has('key') || this.errors.has('operator') || this.errors.has('target');
    },
    isStatusRule: function isStatusRule() {
      return this.data.ruleType === 'states';
    },
    ruleTypes: function ruleTypes() {
      return [{
        key: 'states',
        label: this.$t('notificationsCreateRuleTypesOptionStates'),
        value: 'states'
      }];
    }
  },
  methods: {
    closePopup: function closePopup() {
      this.reset();
      this.showModal = false;
    },
    reset: function reset() {
      var _this = this;

      this.data = {
        conditions: {
          key: null,
          op: null,
          target: null
        },
        familyNames: [],
        message: null,
        ruleType: 'states',
        title: null
      };
      this.loading = false;
      this.$nextTick(function () {
        _this.$validator.reset();
        _this.$validator.errors.clear();
      });
    },
    createNotification: function createNotification() {
      var _this2 = this;

      return this.$validator.validateAll().then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var rawData, data, save, hasOwnerId, failedMsg, noOwnerIdMsg, message;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!result) {
                    _context.next = 24;
                    break;
                  }

                  _this2.loading = true;

                  _context.prev = 2;
                  rawData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_this2.data, { familyMembers: _this2.familyMembers });
                  data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper__["a" /* getPostData */])(rawData, _this2.uid);
                  _context.next = 7;
                  return _this2.$api.addNotification(data);

                case 7:
                  save = _context.sent;

                  if (!(save.status !== 201)) {
                    _context.next = 10;
                    break;
                  }

                  return _context.abrupt('return');

                case 10:

                  _this2.$message({
                    message: _this2.$t('messageNotificationCreate'),
                    showClose: true,
                    type: 'success'
                  });
                  _context.next = 22;
                  break;

                case 13:
                  _context.prev = 13;
                  _context.t0 = _context['catch'](2);
                  hasOwnerId = _context.t0.bodyText.match(/\\"ownerId\\"/g);
                  failedMsg = _this2.$t('NotificationsCreateFailedMessage');
                  noOwnerIdMsg = _this2.$t('NotificationsCreateFailedNoOwnerIdMessage');
                  message = hasOwnerId ? noOwnerIdMsg : failedMsg;


                  __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* helper */].showErrorMessage(_this2, _this2.component, _context.t0, message);
                  _this2.loading = false;
                  return _context.abrupt('return');

                case 22:

                  __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$emit('get-notifications-list');
                  _this2.closePopup();

                case 24:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2, [[2, 13]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  },
  name: 'NotificationsCreate',
  props: {
    familyMembers: {
      required: true,
      type: Object
    },
    familyNames: {
      required: true,
      type: Array
    },
    noQuota: {
      required: true,
      type: Boolean
    },
    uid: {
      default: null,
      type: Number
    }
  },
  data: function data() {
    var _this3 = this;

    return {
      component: 'notificationsCreate',
      data: {
        conditions: {
          key: null,
          op: null,
          target: null
        },
        familyNames: [],
        message: null,
        ruleType: 'states',
        title: null
      },
      dialogProps: {
        beforeClose: function beforeClose() {
          return _this3.closePopup();
        }
      },
      operators: [],
      rules: {},
      labelWidth: '150px',
      loading: false,
      showModal: false,
      validate: {
        deviceKey: /^H([0-9A-F]){2}$/
      }
    };
  },
  mounted: function mounted() {
    var _this4 = this;

    this.operators = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper__["b" /* getOperators */])();

    __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$on('show-add-notification', function (show) {
      if (show) {
        _this4.showModal = true;
      }
    });
  }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getOperators;
/* harmony export (immutable) */ __webpack_exports__["a"] = getPostData;
function getOperators() {
  return [{
    key: 'eq',
    label: '=',
    value: 'eq'
  }, {
    key: 'gt',
    label: '>',
    value: 'gt'
  }, {
    key: 'geq',
    label: '≥',
    value: 'geq'
  }, {
    key: 'lt',
    label: '<',
    value: 'lt'
  }, {
    key: 'leq',
    label: '≤',
    value: 'leq'
  }, {
    key: 'neq',
    label: '≠',
    value: 'neq'
  }];
}

function getPostData(data, uid) {
  return {
    actions: [{
      title: data.title,
      body: data.message
    }],
    event: {
      source: 'device',
      resource: data.ruleType,
      type: 'exohomeEvent',
      conditions: [{
        key: data.conditions.key,
        op: data.conditions.op,
        target: Number(data.conditions.target)
      }]
    },
    familyMembers: data.familyNames.reduce(function (acc, curr) {
      return acc.concat(data.familyMembers[curr]);
    }, []),
    familyName: data.familyNames,
    ownerId: uid,
    source: 'admin'
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  getOperators: getOperators,
  getPostData: getPostData
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NotificationsDelete',
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* bus */].$off('show-delete-notification');
  },

  methods: {
    closePopup: function closePopup() {
      this.showModal = false;
      this.loading = false;
    },
    deleteNotification: function deleteNotification(id) {
      var _this = this;

      this.loading = true;

      return this.$api.removeNotification(id).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* bus */].$emit('get-notifications-list');
        _this.closePopup();
        _this.$message({
          message: _this.$t('messageNotificationDelete'),
          showClose: true,
          type: 'success'
        });
      }).catch(function (error) {
        _this.loading = false;
        __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* helper */].showErrorMessage(_this, _this.component, error);
      });
    }
  },
  data: function data() {
    var _this2 = this;

    return {
      component: 'notificationsDelete',
      dialogProps: {
        beforeClose: function beforeClose() {
          return _this2.closePopup();
        }
      },
      id: null,
      loading: false,
      showModal: false
    };
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_0__utils__["b" /* bus */].$on('show-delete-notification', function (_ref) {
      var show = _ref.show,
          id = _ref.id;

      if (show) {
        _this3.showModal = true;
      }

      if (id) {
        _this3.id = id;
      }
    });
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__(486);






/* harmony default export */ __webpack_exports__["a"] = ({
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$off('show-edit-notification');
  },

  computed: {
    hasConditionsError: function hasConditionsError() {
      return this.errors.has('key') || this.errors.has('operator') || this.errors.has('target');
    },
    isStatusRule: function isStatusRule() {
      return this.data.ruleType === 'states';
    },
    ruleTypes: function ruleTypes() {
      return [{
        key: 'states',
        label: this.$t('notificationsCreateRuleTypesOptionStates'),
        value: 'states'
      }];
    }
  },
  methods: {
    closePopup: function closePopup() {
      this.reset();
      this.showModal = false;
    },
    reset: function reset() {
      var _this = this;

      this.data = {
        conditions: {
          key: null,
          op: null,
          target: null
        },
        familyNames: [],
        id: null,
        message: null,
        ruleType: 'states',
        title: null
      };
      this.loading = false;
      this.gettingNotification = false;
      this.$nextTick(function () {
        _this.$validator.reset();
        _this.$validator.errors.clear();
      });
    },
    editNotification: function editNotification() {
      var _this2 = this;

      return this.$validator.validateAll().then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var rawData, data, save, hasOwnerId, failedMsg, noOwnerIdMsg, message;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!result) {
                    _context.next = 24;
                    break;
                  }

                  _this2.loading = true;

                  rawData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_this2.data, { familyMembers: _this2.familyMembers });
                  _context.prev = 3;
                  data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper__["a" /* getPutData */])(rawData, _this2.uid);
                  _context.next = 7;
                  return _this2.$api.updateNotification(data);

                case 7:
                  save = _context.sent;

                  if (!(save.status !== 204)) {
                    _context.next = 10;
                    break;
                  }

                  return _context.abrupt('return');

                case 10:

                  _this2.$message({
                    message: _this2.$t('messageNotificationUpdate'),
                    showClose: true,
                    type: 'success'
                  });
                  _context.next = 22;
                  break;

                case 13:
                  _context.prev = 13;
                  _context.t0 = _context['catch'](3);
                  hasOwnerId = _context.t0.bodyText.match(/\\"ownerId\\"/g);
                  failedMsg = _this2.$t('NotificationsCreateFailedMessage');
                  noOwnerIdMsg = _this2.$t('NotificationsEditFailedNoOwnerIdMessage');
                  message = hasOwnerId ? noOwnerIdMsg : failedMsg;


                  __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* helper */].showErrorMessage(_this2, _this2.component, _context.t0, message);

                  _this2.loading = false;
                  return _context.abrupt('return');

                case 22:

                  __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$emit('get-notifications-list');
                  _this2.closePopup();

                case 24:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2, [[3, 13]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getNotificationById: function getNotificationById(id) {
      var _this3 = this;

      return this.$api.getNotification(id).then(function (notification) {
        _this3.setDefaultNotification(notification);
        _this3.gettingNotification = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* helper */].showErrorMessage(_this3, _this3.component, error);
        _this3.gettingNotification = false;
        _this3.closePopup();
      });
    },
    setDefaultNotification: function setDefaultNotification(notification) {
      var actions = notification.actions,
          event = notification.event,
          familyName = notification.familyName,
          id = notification.id;

      var newActions = actions[0];
      var newConditions = event.conditions[0];

      this.data = {
        conditions: {
          key: newConditions.key,
          op: newConditions.op,
          target: newConditions.target
        },
        familyNames: familyName,
        id: id,
        message: newActions.body,
        ruleType: event.resource,
        title: newActions.title
      };
    }
  },
  name: 'NotificationsEdit',
  props: {
    familyMembers: {
      required: true,
      type: Object
    },
    familyNames: {
      required: true,
      type: Array
    },
    uid: {
      default: null,
      type: Number
    }
  },
  data: function data() {
    var _this4 = this;

    return {
      component: 'notificationsEdit',
      data: {
        conditions: {
          key: null,
          op: null,
          target: null
        },
        familyNames: [],
        id: null,
        message: null,
        ruleType: null,
        title: null
      },
      dialogProps: {
        beforeClose: function beforeClose() {
          return _this4.closePopup();
        }
      },
      gettingNotification: false,
      operators: [],
      rules: {},
      labelWidth: '150px',
      loading: false,
      notification: [],
      showModal: false,
      titleAdd: 'Edit Notification Rule',
      validate: {
        deviceKey: /^H([0-9A-F]){2}$/
      }
    };
  },
  mounted: function mounted() {
    var _this5 = this;

    this.operators = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helper__["b" /* getOperators */])();

    __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$on('show-edit-notification', function (_ref2) {
      var show = _ref2.show,
          id = _ref2.id;

      if (show) {
        _this5.showModal = true;
      }

      if (id) {
        _this5.gettingNotification = true;
        _this5.getNotificationById(id);
      }
    });
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getOperators;
/* harmony export (immutable) */ __webpack_exports__["a"] = getPutData;
function getOperators() {
  return [{
    key: 'eq',
    label: '=',
    value: 'eq'
  }, {
    key: 'gt',
    label: '>',
    value: 'gt'
  }, {
    key: 'geq',
    label: '≥',
    value: 'geq'
  }, {
    key: 'lt',
    label: '<',
    value: 'lt'
  }, {
    key: 'leq',
    label: '≤',
    value: 'leq'
  }, {
    key: 'neq',
    label: '≠',
    value: 'neq'
  }];
}

function getPutData(data, uid) {
  return {
    actions: [{
      title: data.title,
      body: data.message
    }],
    event: {
      source: 'device',
      resource: data.ruleType,
      type: 'exohomeEvent',
      conditions: [{
        key: data.conditions.key,
        op: data.conditions.op,
        target: Number(data.conditions.target)
      }]
    },
    familyMembers: data.familyNames.reduce(function (acc, curr) {
      return acc.concat(data.familyMembers[curr]);
    }, []),
    familyName: data.familyNames,
    id: data.id,
    ownerId: uid,
    source: 'admin'
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  getOperators: getOperators,
  getPutData: getPutData
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__(57);


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__i18n__["b" /* loadLanguageAsync */])();
  },

  methods: {
    sendEmail: function sendEmail(email) {
      var _this = this;

      this.resetResponse();
      return this.$api.resetPassword(email).then(function () {
        _this.$store.commit('RESET_PWD_DONE', true);
        _this.$router.push('/login');
      }).catch(function (error) {
        _this.response = error.data;
        _this.loading = false;
      });
    },
    resetResponse: function resetResponse() {
      this.response = '';
    },
    validateForm: function validateForm() {
      var _this2 = this;

      return this.$validator.validateAll().then(function (valid) {
        if (valid) {
          var email = _this2.email;

          _this2.loading = true;
          return _this2.sendEmail(email);
        }
      });
    }
  },
  name: 'ResetPassword',
  data: function data(router) {
    return {
      email: '',
      loading: false,
      response: '',
      section: 'Reset Password'
    };
  }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Sidebar',
  props: ['collapse'],
  computed: {
    expandWidth: function expandWidth() {
      return this.collapse ? 'not-collapse-width' : 'collapse-width';
    },
    isDeviceChildren: function isDeviceChildren() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.startsWith(this.$route.path, '/device') || this.$route.path === '/';
    },
    isExportChildren: function isExportChildren() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.startsWith(this.$route.path, '/export');
    },
    isFirmwareChildren: function isFirmwareChildren() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.startsWith(this.$route.path, '/firmware');
    },
    isIMChildren: function isIMChildren() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.startsWith(this.$route.path, '/informationModel');
    },
    isNotifyChildren: function isNotifyChildren() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.startsWith(this.$route.path, '/notifications');
    },
    isThemeChildren: function isThemeChildren() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.startsWith(this.$route.path, '/theme');
    },
    isUserChildren: function isUserChildren() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.startsWith(this.$route.path, '/user');
    },
    showDevicesActive: function showDevicesActive() {
      return [{ 'active': this.isDeviceChildren }];
    },
    showExportActive: function showExportActive() {
      return [{ 'active': this.isExportChildren }];
    },
    showFirmwareActive: function showFirmwareActive() {
      return [{ 'active': this.isFirmwareChildren }];
    },
    showIMActive: function showIMActive() {
      return [{ 'active': this.isIMChildren }];
    },
    showNotifyActive: function showNotifyActive() {
      return [{ 'active': this.isNotifyChildren }];
    },
    showThemeActive: function showThemeActive() {
      return [{ 'active': this.isThemeChildren }];
    },
    showUsersActive: function showUsersActive() {
      return [{ 'active': this.isUserChildren }];
    }
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SolutionStatusTest',
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$off('show-solution-status-test');
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$on('show-solution-status-test', function (_ref) {
      var show = _ref.show;

      if (show) {
        _this.showModal = true;
        _this.data.SolutionAccount = _this.$store.state.user;
      }
    });
  },
  data: function data() {
    var _this2 = this;

    return {
      component: 'solutionStatusTest',
      data: {
        SolutionAccount: '',
        SolutionPassword: '',
        RecipientList: ''
      },
      description: {
        class: 'description',
        text: 'solutionStatusTestDialogDescription'
      },
      dialogProps: {
        beforeClose: function beforeClose() {
          return _this2.closePopup();
        }
      },
      labelWidth: '150px',
      loading: false,
      recipients: {
        label: 'solutionStatusTestInputRecipientLabel',
        tips: 'solutionStatusTestInputRecipientsTip'
      },
      rules: {
        SolutionAccount: [{
          required: true, message: 'Please input'
        }],
        SolutionPassword: [],
        RecipientList: []
      },
      showModal: false,
      support: {
        href: 'https://support.exosite.com/hc/en-us/requests/new',
        text: 'solutionStatusTestDialogSupport'
      }
    };
  },

  methods: {
    closePopup: function closePopup() {
      this.reset();
      this.showModal = false;
    },
    reset: function reset() {
      var _this3 = this;

      this.data = {
        SolutionAccount: '',
        SolutionPassword: '',
        RecipientList: ''
      };
      this.loading = false;
      this.$nextTick(function () {
        _this3.$validator.reset();
        _this3.$validator.errors.clear();
      });
    },
    triggerTest: function triggerTest() {
      var _this4 = this;

      return this.$validator.validateAll().then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var RecipientList, data, trigger;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!result) {
                    _context.next = 17;
                    break;
                  }

                  _this4.loading = true;

                  _context.prev = 2;
                  RecipientList = _this4.data.RecipientList;
                  data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this4.data, { RecipientList: RecipientList });
                  _context.next = 7;
                  return _this4.$api.triggerOnlineTesting(data);

                case 7:
                  trigger = _context.sent;

                  if (!(trigger.status !== 200)) {
                    _context.next = 10;
                    break;
                  }

                  return _context.abrupt('return');

                case 10:

                  _this4.$message({
                    message: _this4.$t('solutionStatusTestSuccessMessage'),
                    showClose: true,
                    type: 'success'
                  });
                  _context.next = 16;
                  break;

                case 13:
                  _context.prev = 13;
                  _context.t0 = _context['catch'](2);

                  __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* helper */].showErrorMessage(_this4, _this4.component, _context.t0);

                case 16:

                  _this4.closePopup();

                case 17:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this4, [[2, 13]]);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ThemeLegal_ThemeLegal_vue__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ThemeLegal_ThemeLegal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ThemeLegal_ThemeLegal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThemeView_ThemeView_vue__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThemeView_ThemeView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ThemeView_ThemeView_vue__);









/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ThemeLegal: __WEBPACK_IMPORTED_MODULE_6__ThemeLegal_ThemeLegal_vue___default.a, ThemeView: __WEBPACK_IMPORTED_MODULE_7__ThemeView_ThemeView_vue___default.a },
  computed: {
    componentTitle: function componentTitle() {
      return this.$t('ComponentTitle.' + this.$route.name);
    },
    tabValue: function tabValue() {
      return this.$route.params.id || 'general';
    }
  },
  methods: {
    getTheme: function getTheme() {
      var _this = this;

      this.loading = true;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([this.$api.getTheme(), this.$api.getLegal(), this.$api.getServiceConfig({ service: 'email' })]).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
            themeData = _ref2[0],
            legalData = _ref2[1],
            serviceConfigData = _ref2[2];

        var config = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, themeData.data, legalData.data, serviceConfigData.data);

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.$data.fieldsData).forEach(function (blockKey) {
          var obj = _this.$data.fieldsData[blockKey];
          for (var key in obj) {
            var input = obj[key];
            var value = config[key];

            if (value) input.model = value;
          }
        });

        _this.loading = false;
        return config;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* helper */].showErrorMessage(_this, _this.component, error);
      });
    },
    getImageSrc: function getImageSrc(id) {
      var ts = Date.now();
      return __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].serverURI + '/theme/' + id + '?' + ts;
    },
    setUrl: function setUrl(tab) {
      this.$router.push({ path: '/theme/' + tab.name });
    }
  },
  data: function data() {
    return {
      component: 'theme',
      fieldsData: {
        appText: {
          wifi_name: {
            class: 'form-control',
            description: 'themeTabAppAppTextWifiNameDescription',
            label: 'themeTabAppAppTextWifiNameLabel',
            model: null,
            validate: {
              rules: {
                max: 32
              }
            }
          },
          news: {
            class: 'form-control',
            description: 'themeTabAppAppTextNewsDescription',
            label: 'themeTabAppAppTextNewsLabel',
            model: null,
            type: 'textarea'
          }
        },
        appFile: {
          'logo_navbar.png': {
            currentImgSrc: this.getImageSrc('logo_navbar.png'),
            description: 'themeTabAppAppFileNavbarDescription',
            isLocal: false,
            label: 'themeTabAppAppFileNavbarLabel',
            name: 'logo_navbar.png',
            selectedFileName: ''
          }
        },
        settingsText: {
          product_name: {
            class: 'form-control',
            description: 'themeTabGeneralSettingsTextProductNameDescription',
            label: 'themeTabGeneralSettingsTextProductNameLabel',
            model: null,
            placeholder: 'themeTabGeneralSettingsTextProductNamePlaceholder',
            validate: {}
          },
          primary_color: {
            class: 'form-control',
            description: 'themeTabGeneralSettingsTextPrimaryColorDescription',
            label: 'themeTabGeneralSettingsTextPrimaryColorLabel',
            model: null,
            placeholder: 'themeTabGeneralSettingsTextPrimaryColorPlaceholder',
            type: 'colorpicker',
            validate: {
              rules: {
                required: true
              }
            }
          }
        },
        settingsFile: {
          'logo.png': {
            currentImgSrc: this.getImageSrc('logo.png'),
            description: 'themeTabGeneralSettingsFileDescription',
            isLocal: false,
            label: 'themeTabGeneralSettingsFileLabel',
            name: 'logo.png',
            selectedFileName: ''
          }
        },
        emailBasicText: {
          company_name: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextCompanyNameDescription',
            label: 'themeTabEmailEmailBasicTextCompanyNameLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextCompanyNamePlaceholder',
            validate: {}
          },
          company_url: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextCompanyUrlDescription',
            label: 'themeTabEmailEmailBasicTextCompanyUrlLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextCompanyUrlPlaceholder',
            validate: {}
          },
          company_address: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextCompanyAddressDescription',
            label: 'themeTabEmailEmailBasicTextCompanyAddressLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextCompanyAddressPlaceholder',
            validate: {}
          },
          company_contact: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextCompanyContactDescription',
            label: 'themeTabEmailEmailBasicTextCompanyContactLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextCompanyContactPlaceholder',
            validate: {}
          },
          apple_store: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextAppleStoreDescription',
            label: 'themeTabEmailEmailBasicTextAppleStoreLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextAppleStorePlaceholder',
            validate: {}
          },
          google_play: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextGooglePlayDescription',
            label: 'themeTabEmailEmailBasicTextGooglePlayLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextGooglePlayPlaceholder',
            validate: {}
          },
          app_name: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextAppNameDescription',
            label: 'themeTabEmailEmailBasicTextAppNameLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextAppNamePlaceholder',
            validate: {}
          },
          app_url_scheme: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextAppUrlSchemeDescription',
            label: 'themeTabEmailEmailBasicTextAppUrlSchemeLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextAppUrlSchemePlaceholder',
            validate: {}
          },
          support_email_account: {
            class: 'form-control',
            description: 'themeTabEmailEmailBasicTextSupportEmailAccountDescription',
            label: 'themeTabEmailEmailBasicTextSupportEmailAccountLabel',
            model: null,
            placeholder: 'themeTabEmailEmailBasicTextSupportEmailAccountPlaceholder',
            validate: {}
          }
        },
        emailTemplateText: {
          welcome_email_subject: {
            class: 'form-control',
            label: 'themeTabEmailEmailTemplateTextWelcomeEmailSubjectLabel',
            model: null,
            placeholder: 'themeTabEmailEmailTemplateTextWelcomeEmailSubjectPlaceholder',
            validate: {}
          },
          welcome_email_headline: {
            class: 'form-control',
            label: 'themeTabEmailEmailTemplateTextWelcomeEmailHeadlineLabel',
            model: null,
            placeholder: 'themeTabEmailEmailTemplateTextWelcomeEmailHeadlinePlaceholder',
            validate: {}
          },
          welcome_email_body: {
            class: 'form-control',
            label: 'themeTabEmailEmailTemplateTextWelcomeEmailBodyLabel',
            model: null,
            placeholder: 'themeTabEmailEmailTemplateTextWelcomeEmailBodyPlaceholder',
            validate: {}
          },
          welcome_web_headline: {
            class: 'form-control',
            label: 'themeTabEmailEmailTemplateTextWelcomeWebHeadlineLabel',
            model: null,
            placeholder: 'themeTabEmailEmailTemplateTextWelcomeWebHeadlinePlaceholder',
            validate: {}
          },
          welcome_web_body: {
            class: 'form-control',
            label: 'themeTabEmailEmailTemplateTextWelcomeWebBodyLabel',
            model: null,
            placeholder: 'themeTabEmailEmailTemplateTextWelcomeWebBodyPlaceholder',
            validate: {}
          }
        },
        ClaimDevicesTemplateText: {
          claim_web_headline: {
            class: 'form-control',
            label: 'themeTabEmailClaimDevicesTemplateTextClaimDeviceTitleLabel',
            model: null,
            placeholder: 'themeTabEmailClaimDevicesTemplateTextClaimDeviceTitlePlaceholder',
            validate: {}
          },
          claim_web_body: {
            class: 'form-control',
            label: 'themeTabEmailClaimDevicesTemplateTextClaimDeviceBodyLabel',
            model: null,
            placeholder: 'themeTabEmailClaimDevicesTemplateTexttClaimDeviceBodyPlaceholder',
            type: 'textarea',
            validate: {}
          }
        },
        emailSenderText: {
          connection_server: {
            class: 'form-control',
            label: 'themeTabEmailEmailSenderTextConnectionServerLabel',
            model: null,
            placeholder: 'themeTabEmailEmailSenderTextConnectionServerPlaceholder',
            validate: {}
          },
          connection_user: {
            class: 'form-control',
            label: 'themeTabEmailEmailSenderTextConnectionUserLabel',
            model: null,
            placeholder: 'themeTabEmailEmailSenderTextConnectionUserPlaceholder',
            validate: { regex: /^[^\s-]+$/ }
          },
          connection_password: {
            class: 'form-control',
            label: 'themeTabEmailEmailSenderTextConnectionPasswordLabel',
            model: null,
            placeholder: 'themeTabEmailEmailSenderTextConnectionPasswordPlaceholder',
            type: 'password',
            validate: { regex: /^[^\t\r\n\f-]*$/, required: true }
          },
          connection_scheme: {
            class: 'form-control',
            label: 'themeTabEmailEmailSenderTextConnectionSchemeLabel',
            model: null,
            placeholder: 'themeTabEmailEmailSenderTextConnectionSchemePlaceholder',
            validate: { regex: /(smtp|smtps)$/ }
          },
          connection_port: {
            class: 'form-control',
            label: 'themeTabEmailEmailSenderTextConnectionPortLabel',
            model: null,
            placeholder: 'themeTabEmailEmailSenderTextConnectionPortPlaceholder',
            type: 'number',
            validate: 'numeric'
          }
        },
        legalPoliciesText: {
          title: {
            class: 'form-control',
            description: 'themeTabLegalLegalPoliciesTextTitleDescription',
            label: 'themeTabLegalLegalPoliciesTextTitleLabel',
            model: null,
            placeholder: 'themeTabLegalLegalPoliciesTextTitlePlaceholder',
            type: 'text',
            validate: { required: true }
          },
          body: {
            class: 'form-control',
            description: 'themeTabLegalLegalPoliciesTextBodyDescription',
            label: 'themeTabLegalLegalPoliciesTextBodyLabel',
            model: null,
            type: 'textarea',
            validate: { required: true }
          }
        }
      },
      muranoTermsUrl: 'https://exosite.com/murano-terms-conditions/',
      legalUrl: window.location.origin + '/#/legal',
      loading: true
    };
  },
  mounted: function mounted() {
    return this.getTheme();
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    failedCallback: function failedCallback(error) {
      this.saving = false;
      __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* helper */].showErrorMessage(this, this.component, error);
    },
    fieldType: function fieldType(type) {
      return type || 'text';
    },
    isText: function isText(type) {
      return this.fieldType(type) === 'text';
    },
    isTextarea: function isTextarea(type) {
      return this.fieldType(type) === 'textarea';
    },
    successCallback: function successCallback() {
      this.saving = false;
      this.$message({
        message: this.$t('messageLegalSave'),
        showClose: true,
        type: 'success'
      });
    },
    submit: function submit() {
      var _this = this;

      return this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.updateLegal();
        }
      });
    },
    updateLegal: function updateLegal() {
      var _this2 = this;

      this.saving = true;
      var text = this.data.text;
      var data = {};
      for (var key in text) {
        data[key] = text[key].model;
      }

      return this.$api.updateLegal(data).then(function () {
        return _this2.successCallback();
      }, function (e) {
        return _this2.failedCallback(e);
      });
    }
  },
  name: 'ThemeLegal',
  props: {
    loading: { default: true, type: Boolean },
    text: { type: Object, required: true },
    title: String
  },
  data: function data() {
    return {
      component: 'themeLegal',
      data: {
        text: this.text
      },
      labelWidth: '200px',
      saving: false
    };
  }
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    failedCallback: function failedCallback(error) {
      this.saving = false;

      __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* helper */].showErrorMessage(this, this.component, error);

      for (var key in this.data.file) {
        this.data.file[key].isLocal = false;
      }
    },
    fieldType: function fieldType(type) {
      return type || 'text';
    },
    isColorPicker: function isColorPicker(type) {
      return this.fieldType(type) === 'colorpicker';
    },
    isNumber: function isNumber(type) {
      return this.fieldType(type) === 'number';
    },
    isPassword: function isPassword(type) {
      return this.fieldType(type) === 'password';
    },
    isText: function isText(type) {
      return this.fieldType(type) === 'text';
    },
    isTextarea: function isTextarea(type) {
      return this.fieldType(type) === 'textarea';
    },
    onFileChange: function onFileChange(id, e) {
      var fileList = e.target.files;

      var invalid = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.some(fileList, function (file) {
        return !file.type.match('image');
      });
      if (invalid) e.target.value = '';

      var fileExist = !!(fileList && fileList[0]);
      var currentFileName = fileExist && fileList[0].name ? fileList[0].name : '';
      var field = this.data.file[id];

      if (fileExist) {
        field.selectedFileName = currentFileName;
        var reader = new FileReader();
        reader.onload = function () {
          field.currentImgSrc = reader.result;
        };
        reader.readAsDataURL(fileList[0]);
      }
    },
    removeImage: function removeImage(id) {
      this.data.file[id].currentImgSrc = null;
      this.data.file[id].isLocal = true;
      this.data.file[id].selectedFileName = '';
    },
    successCallback: function successCallback() {
      this.saving = false;
      this.$message({
        message: this.$t('themeViewThemeSavedSuccessMessage'),
        showClose: true,
        type: 'success'
      });

      for (var key in this.data.file) {
        this.data.file[key].isLocal = !this.data.file[key].currentImgSrc;
      }
    },
    submit: function submit(e) {
      var _this = this;

      return this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.data.text.hasOwnProperty('connection_user') ? _this.updateEmailSettings(_this.data.text) : _this.updateTheme(e);
        }
      });
    },
    updateEmailSettings: function updateEmailSettings(textFields) {
      var _this2 = this;

      this.saving = true;
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(textFields).reduce(function (acc, curr) {
        acc[curr] = textFields[curr].model;
        return acc;
      }, {});
      return this.$api.updateServiceConfig('email', data).then(function () {
        return _this2.successCallback();
      }, function (e) {
        return _this2.failedCallback(e);
      });
    },
    updateTheme: function updateTheme(e) {
      var _this3 = this;

      this.saving = true;
      var formData = __WEBPACK_IMPORTED_MODULE_2__utils__["c" /* form */].getFormData(e);

      return this.$api.updateTheme(formData).then(function () {
        return _this3.successCallback();
      }, function (e) {
        return _this3.failedCallback(e);
      });
    },
    whenImageNotFound: function whenImageNotFound(id) {
      this.data.file[id].currentImgSrc = null;
      this.data.file[id].isLocal = true;
    }
  },
  name: 'ThemeView',
  props: {
    file: Object,
    loading: { default: true, type: Boolean },
    text: { type: Object, required: true },
    title: String
  },
  data: function data() {
    return {
      component: 'themeView',
      data: {
        file: this.file,
        text: this.text
      },
      labelWidth: '200px',
      saving: false
    };
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TimelineModel_TimelineModel_vue__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TimelineModel_TimelineModel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TimelineModel_TimelineModel_vue__);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: { TimelineModel: __WEBPACK_IMPORTED_MODULE_5__TimelineModel_TimelineModel_vue___default.a },
  methods: {
    getLogs: function getLogs() {
      var _this = this;

      var query = {
        args: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
          tags: this.tagsFormat(this.target),
          metrics: ['from', 'ip', 'log', 'log_type'],
          limit: 5,
          start_time: this.startTime
        })
      };

      return this.$api.getLogs(query).then(function (_ref) {
        var data = _ref.data;
        return _this.showList(data);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* helper */].showErrorMessage(_this, _this.component, error);
        _this.lists = [];
      });
    },
    openTimelineModel: function openTimelineModel() {
      __WEBPACK_IMPORTED_MODULE_4__utils__["b" /* bus */].$emit('show-timeline-model', {
        target: this.target
      });
    },
    showList: function showList(_ref2) {
      var _this2 = this;

      var columns = _ref2.columns,
          values = _ref2.values;

      if (!this.lists) {
        this.lists = [];
      }

      var logs = values.map(function (value) {
        var item = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.zipObject(columns, value);
        var action = void 0;

        try {
          action = JSON.parse(item.log);
        } catch (error) {
          __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* helper */].showErrorMessage(_this2, _this2.component, error);
          action = {};
        }

        return {
          action: action,
          from: item.from,
          ip: item.ip,
          type: item.log_type,
          status: _this2.viewLogInfo(item.status),
          time: item.time,
          identity: _this2.target
        };
      });

      this.lists = this.lists.concat(logs);

      return logs;
    },
    tagsFormat: function tagsFormat(target) {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(target, '@') ? { email: target, log_type: 'event' } : { device_unique_id: target };
    },
    viewLogInfo: function viewLogInfo(status) {
      var data = {};
      __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(status, function (value, key) {
        data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, data, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, value));
      });

      return data;
    }
  },
  name: 'Timeline',
  props: {
    showEventFilter: {
      default: false,
      type: Boolean
    },
    target: {
      type: [String, Number]
    },
    fields: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    target: function target(newStates) {
      this.lists = null;
      if (newStates) {
        this.getLogs();
      }
    }
  },
  data: function data() {
    return {
      component: 'timeline',
      lists: null,
      startTime: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* helper */].parseStartTime(this.$store.state.dataRetention),
      status: {}
    };
  },
  mounted: function mounted() {
    if (this.target) {
      this.getLogs();
    }
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(7);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TimelineLog',
  computed: {
    isEmpty: function isEmpty() {
      return Array.isArray(this.logList) && __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(this.logList);
    }
  },
  data: function data() {
    return {
      hasLocation: {},
      status: {}
    };
  },

  methods: {
    getGeoIP: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.memoize(function (ip) {
      return this.$api.getGeoip(ip);
    }),
    getLogs: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.memoize(function (time, identity, fields) {
      var query = {
        args: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
          tags: this.tagsFormat(identity),
          metrics: fields,
          limit: 1,
          end_time: +new Date(time) + 1,
          fill: 'previous'
        })
      };
      return this.$api.getLogs(query);
    }),
    getDevice: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.memoize(function (identity) {
      return this.$api.getDevices({ identity: identity });
    }),
    getInfo: function getInfo(index, identity, time, ip, deviceID) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var fields, location, logs, regionName, countryName, content, indexStatus;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fields = _this.fields;

                if (!(_this.$route.name === 'User List')) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return _this.getDevice(deviceID).then(function (_ref) {
                  var body = _ref.body;
                  return body.devices[0].fields;
                });

              case 4:
                fields = _context.sent;

              case 5:
                _context.next = 7;
                return _this.getGeoIP(ip);

              case 7:
                location = _context.sent;
                _context.next = 10;
                return _this.getLogs(time, identity, fields).then(function (_ref2) {
                  var body = _ref2.body;
                  return __WEBPACK_IMPORTED_MODULE_5_lodash___default()(body.columns).zipObject(body.values[0]).omit('time').mapValues(function (value) {
                    return value == null ? '--' : value;
                  }).value();
                });

              case 10:
                logs = _context.sent;


                _this.hasLocation[index] = {
                  regionName: location.region_name,
                  countryName: location.country_name,
                  content: logs
                };

                regionName = _this.hasLocation[index].regionName;
                countryName = _this.hasLocation[index].countryName;
                content = _this.hasLocation[index].content;
                indexStatus = {
                  countryName: countryName,
                  ip: ip,
                  content: content,
                  regionName: regionName
                };


                _this.status = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this.status, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, index, indexStatus));

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getMatchedOperator: function getMatchedOperator(op) {
      if (!op) {
        console.error('Operation is required.');
      }

      var operators = {
        eq: '=',
        gt: '>',
        geq: '≥',
        lt: '<',
        leq: '≤',
        neq: '≠'
      };

      if (!operators[op]) {
        console.error('No matched operation found.');
      }
      return operators[op];
    },
    getConditionStatus: function getConditionStatus(conditions) {
      var _this2 = this;

      var result = conditions.map(function (_ref3) {
        var key = _ref3.key,
            op = _ref3.op,
            target = _ref3.target;
        return '' + key + _this2.getMatchedOperator(op) + target;
      }).join(', ');

      return '(' + result + ')';
    },
    getContent: function getContent(action) {
      var content = action.content,
          notification = action.notification;

      if (content) {
        return content;
      } else if (notification) {
        return notification.title;
      }

      return '';
    },
    hideModel: function hideModel() {
      __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* bus */].$emit('hide-timeline-model');
    },
    fromWhom: function fromWhom(_ref4) {
      var action = _ref4.action;
      var path = this.$route.path;

      if (path.includes('/device')) {
        return action.email;
      }
      if (path.includes('/user')) {
        return action.device_unique_id || action.sn;
      }
      return '';
    },
    logType: function logType(type) {
      var tag = {
        debug: {
          color: 'info',
          label: this.$t('LogType.DEBUG')
        },
        error: {
          color: 'danger',
          label: this.$t('LogType.ERROR')
        },
        event: {
          color: 'success',
          label: this.$t('LogType.EVENT')
        }
      };
      return tag[type];
    },
    moreMessage: function moreMessage(action) {
      return 'key' in action ? '(' + action.key + ': ' + action.value + ')' : 'value' in action ? '(' + action.value + ')' : '';
    },
    navigate: function navigate(_ref5) {
      var action = _ref5.action;
      var path = this.$route.path;

      if (path.includes('/device')) {
        return '/user/' + action.email;
      }
      if (path.includes('/user')) {
        var id = action.device_unique_id || action.sn;
        return '/device/' + id;
      }
      return '';
    },
    tagsFormat: function tagsFormat(target) {
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.includes(target, '@') ? { email: target, log_type: 'event' } : { device_id: target };
    }
  },
  props: {
    fields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    logList: {
      required: true
    }
  }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(7);








/* harmony default export */ __webpack_exports__["a"] = ({
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* bus */].$off('hide-timeline-model');
    __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* bus */].$off('show-timeline-model');
  },

  methods: {
    changeFilterType: function changeFilterType() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.reset();
                _context.next = 3;
                return _this.infiniteScrollCallback();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    closePopup: function closePopup() {
      __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* bus */].$emit('hide-timeline-model');
    },
    getLogs: function getLogs() {
      var _this2 = this;

      this.isLoading = true;

      var query = {
        args: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
          tags: this.tagsFormat(this.target),
          metrics: ['from', 'ip', 'log', 'log_type'],
          limit: 20,
          start_time: this.startTime,
          end_time: this.lastLogTime
        })
      };

      return this.$api.getLogs(query).then(function (_ref) {
        var data = _ref.data;
        return _this2.showList(data);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* helper */].showErrorMessage(_this2, _this2.component, error);

        _this2.isLoading = false;
        _this2.lists = [];
      });
    },
    infiniteScrollCallback: function infiniteScrollCallback() {
      var _this3 = this;

      this.infiniteScrollDisabled = true;
      return this.getLogs().then(function (logs) {
        if (logs.length) {
          _this3.infiniteScrollDisabled = false;
        }
      });
    },
    reset: function reset() {
      this.isLoading = false;
      this.isNoMore = false;
      this.lastLogTime = undefined;
      this.lists = null;
    },
    showList: function showList(_ref2) {
      var _this4 = this;

      var columns = _ref2.columns,
          values = _ref2.values;

      this.isLoading = false;

      if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(values)) {
        this.isNoMore = true;
      }

      if (!this.lists) {
        this.lists = [];
      }

      var logs = values.map(function (value) {
        var item = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.zipObject(columns, value);
        var action = void 0;

        try {
          action = JSON.parse(item.log);
        } catch (error) {
          __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* helper */].showErrorMessage(_this4, _this4.component, error);
          action = {};
        }

        return {
          action: action,
          from: item.from,
          ip: item.ip,
          type: item.log_type,
          status: _this4.viewLogInfo(item.status),
          time: item.time,
          identity: _this4.target
        };
      });

      this.lists = this.lists.concat(logs);

      var lastLog = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.last(this.lists);
      this.lastLogTime = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.has(lastLog, 'time') ? new Date(lastLog.time).toJSON() : '';

      return logs;
    },
    tagsFormat: function tagsFormat(target) {
      if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.includes(target, '@')) {
        return { email: target, log_type: 'event' };
      }
      return this.filterType === 'all' ? { device_unique_id: target } : { device_unique_id: target, log_type: this.filterType };
    },
    viewLogInfo: function viewLogInfo(status) {
      var data = {};
      __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.forEach(status, function (value, key) {
        data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, data, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, value));
      });

      return data;
    }
  },
  name: 'TimelineModel',
  props: {
    fields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showEventFilter: {
      default: false,
      type: Boolean
    }
  },
  data: function data() {
    var _this5 = this;

    return {
      component: 'timelineModel',
      dialogProps: {
        beforeClose: function beforeClose() {
          return _this5.closePopup();
        },
        width: '70%'
      },
      headerSelectFilter: [{
        text: 'timelineFilterLabelAllText',
        dataQA: 'Dialog-TimelineModel-Filter-Option-All',
        value: 'all'
      }, {
        text: 'timelineFilterLabelErrorText',
        dataQA: 'Dialog-TimelineModel-Filter-Option-Error',
        value: 'error'
      }, {
        text: 'timelineFilterLabelDebugText',
        dataQA: 'Dialog-TimelineModel-Filter-Option-Debug',
        value: 'debug'
      }],
      filterType: 'all',
      infiniteScrollDisabled: false,
      isLoading: false,
      isNoMore: false,
      lastLogTime: undefined,
      lists: null,
      showModal: false,
      startTime: __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* helper */].parseStartTime(this.$store.state.dataRetention)
    };
  },
  mounted: function mounted() {
    var _this6 = this;

    __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* bus */].$on('show-timeline-model', function (data) {
      _this6.showModal = true;
      _this6.filterType = 'all';
      _this6.reset();

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_this6, __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.pick(data, ['target']));

      _this6.infiniteScrollCallback();
    });

    __WEBPACK_IMPORTED_MODULE_6__utils__["b" /* bus */].$on('hide-timeline-model', function () {
      _this6.showModal = false;
    });

    if (!this.showModal) {
      this.infiniteScrollDisabled = false;
    }
  }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserDelete_UserDelete_vue__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserDelete_UserDelete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UserDelete_UserDelete_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserInfo_UserInfo_vue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserInfo_UserInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__UserInfo_UserInfo_vue__);










/* harmony default export */ __webpack_exports__["a"] = ({
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* bus */].$off('update-deleted-user-list');
  },

  components: { UserDelete: __WEBPACK_IMPORTED_MODULE_6__UserDelete_UserDelete_vue___default.a, UserInfo: __WEBPACK_IMPORTED_MODULE_7__UserInfo_UserInfo_vue___default.a },
  computed: {
    componentTitle: function componentTitle() {
      return this.$t('ComponentTitle.' + this.$route.name);
    },
    showPagination: function showPagination() {
      return !!this.userList.length;
    }
  },
  methods: {
    convertTime: function convertTime(ms) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__filters__["a" /* formatDate */])(ms);
    },
    deleteUser: function deleteUser(id, email) {
      __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* bus */].$emit('show-delete-user', {
        show: true,
        info: { id: id, email: email }
      });
    },
    getCurrentPageUser: function getCurrentPageUser(pageNumber) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.pagination.offset = _this.pagination.limit * (pageNumber - 1);
                _context.next = 3;
                return _this.getUsers(_this.searchQuery);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getTotal: function getTotal() {
      var _this2 = this;

      var query = { fields: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(['users']) };
      return this.$api.getTotal(query).then(function (ret) {
        return ret.data;
      }).catch(function () {
        return {};
      }).then(function (total) {
        _this2.total = total;
      });
    },
    getUserInfo: function getUserInfo(id) {
      var _this3 = this;

      this.isLoadingInfo = true;

      return this.$api.getUser({ id: id }).then(function (res) {
        _this3.userInfo = res.data;
        _this3.isLoadingInfo = false;
      });
    },
    getUsers: function getUsers() {
      var _this4 = this;

      var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.isLoading = true;

      var query = { limit: this.pagination.limit, offset: this.pagination.offset };

      if (email.trim()) {
        query.filter = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ email: email });
      }

      return this.$api.getUsers(query).then(function (res) {
        return _this4.showList(res.data);
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* helper */].showErrorMessage(_this4, _this4.component, error);
      });
    },
    handleExpand: function handleExpand(row, expanded) {
      var _this5 = this;

      var arr = [];
      expanded.forEach(function (_ref) {
        var id = _ref.id;

        var alreadyIn = _this5.expanded.indexOf(id) !== -1;
        if (!alreadyIn) {
          _this5.getUserInfo(id);
          arr.push(id);
        }
      });

      this.expanded = arr;
      return expanded;
    },
    getRowKey: function getRowKey(row) {
      return row.id;
    },
    showList: function showList(users) {
      var _this6 = this;

      this.isLoading = false;
      this.searchedTotal = users.total;

      this.userList = users.items.map(function (user) {
        _this6.isToggle[user.email] = false;
        user.creation_date = user.creation_date * 1000;
        return user;
      });

      return users;
    },
    toggleRowExpansion: function toggleRowExpansion(row) {
      var expandRow = this.expanded.some(function (id) {
        return row.id === id;
      });
      var expandedArray = expandRow ? [] : [row];

      this.handleExpand(row, expandedArray);
    },
    userSearch: function userSearch(email) {
      this.pagination.currentPage = 1;
      this.userList = [];
      this.expanded = [];
      this.pagination.offset = 0;
      this.userInfo = undefined;

      this.getUsers(email);
    }
  },
  name: 'User',
  created: function created() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this7.getTotal(), _this7.getUsers(_this7.searchQuery)]);

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this7);
    }))();
  },
  data: function data() {
    return {
      component: 'user',
      expanded: [],
      isLoading: false,
      isLoadingInfo: false,
      isToggle: {},
      pagination: {
        currentPage: 1,
        layout: 'prev, pager, next',
        limit: 50,
        offset: 0
      },
      searchedTotal: 0,
      searchQuery: this.$route.params.email || '',
      total: {},
      userInfo: undefined,
      userList: []
    };
  },
  mounted: function mounted() {
    var _this8 = this;

    __WEBPACK_IMPORTED_MODULE_5__utils__["b" /* bus */].$on('update-deleted-user-list', function (id) {
      var index = _this8.userList.findIndex(function (user) {
        return user.id === id;
      });
      _this8.userList.splice(index, 1);
      _this8.total.users -= 1;
    });
  }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["a"] = ({
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$off('show-delete-user');
  },

  computed: {
    email: function email() {
      return this.info.email;
    }
  },
  methods: {
    closePopup: function closePopup() {
      this.showModal = false;
    },
    deleteUser: function deleteUser(id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.removeUser(id).then(function () {
                  return __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$emit('update-deleted-user-list', id);
                }).catch(function (error) {
                  return new Error('Failed to delete user, please try again later (Error: ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(error) + ')');
                });

              case 2:
                return _context.abrupt('return', _context.sent);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  name: 'UserDelete',
  data: function data() {
    var _this2 = this;

    return {
      buttons: [{
        id: 'Close',
        class: 'btn-close',
        text: 'userDeleteDialogButtonCloseText',
        type: 'text',
        click: function click() {
          _this2.closePopup();
        }
      }, {
        id: 'Delete',
        text: 'userDeleteDialogButtonDeleteText',
        type: 'warning',
        click: function click() {
          _this2.deleteUser(_this2.info.id);
          _this2.closePopup();
        }
      }],
      dialogProps: {
        beforeClose: function beforeClose() {
          return _this2.closePopup();
        }
      },
      info: {},
      showModal: false
    };
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_3__utils__["b" /* bus */].$on('show-delete-user', function (_ref) {
      var show = _ref.show,
          info = _ref.info;

      if (show) {
        _this3.showModal = true;
      }

      if (info) {
        _this3.info = info;
      }
    });
  }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Timeline_Timeline_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Timeline_Timeline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Timeline_Timeline_vue__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserInfo',
  components: { timeLine: __WEBPACK_IMPORTED_MODULE_0__Timeline_Timeline_vue___default.a },
  computed: {
    devices: function devices() {
      return this.user.devices || [];
    },
    devicesCount: function devicesCount() {
      return this.devices.length || 0;
    },
    groups: function groups() {
      return this.user.groups || [];
    },
    groupsCount: function groupsCount() {
      return this.groups.length || 0;
    }
  },
  methods: {
    getGroupName: function getGroupName(group) {
      return group.properties && group.properties.displayName || group.name;
    }
  },
  props: {
    loading: {
      default: false,
      type: Boolean
    },
    user: {
      default: function _default() {
        return { devices: [], groups: [] };
      },
      type: Object
    }
  }
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export config */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(500);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var config = {
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store(config));

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  RESET_PWD_DONE: function RESET_PWD_DONE(state, done) {
    state.resetPwdDone = done;
  },
  SET_DATA_RETENTION: function SET_DATA_RETENTION(state, time) {
    state.dataRetention = time;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_USER: function SET_USER(state, user) {
    state.user = user;
  }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  dataRetention: '',
  resetPwdDone: false,
  token: null,
  user: ''
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  getFormData: function getFormData(e) {
    if (e.type !== 'submit') throw new Error('not a submit event');

    var elements = e.currentTarget ? e.currentTarget.elements : e.srcElement.elements;
    var formData = new FormData();
    __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(elements, function (dom) {
      switch (dom.type) {
        case 'hidden':
          formData.append(dom.name, dom.value);
          break;
        case 'text':
        case 'textarea':
          formData.append(dom.id, dom.value);
          break;
        case 'file':
          __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(dom.files, function (file) {
            return formData.append(dom.id, file);
          });
          break;
      }
    });
    return formData;
  },
  getJsonFormData: function getJsonFormData(formData) {
    if (!formData) return undefined;

    var obj = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(formData.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var pair = _step.value;

        var key = pair[0];
        var value = pair[1];
        obj[key] = value;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj);
  }
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Company_js__ = __webpack_require__(455);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Company_js__["a" /* default */]);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Confirmation_js__ = __webpack_require__(456);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Confirmation_js__["a" /* default */]);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Legal_js__ = __webpack_require__(457);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Legal_js__["a" /* default */]);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logo_js__ = __webpack_require__(458);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Logo_js__["a" /* default */]);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Reset_js__ = __webpack_require__(459);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Reset_js__["a" /* default */]);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Welcome_js__ = __webpack_require__(460);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Welcome_js__["a" /* default */]);

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_js__ = __webpack_require__(462);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__App_js__["a" /* default */]);

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dash_js__ = __webpack_require__(463);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Dash_js__["a" /* default */]);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Device_js__ = __webpack_require__(464);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Device_js__["a" /* default */]);

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DeviceInfo_js__ = __webpack_require__(466);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__DeviceInfo_js__["a" /* default */]);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DeviceInfoBoxes_js__ = __webpack_require__(467);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__DeviceInfoBoxes_js__["a" /* default */]);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DeviceLock_js__ = __webpack_require__(468);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__DeviceLock_js__["a" /* default */]);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dialog_js__ = __webpack_require__(469);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Dialog_js__["a" /* default */]);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Export_js__ = __webpack_require__(470);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Export_js__["a" /* default */]);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Firmware_js__ = __webpack_require__(471);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Firmware_js__["a" /* default */]);

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FirmwareDelete_js__ = __webpack_require__(472);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__FirmwareDelete_js__["a" /* default */]);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FirmwareUpload_js__ = __webpack_require__(473);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__FirmwareUpload_js__["a" /* default */]);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InfoBox_js__ = __webpack_require__(474);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__InfoBox_js__["a" /* default */]);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InformationModel_js__ = __webpack_require__(475);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__InformationModel_js__["a" /* default */]);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InformationModelDelete_js__ = __webpack_require__(476);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__InformationModelDelete_js__["a" /* default */]);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InformationModelImagesUpload_js__ = __webpack_require__(477);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__InformationModelImagesUpload_js__["a" /* default */]);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InformationModelUpload_js__ = __webpack_require__(478);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__InformationModelUpload_js__["a" /* default */]);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Login_js__ = __webpack_require__(479);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Login_js__["a" /* default */]);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotFound_js__ = __webpack_require__(480);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__NotFound_js__["a" /* default */]);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Notifications_js__ = __webpack_require__(481);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Notifications_js__["a" /* default */]);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotificationsCreate_js__ = __webpack_require__(482);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__NotificationsCreate_js__["a" /* default */]);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotificationsDelete_js__ = __webpack_require__(484);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__NotificationsDelete_js__["a" /* default */]);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotificationsEdit_js__ = __webpack_require__(485);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__NotificationsEdit_js__["a" /* default */]);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ResetPassword_js__ = __webpack_require__(487);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__ResetPassword_js__["a" /* default */]);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar_js__ = __webpack_require__(488);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Sidebar_js__["a" /* default */]);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SolutionStatusTest_js__ = __webpack_require__(489);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__SolutionStatusTest_js__["a" /* default */]);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Theme_js__ = __webpack_require__(490);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Theme_js__["a" /* default */]);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemeLegal_js__ = __webpack_require__(491);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__ThemeLegal_js__["a" /* default */]);

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemeView_js__ = __webpack_require__(492);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__ThemeView_js__["a" /* default */]);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Timeline_js__ = __webpack_require__(493);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Timeline_js__["a" /* default */]);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TimelineLog_js__ = __webpack_require__(494);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__TimelineLog_js__["a" /* default */]);

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TimelineModel_js__ = __webpack_require__(495);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__TimelineModel_js__["a" /* default */]);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__User_js__ = __webpack_require__(496);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__User_js__["a" /* default */]);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserDelete_js__ = __webpack_require__(497);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__UserDelete_js__["a" /* default */]);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserInfo_js__ = __webpack_require__(498);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__UserInfo_js__["a" /* default */]);

/***/ }),
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 836 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 837 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 839 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 841 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 847 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 855 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 856 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 859 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 860 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 861 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 863 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 864 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 865 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 866 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 867 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 868 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 869 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 268,
	"./af.js": 268,
	"./ar": 275,
	"./ar-dz": 269,
	"./ar-dz.js": 269,
	"./ar-kw": 270,
	"./ar-kw.js": 270,
	"./ar-ly": 271,
	"./ar-ly.js": 271,
	"./ar-ma": 272,
	"./ar-ma.js": 272,
	"./ar-sa": 273,
	"./ar-sa.js": 273,
	"./ar-tn": 274,
	"./ar-tn.js": 274,
	"./ar.js": 275,
	"./az": 276,
	"./az.js": 276,
	"./be": 277,
	"./be.js": 277,
	"./bg": 278,
	"./bg.js": 278,
	"./bm": 279,
	"./bm.js": 279,
	"./bn": 280,
	"./bn.js": 280,
	"./bo": 281,
	"./bo.js": 281,
	"./br": 282,
	"./br.js": 282,
	"./bs": 283,
	"./bs.js": 283,
	"./ca": 284,
	"./ca.js": 284,
	"./cs": 285,
	"./cs.js": 285,
	"./cv": 286,
	"./cv.js": 286,
	"./cy": 287,
	"./cy.js": 287,
	"./da": 288,
	"./da.js": 288,
	"./de": 291,
	"./de-at": 289,
	"./de-at.js": 289,
	"./de-ch": 290,
	"./de-ch.js": 290,
	"./de.js": 291,
	"./dv": 292,
	"./dv.js": 292,
	"./el": 293,
	"./el.js": 293,
	"./en-au": 294,
	"./en-au.js": 294,
	"./en-ca": 295,
	"./en-ca.js": 295,
	"./en-gb": 296,
	"./en-gb.js": 296,
	"./en-ie": 297,
	"./en-ie.js": 297,
	"./en-il": 298,
	"./en-il.js": 298,
	"./en-nz": 299,
	"./en-nz.js": 299,
	"./eo": 300,
	"./eo.js": 300,
	"./es": 303,
	"./es-do": 301,
	"./es-do.js": 301,
	"./es-us": 302,
	"./es-us.js": 302,
	"./es.js": 303,
	"./et": 304,
	"./et.js": 304,
	"./eu": 305,
	"./eu.js": 305,
	"./fa": 306,
	"./fa.js": 306,
	"./fi": 307,
	"./fi.js": 307,
	"./fo": 308,
	"./fo.js": 308,
	"./fr": 311,
	"./fr-ca": 309,
	"./fr-ca.js": 309,
	"./fr-ch": 310,
	"./fr-ch.js": 310,
	"./fr.js": 311,
	"./fy": 312,
	"./fy.js": 312,
	"./gd": 313,
	"./gd.js": 313,
	"./gl": 314,
	"./gl.js": 314,
	"./gom-latn": 315,
	"./gom-latn.js": 315,
	"./gu": 316,
	"./gu.js": 316,
	"./he": 317,
	"./he.js": 317,
	"./hi": 318,
	"./hi.js": 318,
	"./hr": 319,
	"./hr.js": 319,
	"./hu": 320,
	"./hu.js": 320,
	"./hy-am": 321,
	"./hy-am.js": 321,
	"./id": 322,
	"./id.js": 322,
	"./is": 323,
	"./is.js": 323,
	"./it": 324,
	"./it.js": 324,
	"./ja": 325,
	"./ja.js": 325,
	"./jv": 326,
	"./jv.js": 326,
	"./ka": 327,
	"./ka.js": 327,
	"./kk": 328,
	"./kk.js": 328,
	"./km": 329,
	"./km.js": 329,
	"./kn": 330,
	"./kn.js": 330,
	"./ko": 331,
	"./ko.js": 331,
	"./ky": 332,
	"./ky.js": 332,
	"./lb": 333,
	"./lb.js": 333,
	"./lo": 334,
	"./lo.js": 334,
	"./lt": 335,
	"./lt.js": 335,
	"./lv": 336,
	"./lv.js": 336,
	"./me": 337,
	"./me.js": 337,
	"./mi": 338,
	"./mi.js": 338,
	"./mk": 339,
	"./mk.js": 339,
	"./ml": 340,
	"./ml.js": 340,
	"./mn": 341,
	"./mn.js": 341,
	"./mr": 342,
	"./mr.js": 342,
	"./ms": 344,
	"./ms-my": 343,
	"./ms-my.js": 343,
	"./ms.js": 344,
	"./mt": 345,
	"./mt.js": 345,
	"./my": 346,
	"./my.js": 346,
	"./nb": 347,
	"./nb.js": 347,
	"./ne": 348,
	"./ne.js": 348,
	"./nl": 350,
	"./nl-be": 349,
	"./nl-be.js": 349,
	"./nl.js": 350,
	"./nn": 351,
	"./nn.js": 351,
	"./pa-in": 352,
	"./pa-in.js": 352,
	"./pl": 353,
	"./pl.js": 353,
	"./pt": 355,
	"./pt-br": 354,
	"./pt-br.js": 354,
	"./pt.js": 355,
	"./ro": 356,
	"./ro.js": 356,
	"./ru": 357,
	"./ru.js": 357,
	"./sd": 358,
	"./sd.js": 358,
	"./se": 359,
	"./se.js": 359,
	"./si": 360,
	"./si.js": 360,
	"./sk": 361,
	"./sk.js": 361,
	"./sl": 362,
	"./sl.js": 362,
	"./sq": 363,
	"./sq.js": 363,
	"./sr": 365,
	"./sr-cyrl": 364,
	"./sr-cyrl.js": 364,
	"./sr.js": 365,
	"./ss": 366,
	"./ss.js": 366,
	"./sv": 367,
	"./sv.js": 367,
	"./sw": 368,
	"./sw.js": 368,
	"./ta": 369,
	"./ta.js": 369,
	"./te": 370,
	"./te.js": 370,
	"./tet": 371,
	"./tet.js": 371,
	"./tg": 372,
	"./tg.js": 372,
	"./th": 373,
	"./th.js": 373,
	"./tl-ph": 374,
	"./tl-ph.js": 374,
	"./tlh": 375,
	"./tlh.js": 375,
	"./tr": 376,
	"./tr.js": 376,
	"./tzl": 377,
	"./tzl.js": 377,
	"./tzm": 379,
	"./tzm-latn": 378,
	"./tzm-latn.js": 378,
	"./tzm.js": 379,
	"./ug-cn": 380,
	"./ug-cn.js": 380,
	"./uk": 381,
	"./uk.js": 381,
	"./ur": 382,
	"./ur.js": 382,
	"./uz": 384,
	"./uz-latn": 383,
	"./uz-latn.js": 383,
	"./uz.js": 384,
	"./vi": 385,
	"./vi.js": 385,
	"./x-pseudo": 386,
	"./x-pseudo.js": 386,
	"./yo": 387,
	"./yo.js": 387,
	"./zh-cn": 388,
	"./zh-cn.js": 388,
	"./zh-hk": 389,
	"./zh-hk.js": 389,
	"./zh-tw": 390,
	"./zh-tw.js": 390
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 893;

/***/ }),
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(860)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(981),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b9ce85e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(853)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(975),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d2297a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(866)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(986),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-effde368",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(865)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(985),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-da63dc1c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(861)
  __webpack_require__(862)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(982),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c6d40b64",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(848)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(970),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5e016e8a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(838)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(960),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f7d554a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(829)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(951),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-060cb10a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(863)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(983),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d0fa5c14",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(835)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(957),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-228b80ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(857)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(516),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8e6fbdec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(856)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(978),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8df1e0ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(846)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(968),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4c00632a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(858)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(979),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-99e9af6c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(842)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(964),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40e4118a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(852)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(974),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7ac9a686",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(833)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(955),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-18d7e16a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(849)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(971),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-60f8c30a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(832)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(954),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-161ea40a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(836)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(958),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-23b4224a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(840)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(962),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-337eee44",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(869)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(989),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fccb24ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(843)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(965),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-41e58ac8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(854)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(976),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7f7edb94",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(830)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(952),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0cad4f1c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(839)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(961),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-31d04220",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(867)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(987),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f44db540",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(864)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(984),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d7c9512c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(831)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(953),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-157624c4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(847)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(969),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56d06cec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(868)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(988),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f6e18a30",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(834)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(956),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-202b2f92",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(841)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(963),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-37f2c0c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(859)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(980),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a7474bac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(845)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(967),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-49427dca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('time-line', {
    attrs: {
      "showEventFilter": true,
      "target": _vm.identity,
      "fields": _vm.fields
    }
  }), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": _vm.$t('deviceInfoCardHeader'),
      "data-qa": "Content-DeviceInfo-Card-Users"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('deviceInfoLabelOwnerText')))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(_vm._s(_vm.owner))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('deviceInfoLabelGuestsText')))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, _vm._l((_vm.guests), function(guest, index) {
    return _c('div', {
      key: index
    }, [_vm._v(_vm._s(guest))])
  }))], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-DeleteNotification-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('notificationsDeleteDialogTitle')))]), _vm._v(" "), _c('span', {
    attrs: {
      "data-qa": "Dialog-DeleteNotification-ConfirmText"
    }
  }, [_vm._v(_vm._s(_vm.$t('notificationsDeleteDialogConfirmText')))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('el-button', {
    staticClass: "btn-close",
    attrs: {
      "data-qa": "Dialog-DeleteNotification-Button-Close",
      "type": "text"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('notificationsDeleteDialogButtonCancelText')) + "\n    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading,
      "loading": _vm.loading,
      "data-qa": "Dialog-DeleteNotification-Button-Delete",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.deleteNotification(_vm.id)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('notificationsDeleteDialogButtonDeleteText')) + "\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "primary-header"
  }, [_c('h1', {
    attrs: {
      "data-qa": "Content-Theme-Title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.componentTitle) + "\n      "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])])]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "value": _vm.tabValue
    },
    on: {
      "tab-click": _vm.setUrl
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "data-qa": "Content-Theme-TabContent-General",
      "name": "general"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label",
      "data-qa": "Content-Theme-Tab-General"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('themeTabGeneralText')))]), _vm._v(" "), _c('theme-view', {
    attrs: {
      "file": _vm.fieldsData.settingsFile,
      "loading": _vm.loading,
      "text": _vm.fieldsData.settingsText
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "data-qa": "Content-Theme-TabContent-App",
      "name": "app"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label",
      "data-qa": "Content-Theme-Tab-App"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('themeTabAppText')))]), _vm._v(" "), _c('theme-view', {
    attrs: {
      "file": _vm.fieldsData.appFile,
      "loading": _vm.loading,
      "text": _vm.fieldsData.appText
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "data-qa": "Content-Theme-TabContent-Email",
      "name": "email"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label",
      "data-qa": "Content-Theme-Tab-Email"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('themeTabEmailText')))]), _vm._v(" "), _c('theme-view', {
    attrs: {
      "loading": _vm.loading,
      "text": _vm.fieldsData.emailBasicText,
      "title": _vm.$t('themeThemeViewBasicSettingsTitle'),
      "data-qa": "Content-Theme-Tab-Email-Basic_Settings"
    }
  }), _vm._v(" "), _c('theme-view', {
    attrs: {
      "loading": _vm.loading,
      "text": _vm.fieldsData.emailTemplateText,
      "title": _vm.$t('themeThemeViewWelcomeTemplateTitle'),
      "data-qa": "Content-Theme-Tab-Email-Welcome_Template"
    }
  }), _vm._v(" "), _c('theme-view', {
    attrs: {
      "loading": _vm.loading,
      "text": _vm.fieldsData.ClaimDevicesTemplateText,
      "title": _vm.$t('themeThemeViewClaimDevicesTemplateTitle'),
      "data-qa": "Content-Theme-Tab-Email-Claim_Devices_Template"
    }
  }), _vm._v(" "), _c('theme-view', {
    attrs: {
      "loading": _vm.loading,
      "text": _vm.fieldsData.emailSenderText,
      "title": _vm.$t('themeThemeViewSenderConfigureTitle'),
      "data-qa": "Content-Theme-Tab-Email-Email_Settings"
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "data-qa": "Content-Theme-TabContent-Legal",
      "name": "legal"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label",
      "data-qa": "Content-Theme-Tab-Legal"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('themeTabLegalText')))]), _vm._v(" "), _c('div', {
    staticClass: "bs-callout"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('themeTabLegalContentTitle')))]), _vm._v(" "), _c('i18n', {
    attrs: {
      "path": "themeTabLegalContentBody",
      "tag": "p"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.legalUrl,
      "place": "legalUrl",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.legalUrl))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.muranoTermsUrl,
      "place": "muranoTermsUrl",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('themeTabLegalToSText')))])])], 1), _vm._v(" "), _c('theme-legal', {
    attrs: {
      "loading": _vm.loading,
      "text": _vm.fieldsData.legalPoliciesText,
      "title": _vm.$t('themeThemeViewLegalPoliciesTitle')
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-UploadInformationModelImages-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('informationModelImagesUploadDialogTitle')))]), _vm._v(" "), _c('el-form', {
    ref: "data",
    attrs: {
      "model": _vm.data,
      "id": "uploadform",
      "enctype": "multipart/form-data",
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, _vm._l((_vm.fieldsData), function(field, key) {
    return _c('el-form-item', {
      key: key,
      attrs: {
        "data-qa": ("Dialog-UploadInformationModelImagesUpload-" + key),
        "label-width": _vm.labelWidth,
        "label": field.label
      }
    }, [_c('div', {
      staticClass: "image-block"
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (field.currentImgSrc),
        expression: "field.currentImgSrc"
      }],
      attrs: {
        "src": field.currentImgSrc,
        "height": "34"
      },
      on: {
        "error": function($event) {
          _vm.whenImageNotFound(key)
        }
      }
    }), _vm._v(" "), _c('input', _vm._b({
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (field.validate),
        expression: "field.validate"
      }],
      staticClass: "input-file",
      attrs: {
        "id": field.name,
        "name": field.name,
        "accept": "image/png, image/gif, image/jpg, image/jpeg",
        "data-qa": ("Dialog-UploadInformationModelImages" + key + "-UploadImage"),
        "type": "file"
      },
      on: {
        "change": function($event) {
          _vm.filesChange(key, $event.target.name, $event.target.files)
        }
      }
    }, 'input', field.model, false)), _vm._v(" "), _c('label', {
      staticClass: "el-button el-button--default",
      attrs: {
        "for": field.name
      }
    }, [_vm._v(_vm._s(_vm.$t('informationModelImagesUploadButtonUploadImageText')))]), _vm._v(" "), (field.isLocal || !field.uri) ? _c('div', {
      staticClass: "selected-file-name"
    }, [_vm._v(_vm._s(field.selectedFileName))]) : _vm._e(), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (field.uri && !field.isLocal),
        expression: "field.uri && !field.isLocal"
      }],
      attrs: {
        "data-qa": ("Dialog-UploadInformationModelImages" + key + "-RemoveImage")
      },
      on: {
        "click": function($event) {
          _vm.removeImage(key, field.name)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('informationModelImagesUploadButtonRemoveImageText')) + "\n        ")])], 1), _vm._v(" "), (_vm.errors.has(field.name)) ? _c('div', {
      staticClass: "help is-danger"
    }, [_vm._v("\n        " + _vm._s(_vm.errors.first(field.name)) + "\n      ")]) : _vm._e(), _vm._v(" "), (!field.isValidImageSize) ? _c('div', {
      staticClass: "help is-warning"
    }, [_vm._v("\n        " + _vm._s(field.imageErrorMsg) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "column-describe",
      attrs: {
        "data-qa": ("Content-UploadInformationModelImages" + key + "-Description")
      }
    }, [(field.uri) ? _c('p', [_vm._v(_vm._s(field.uri))]) : _vm._e(), _vm._v(" "), _c('i', [_vm._v(_vm._s(field.description))])])])
  })), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('el-button', {
    staticClass: "btn-close",
    attrs: {
      "data-qa": "Dialog-UploadInformationModelImages-Button-Cancel",
      "type": "text"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('informationModelImagesUploadDialogButtonCloseText')) + "\n    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading || _vm.errors.any(),
      "loading": _vm.loading,
      "data-qa": "Dialog-UploadInformationModelImages-Button-Save",
      "type": "warning"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('informationModelImagesUploadDialogButtonSaveText')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "primary-header"
  }, [_c('h1', {
    attrs: {
      "data-qa": "Content-InfomationModel-Title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.componentTitle) + "\n      "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "data-qa": "Content-AddInfomationModel-Button",
      "type": "warning",
      "id": "btn-im-form"
    },
    on: {
      "click": _vm.addInformationModal
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('informationModelButtonAddInfomationModelText')) + "\n    ")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "im-table",
    attrs: {
      "element-loading-text": _vm.$t('informationModelTableLoadingText'),
      "data": _vm.informationModels,
      "default-sort": _vm.defaultSort,
      "data-qa": "Content-InformationModel-Table",
      "element-loading-background": "#FFFFFF",
      "fit": "",
      "header-row-class-name": "im-table__header",
      "max-height": "100%",
      "show-header": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('informationModelTableColFamilyNameLabel'),
      "prop": "index",
      "sortable": "",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('informationModelTableColFileNameLabel'),
      "prop": "name",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('informationModelTableColModelImageLabel'),
      "prop": "informationModel",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.hasNoImages(scope.row.informationModel)) ? _c('el-button', {
          attrs: {
            "data-qa": ("Content-InformationModel-UploadImages-" + (scope.row.index)),
            "size": "medium"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.showSetImagePopup(scope.row.informationModel, false)
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$t('informationModelButtonUploadImagesText')) + "\n        ")]) : _c('div', {
          staticClass: "edit-image"
        }, [(_vm.getImageSrc(scope.row.informationModel)) ? _c('img', {
          attrs: {
            "src": _vm.getImageSrc(scope.row.informationModel),
            "height": "34"
          }
        }) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "data-qa": ("Content-InformationModel-EditImages-" + (scope.row.index)),
            "size": "medium"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.showSetImagePopup(scope.row.informationModel, true)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('informationModelButtonEditImagesText')) + "\n          ")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('informationModelTableColLastModifiedLabel'),
      "prop": "timestamp",
      "sortable": "",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(_vm._f("formatDate")(scope.row.formatedDate)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('informationModelTableColActionLabel'),
      "fixed": "right",
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": _vm.$t('informationModelTooltipDownloadText'),
            "placement": "top-start"
          }
        }, [_c('a', {
          staticClass: "el-button el-button--mini el-button--text",
          attrs: {
            "data-qa": ("Content-DownloadInformationModel-Button-" + (scope.row.index)),
            "download": scope.row.name,
            "href": scope.row.downloadLink,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-download fa-2 operation-icons"
        })])]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": _vm.$t('informationModelTooltipDeleteText'),
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "data-qa": 'Content-DeleteInformationModel-Button-' + scope.row.index,
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.removeInformationModel(scope.row.index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash fa-2 operation-icons"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('information-model-delete'), _vm._v(" "), _c('information-model-images-upload'), _vm._v(" "), _c('information-model-upload')], 1)
},staticRenderFns: []}

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-qa": "Content-TimelineLog-Body"
    }
  }, [_vm._l((_vm.logList), function(item, index) {
    return _c('el-row', {
      key: index,
      staticClass: "log-list",
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "data-qa": ("Content-TimelineLogType-Column-" + index),
        "span": 3
      }
    }, [_c('el-tag', {
      attrs: {
        "type": _vm.logType(item.type).color
      }
    }, [_vm._v(_vm._s(_vm.logType(item.type).label))])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "data-qa": ("Content-TimelineLogDescribe-Column-" + index),
        "span": 10
      }
    }, [_c('b', [_vm._v(_vm._s(item.action.label))]), (item.action.content || item.action.notification) ? _c('b', [_vm._v(": ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getContent(item.action)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.moreMessage(item.action)))]), _vm._v(" "), (item.action.conditions) ? _c('span', [_vm._v(_vm._s(_vm.getConditionStatus(item.action.conditions)))]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "from-who",
      attrs: {
        "data-qa": ("Content-TimelineLogFromWho-Link-" + index),
        "to": _vm.navigate(item),
        "replace": ""
      },
      on: {
        "click": function($event) {
          _vm.hideModel()
        }
      }
    }, [_vm._v(_vm._s(_vm.fromWhom(item)))])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "data-qa": ("Content-TimelineLogViewInfo-Column-" + index),
        "span": 4
      }
    }, [(_vm.status[index]) ? _c('el-tooltip', {
      attrs: {
        "placement": "top"
      }
    }, [_c('div', {
      staticClass: "status-tooltip",
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [(item.type !== 'debug') ? _c('el-row', [_c('el-col', [_c('b', [_vm._v(_vm._s(_vm.$t('timelineLogTooltipLocationText')) + ": " + _vm._s(_vm.status[index].regionName) + ", " + _vm._s(_vm.status[index].countryName) + " (" + _vm._s(_vm.status[index].ip) + ")")])])], 1) : _vm._e(), _vm._v(" "), _c('el-row', _vm._l((_vm.status[index].content), function(value, key) {
      return _c('el-col', {
        key: key,
        attrs: {
          "span": 6
        }
      }, [_vm._v("\n              " + _vm._s(key) + ": " + _vm._s(value) + "\n            ")])
    }))], 1), _vm._v(" "), _c('a', {
      staticClass: "view-info",
      attrs: {
        "data-qa": ("Content-TimelineLogViewInfo-Link-" + index)
      },
      on: {
        "mouseover": function($event) {
          _vm.getInfo(index, item.identity, item.time, item.ip, item.action.device_unique_id)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('timelineLogLinkViewInfoText')) + "\n        ")])]) : _c('a', {
      staticClass: "view-info",
      attrs: {
        "data-qa": ("Content-TimelineLogViewInfo-Link-" + index)
      },
      on: {
        "mouseover": function($event) {
          _vm.getInfo(index, item.identity, item.time, item.ip, item.action.device_unique_id)
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$t('timelineLogLinkViewInfoText')) + "\n      ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "data-qa": ("Content-TimelineLogTime-Column-" + index),
        "span": 7
      }
    }, [_vm._v("\n      " + _vm._s(_vm._f("formatDate")(item.time)) + "\n    ")])], 1)
  }), _vm._v(" "), (_vm.isEmpty) ? _c('div', {
    staticClass: "empty-message",
    attrs: {
      "data-qa": "Content-TimelineLog-Empty"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('timelineLogEmptyMessage')) + "\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-DeleteDevice-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('deviceLockDialogTitle')))]), _vm._v(" "), _c('i18n', {
    attrs: {
      "path": "deviceLockDialogConfirmText",
      "data-qa": "Dialog-DeleteDevice-ConfirmText",
      "tag": "span"
    }
  }, [_c('el-tag', {
    attrs: {
      "place": "id",
      "type": "info"
    }
  }, [_vm._v(_vm._s(_vm.id))])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, _vm._l((_vm.buttons), function(button, index) {
    return _c('el-button', {
      key: index,
      class: button.class,
      attrs: {
        "data-qa": ("Dialog-DeleteDevice-Button-" + (button.id)),
        "type": button.type || 'warning'
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return button.click($event)
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.$t(button.text)) + "\n    ")])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-UploadInformationModel-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('informationModelUploadDialogTitle')))]), _vm._v(" "), _c('el-form', {
    ref: "data",
    attrs: {
      "model": _vm.data,
      "id": "uploadform",
      "enctype": "multipart/form-data",
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, _vm._l((_vm.fieldsData), function(field, key) {
    return _c('el-form-item', {
      key: key,
      attrs: {
        "data-qa": ("Dialog-UploadInformationModelUpload-" + key),
        "label-width": _vm.labelWidth,
        "label": field.label
      }
    }, [_c('div', {
      staticClass: "upload-block"
    }, [_c('input', _vm._b({
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (field.validate),
        expression: "field.validate"
      }],
      staticClass: "input-file",
      attrs: {
        "id": field.name,
        "name": field.name,
        "accept": ".json,.yaml,.yml",
        "data-qa": ("Dialog-UploadInformationModelUpload" + key + "-UploadField"),
        "multiple": "",
        "type": "file"
      },
      on: {
        "change": function($event) {
          _vm.filesChange(key, $event.target.name, $event.target.files)
        }
      }
    }, 'input', field.model, false)), _vm._v(" "), _c('label', {
      staticClass: "el-button el-button--default",
      attrs: {
        "for": field.name
      }
    }, [_vm._v(_vm._s(_vm.$t('informationModelUploadButtonUploadText')))]), _vm._v(" "), _c('div', {
      staticClass: "selected-file-name"
    }, [_vm._v(_vm._s(field.selectedFileName))])]), _vm._v(" "), (_vm.errors.has(field.name)) ? _c('div', {
      staticClass: "help is-danger"
    }, [_vm._v("\n        " + _vm._s(_vm.$t('informationModelUploadInputUploadError')) + "\n      ")]) : _vm._e()])
  })), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer-content"
    },
    slot: "footer-content"
  }, [_c('el-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alert$.show),
      expression: "alert$.show"
    }],
    attrs: {
      "closable": false,
      "type": _vm.alert$.type,
      "data-qa": "Dialog-UploadInformationModel-Alert",
      "show-icon": "",
      "title": ""
    }
  }, _vm._l((_vm.alert$.errors), function(error, index) {
    return _c('p', {
      key: index
    }, [_vm._v("\n        " + _vm._s(error) + "\n      ")])
  }))], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('el-button', {
    staticClass: "btn-close",
    attrs: {
      "data-qa": "Dialog-UploadInformationModel-Button-Close",
      "type": "text"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('informationModelUploadDialogButtonCloseText')) + "\n    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading || _vm.errors.any(),
      "loading": _vm.loading,
      "data-qa": "Dialog-UploadInformationModel-Button-Upload",
      "type": "warning"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('informationModelUploadDialogButtonUploadText')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.lists),
      expression: "!lists"
    }],
    attrs: {
      "data-qa": "Content-Timeline-Card"
    }
  }, [_c('div', {
    staticClass: "timeline-header",
    attrs: {
      "slot": "header",
      "data-qa": "Content-Timeline-Header"
    },
    slot: "header"
  }, [_c('span', {
    attrs: {
      "data-qa": "Content-TimelineHeader-Title"
    }
  }, [_vm._v(_vm._s(_vm.$t('timelineComponentTitle')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "data-qa": "Content-TimelineHeader-Button-ViewAll",
      "plain": "",
      "type": "primary"
    },
    on: {
      "click": _vm.openTimelineModel
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('timelineButtonViewAllText')) + "\n      ")])], 1), _vm._v(" "), _c('timeline-log', {
    attrs: {
      "log-list": _vm.lists,
      "fields": _vm.fields
    }
  })], 1), _vm._v(" "), _c('timeline-model', {
    attrs: {
      "showEventFilter": _vm.showEventFilter,
      "fields": _vm.fields
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "primary-header"
  }, [_c('h1', {
    attrs: {
      "data-qa": "Content-Device-Title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.componentTitle) + "\n      "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])])]), _vm._v(" "), _c('device-info-boxes', {
    attrs: {
      "total": _vm.total
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "device-search",
    attrs: {
      "placeholder": _vm.searchBarPlaceholder,
      "clearable": "",
      "type": "text",
      "disabled": _vm.isSearchBarDisabled
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.deviceSearch(_vm.searchQuery)
      }
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  }, [_c('el-select', {
    staticClass: "device-filter",
    attrs: {
      "slot": "prepend",
      "data-qa": "Device-Filter-Options",
      "placeholder": "Filter"
    },
    on: {
      "change": _vm.onSelectionChanged
    },
    slot: "prepend",
    model: {
      value: (_vm.selectedFilter),
      callback: function($$v) {
        _vm.selectedFilter = $$v
      },
      expression: "selectedFilter"
    }
  }, _vm._l((_vm.filterOptions), function(op) {
    return _c('el-option', {
      key: op.key,
      attrs: {
        "label": op.label,
        "value": op.value
      }
    })
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        _vm.deviceSearch(_vm.searchQuery)
      }
    },
    slot: "append"
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    ref: "deviceListTable",
    staticClass: "device-table",
    attrs: {
      "data": _vm.deviceList,
      "element-loading-text": _vm.$t('deviceTableLoadingText'),
      "expand-row-keys": _vm.expanded,
      "row-key": _vm.getRowKey,
      "data-qa": "Content-Device-Table",
      "element-loading-background": "#FFFFFF",
      "fit": "",
      "max-height": "100%",
      "row-class-name": "pointer",
      "show-header": ""
    },
    on: {
      "expand-change": _vm.handleExpand,
      "row-click": _vm.toggleRowExpansion,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    staticClass: "empty",
    attrs: {
      "slot": "empty",
      "min-width": "5"
    },
    slot: "empty"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('deviceTableEmptyMessageTitle')) + "\n      "), _c('i18n', {
    attrs: {
      "path": "deviceTableEmptyMessageBody",
      "tag": "p"
    }
  }, [_c('a', {
    attrs: {
      "place": "support",
      "href": "mailto:support@exosite.com"
    }
  }, [_vm._v("support@exosite.com")])])], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('device-info', {
          attrs: {
            "fields": props.row.fields,
            "guests": props.row.guest_emails,
            "identity": props.row.identity,
            "owner": props.row.owner_email
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "identity",
      "label": _vm.$t('deviceTableColSNLabel'),
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "model",
      "label": _vm.$t('deviceTableColModelLabel'),
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.getDeviceModel(scope.row.model)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "connected",
      "label": _vm.$t('deviceTableColConnectivityStatusLabel'),
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.getConnectedStatus(scope.row.connected) !== '--') ? _c('i', {
          class: _vm.getConnectedStatusIcon(scope.row.connected)
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getConnectedStatus(scope.row.connected)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "provisioned_time",
      "label": _vm.$t('deviceTableColProvisionedDateLabel'),
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.convertSecTime(scope.row.provisioned_time),
            "placement": "top-start"
          }
        }, [_c('span', {
          staticClass: "device-provisioned-date"
        }, [_vm._v(_vm._s(_vm.convertSecTime(scope.row.provisioned_time)))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "last_seen",
      "label": _vm.$t('deviceTableColLastSeenLabel'),
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.convertUsTime(scope.row.last_seen),
            "placement": "top-start"
          }
        }, [_c('span', {
          staticClass: "device-last-seen"
        }, [_vm._v(_vm._s(_vm.convertUsTime(scope.row.last_seen)))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "firmware_version",
      "label": _vm.$t('deviceTableColFirmwareVerLabel'),
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.locked) ? _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('deviceTooltipDeleteText'),
            "effect": "dark",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "data-qa": 'Content-LockDevice-Button-' + scope.row.identity,
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.confirmLock(scope.row.identity, scope.row.sn)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash fa-2 operation-icons"
        })])], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), (_vm.showPagination) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.pagination.currentPage,
      "disabled": _vm.isLoading,
      "layout": _vm.pagination.layout,
      "page-size": _vm.pagination.limit,
      "total": _vm.searchedTotal,
      "background": ""
    },
    on: {
      "update:currentPage": function($event) {
        _vm.$set(_vm.pagination, "currentPage", $event)
      },
      "current-change": _vm.getCurrentPageDevice
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('device-lock')], 1)
},staticRenderFns: []}

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-EditNotificationAdd-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('notificationsEditTitleEdit')))]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.gettingNotification),
      expression: "gettingNotification"
    }],
    ref: "data",
    attrs: {
      "model": _vm.data,
      "id": "editForm",
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.editNotification($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('familyName') ? _vm.errors.first('familyName') : '',
      "label": _vm.$t('notificationsEditInputFamilyNameLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('familyName'),
      "data-qa": "Dialog-EditNotificationFamilyName-Item"
    }
  }, [_c('el-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    staticClass: "full-width",
    attrs: {
      "placeholder": _vm.$t('notificationsEditInputFamilyNamePlaceholder'),
      "data-vv-as": _vm.$t('notificationsEditInputFamilyNamePlaceholder'),
      "data-qa": "Dialog-EditNotificationFamilyName-Select",
      "multiple": "",
      "name": "familyName",
      "required": ""
    },
    model: {
      value: (_vm.data.familyNames),
      callback: function($$v) {
        _vm.$set(_vm.data, "familyNames", $$v)
      },
      expression: "data.familyNames"
    }
  }, _vm._l((_vm.familyNames), function(name) {
    return _c('el-option', {
      key: name,
      attrs: {
        "label": name,
        "value": name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "column-describe",
    attrs: {
      "label-width": _vm.labelWidth,
      "data-qa": "Dialog-EditNotificationFamilyName-Description"
    }
  }, [_c('div', {
    staticClass: "fit-line-height"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('notificationsEditInputFamilyNameHint')))])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('ruleType') ? _vm.errors.first('ruleType') : '',
      "label": _vm.$t('notificationsEditInputRuleTypeLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('ruleType'),
      "data-qa": "Dialog-EditNotificationRuleType-Item"
    }
  }, [_c('el-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    staticClass: "full-width",
    attrs: {
      "placeholder": _vm.$t('notificationsEditInputRuleTypePlaceholder'),
      "data-qa": "Dialog-EditNotificationRuleType-Select",
      "name": "ruleType",
      "required": ""
    },
    model: {
      value: (_vm.data.ruleType),
      callback: function($$v) {
        _vm.$set(_vm.data, "ruleType", $$v)
      },
      expression: "data.ruleType"
    }
  }, _vm._l((_vm.ruleTypes), function(type) {
    return _c('el-option', {
      key: type.key,
      attrs: {
        "label": type.label,
        "value": type.value
      }
    })
  })), _vm._v(" "), (_vm.isStatusRule) ? _c('el-row', {
    staticClass: "status-rule-block",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('key') ? _vm.errors.first('key') : '',
      "show-message": false
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: _vm.validate.deviceKey
        }
      }),
      expression: "{ rules: { required: true, regex: validate.deviceKey } }"
    }],
    attrs: {
      "disabled": true,
      "placeholder": _vm.$t('notificationsEditInputKeyPlaceholder'),
      "clearable": "",
      "data-qa": "Dialog-EditNotificationRuleTypeConditionsKey-Input",
      "name": "key",
      "required": "",
      "type": "text"
    },
    model: {
      value: (_vm.data.conditions.key),
      callback: function($$v) {
        _vm.$set(_vm.data.conditions, "key", $$v)
      },
      expression: "data.conditions.key"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('operator') ? _vm.errors.first('operator') : '',
      "show-message": false
    }
  }, [_c('el-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    attrs: {
      "placeholder": _vm.$t('notificationsEditInputOperatorPlaceholder'),
      "data-qa": "Dialog-EditNotificationRuleTypeConditionsOperators-Select",
      "name": "operator",
      "required": ""
    },
    model: {
      value: (_vm.data.conditions.op),
      callback: function($$v) {
        _vm.$set(_vm.data.conditions, "op", $$v)
      },
      expression: "data.conditions.op"
    }
  }, _vm._l((_vm.operators), function(op) {
    return _c('el-option', {
      key: op.key,
      attrs: {
        "label": op.label,
        "value": op.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('target') ? _vm.errors.first('target') : '',
      "show-message": false
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          numeric: true
        }
      }),
      expression: "{ rules: { required: true, numeric: true } }"
    }],
    attrs: {
      "placeholder": _vm.$t('notificationsEditInputTargetPlaceholder'),
      "data-vv-as": _vm.$t('notificationsEditInputTargetPlaceholder'),
      "clearable": "",
      "data-qa": "Dialog-EditNotificationRuleTypeConditionsTarget-Input",
      "name": "target",
      "required": "",
      "type": "text"
    },
    model: {
      value: (_vm.data.conditions.target),
      callback: function($$v) {
        _vm.$set(_vm.data.conditions, "target", $$v)
      },
      expression: "data.conditions.target"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hasConditionsError) ? _c('div', {
    staticClass: "help is-danger conditions-error"
  }, [(_vm.errors.has('key')) ? _c('p', [_vm._v(_vm._s(_vm.$t('notificationsEditInputKeyError')))]) : _vm._e(), _vm._v(" "), (_vm.errors.has('operator')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('operator')))]) : _vm._e(), _vm._v(" "), (_vm.errors.has('target')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('target')))]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "column-describe",
    attrs: {
      "label-width": _vm.labelWidth,
      "data-qa": "Dialog-EditNotificationRuleType-Description"
    }
  }, [_c('div', {
    staticClass: "fit-line-height"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('notificationsEditInputRuleTypeHint')))])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('title') ? _vm.errors.first('title') : '',
      "label": _vm.$t('notificationsEditInputTitleLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('title'),
      "data-qa": "Dialog-EditNotificationTitle-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          max: 40
        }
      }),
      expression: "{ rules: { required: true, max: 40 } }"
    }],
    attrs: {
      "placeholder": _vm.$t('notificationsEditInputTitlePlaceholder'),
      "data-vv-as": _vm.$t('notificationsEditInputTitlePlaceholder'),
      "clearable": "",
      "data-qa": "Dialog-EditNotificationTitle-Input",
      "name": "title",
      "required": "",
      "type": "text"
    },
    model: {
      value: (_vm.data.title),
      callback: function($$v) {
        _vm.$set(_vm.data, "title", $$v)
      },
      expression: "data.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "column-describe",
    attrs: {
      "label-width": _vm.labelWidth,
      "data-qa": "Dialog-EditNotificationTitle-Description"
    }
  }, [_c('div', {
    staticClass: "fit-line-height"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('notificationsEditInputTitleHint1')))]), _c('br'), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.$t('notificationsEditInputTitleHint2')))])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('message') ? _vm.errors.first('message') : '',
      "label": _vm.$t('notificationsEditInputMessageLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('message'),
      "data-qa": "Dialog-EditNotificationMessage-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          max: 160
        }
      }),
      expression: "{ rules: { required: true, max: 160 } }"
    }],
    attrs: {
      "placeholder": _vm.$t('notificationsEditInputMessagePlaceholder'),
      "data-vv-as": _vm.$t('notificationsEditInputMessageLabel'),
      "clearable": "",
      "data-qa": "Dialog-EditNotificationMessage-Input",
      "name": "message",
      "required": "",
      "type": "text"
    },
    model: {
      value: (_vm.data.message),
      callback: function($$v) {
        _vm.$set(_vm.data, "message", $$v)
      },
      expression: "data.message"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "column-describe",
    attrs: {
      "label-width": _vm.labelWidth,
      "data-qa": "Dialog-EditNotificationMessage-Description"
    }
  }, [_c('div', {
    staticClass: "fit-line-height"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('notificationsEditInputMessageHint1')))]), _c('br'), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.$t('notificationsEditInputMessageHint2')))])])])], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('el-button', {
    staticClass: "btn-close",
    attrs: {
      "data-qa": "Dialog-EditNotification-Button-Close",
      "type": "text"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('notificationsEditDialogButtonCloseText')) + "\n    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading || _vm.errors.any(),
      "loading": _vm.loading,
      "data-qa": "Dialog-EditNotification-Button-Save",
      "type": "warning"
    },
    on: {
      "click": _vm.editNotification
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('notificationsEditDialogButtonSaveText')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-main', {
    staticClass: "login"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "data-qa": "Content-SigninLogo-Image",
      "src": "/src/assets/img/admin-logo.png"
    }
  }), _vm._v(" "), (_vm.resetPwdMsg) ? _c('el-col', {
    staticClass: "reset-pwd-msg",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "reset-title",
    attrs: {
      "data-qa": "Content-SigninResetPwdMsg-Title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('loginResetResponseTitle')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "reset-body",
    attrs: {
      "data-qa": "Content-SigninResetPwdMsg-Body"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('loginResetResponseMessage')) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "login-form",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('loginFormTitle')))]), _vm._v(" "), _c('el-form', {
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('email') ? _vm.errors.first('email') : '',
      "show-message": _vm.errors.has('email'),
      "prop": "email"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "placeholder": _vm.$t('loginInputEmailPlaceholder'),
      "clearable": "",
      "data-qa": "Content-SigninEmail-Input",
      "name": "email",
      "type": "text",
      "data-vv-as": _vm.$t('loginInputEmailPlaceholder')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.validateForm($event)
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-open email",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('password') ? _vm.errors.first('password') : '',
      "show-message": _vm.errors.has('password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8|max:20'),
      expression: "'required|min:8|max:20'"
    }],
    attrs: {
      "placeholder": _vm.$t('loginInputPasswordPlaceholder'),
      "clearable": "",
      "data-qa": "Content-SigninPassword-Input",
      "name": "password",
      "type": "password",
      "data-vv-as": _vm.$t('loginInputPasswordPlaceholder')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.validateForm($event)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }, [_c('i', {
    staticClass: "fa fa-unlock-alt password",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "disabled": _vm.loading || _vm.errors.any(),
      "loading": _vm.loading,
      "data-qa": "Content-Signin-Button",
      "id": "signIn",
      "type": "primary"
    },
    on: {
      "click": _vm.validateForm
    }
  }, [_vm._v(_vm._s(_vm.$t('loginButtonSignInText')))])], 1), _vm._v(" "), _c('a', {
    staticClass: "forgot-pwd",
    attrs: {
      "data-qa": "Content-SigninForgotPassword-Link",
      "type": "text"
    },
    on: {
      "click": _vm.forgetPwd
    }
  }, [_vm._v(_vm._s(_vm.$t('loginLinkForgotPasswordText')))])], 1)], 1), _vm._v(" "), (_vm.response) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-card', [_c('div', {
    attrs: {
      "slot": "header",
      "data-qa": "Content-SigninError-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('loginErrorResponseTitle')))]), _vm._v(" "), _c('div', {
    attrs: {
      "data-qa": "Content-SigninError-Body"
    }
  }, [_vm._v(_vm._s(_vm.response))])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.infiniteScrollCallback),
      expression: "infiniteScrollCallback"
    }],
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal,
      "infinite-scroll-disabled": "infiniteScrollDisabled",
      "infinite-scroll-distance": "20",
      "infinite-scroll-immediate-check": "true"
    }
  }, [_c('el-row', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-TimelineModel-Header"
    },
    slot: "header"
  }, [_c('el-col', {
    attrs: {
      "span": 8,
      "data-qa": "Dialog-TimelineModel-Title"
    }
  }, [_vm._v(_vm._s(_vm.$t('timelineComponentTitle')))]), _vm._v(" "), (_vm.showEventFilter) ? _c('el-col', {
    staticClass: "type-filter",
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "label": _vm.$t('timelineFilterPlaceholder'),
      "data-qa": "Dialog-TimelineModel-Filter-Select"
    },
    on: {
      "change": _vm.changeFilterType
    },
    model: {
      value: (_vm.filterType),
      callback: function($$v) {
        _vm.filterType = $$v
      },
      expression: "filterType"
    }
  }, _vm._l((_vm.headerSelectFilter), function(item) {
    return _c('el-option', {
      key: item.text,
      attrs: {
        "data-qa": item.dataQA,
        "label": _vm.$t(item.text),
        "value": item.value
      }
    })
  }))], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    attrs: {
      "data-qa": "Dialog-TimelineModel-Body"
    }
  }, [_c('timeline-log', {
    attrs: {
      "log-list": _vm.lists,
      "fields": _vm.fields
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-UploadFirmware-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('firmwareUploadDialogTitle')))]), _vm._v(" "), _c('el-form', {
    ref: "data",
    attrs: {
      "model": _vm.data,
      "id": "uploadform",
      "enctype": "multipart/form-data",
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.uploadFirmware($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('version') ? _vm.$t('firmwareUploadInputVersionError') : '',
      "label": _vm.$t('firmwareUploadInputVersionLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('version'),
      "data-qa": "Dialog-UploadFirmwareVersion-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: _vm.validate.semver
        }
      }),
      expression: "{ rules: { required: true, regex: validate.semver} }"
    }],
    attrs: {
      "placeholder": _vm.$t('firmwareUploadInputVersionPlaceholder'),
      "clearable": "",
      "data-qa": "Dialog-UploadFirmwareVersion-Input",
      "name": "version",
      "required": "",
      "type": "text"
    },
    model: {
      value: (_vm.data.version),
      callback: function($$v) {
        _vm.$set(_vm.data, "version", $$v)
      },
      expression: "data.version"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('previous') ? _vm.$t('firmwareUploadInputPreviousError') : '',
      "label": _vm.$t('firmwareUploadInputPreviousLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('previous'),
      "data-qa": "Dialog-UploadFirmwarePreVersion-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: _vm.validate.semver
        }
      }),
      expression: "{ rules: { required: true, regex: validate.semver} }"
    }],
    attrs: {
      "placeholder": _vm.$t('firmwareUploadInputPreviousPlaceholder'),
      "clearable": "",
      "data-qa": "Dialog-UploadFirmwarePreVersion-Input",
      "name": "previous",
      "required": "",
      "type": "text"
    },
    model: {
      value: (_vm.data.lastVersion),
      callback: function($$v) {
        _vm.$set(_vm.data, "lastVersion", $$v)
      },
      expression: "data.lastVersion"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('sha1') ? _vm.$t('firmwareUploadInputSHA1Error') : '',
      "label": _vm.$t('firmwareUploadInputSHA1Label'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('sha1'),
      "data-qa": "Dialog-UploadFirmwareSHA1-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: _vm.validate.sha1
        }
      }),
      expression: "{ rules: { required: true, regex: validate.sha1} }"
    }],
    attrs: {
      "placeholder": _vm.$t('firmwareUploadInputSHA1Label'),
      "clearable": "",
      "data-qa": "Dialog-UploadFirmwareSHA1-Input",
      "name": "sha1",
      "required": "",
      "type": "text"
    },
    model: {
      value: (_vm.data.sha1),
      callback: function($$v) {
        _vm.$set(_vm.data, "sha1", $$v)
      },
      expression: "data.sha1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('model') ? _vm.$t('firmwareUploadInputModelError') : '',
      "label": _vm.$t('firmwareUploadInputModelLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('model'),
      "data-qa": "Dialog-UploadFirmwareModel-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    attrs: {
      "placeholder": _vm.$t('firmwareUploadInputModelLabel'),
      "clearable": "",
      "data-qa": "Dialog-UploadFirmwareModel-Input",
      "name": "model",
      "required": "",
      "type": "text"
    },
    model: {
      value: (_vm.data.model),
      callback: function($$v) {
        _vm.$set(_vm.data, "model", $$v)
      },
      expression: "data.model"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('firmwareUploadInputTriggerLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('trigger'),
      "data-qa": "Dialog-UploadFirmwareTrigger-Item"
    }
  }, [_c('el-switch', {
    attrs: {
      "placeholder": _vm.$t('firmwareUploadInputTriggerLabel'),
      "clearable": "",
      "data-qa": "Dialog-UploadFirmwareTrigger-Input",
      "name": "trigger"
    },
    model: {
      value: (_vm.data.trigger),
      callback: function($$v) {
        _vm.$set(_vm.data, "trigger", $$v)
      },
      expression: "data.trigger"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('firmwareUploadInputImageLabel'),
      "label-width": _vm.labelWidth,
      "data-qa": "Dialog-UploadFirmwareImage-Item"
    }
  }, [_c('div', {
    staticClass: "upload-block"
  }, [_c('input', _vm._b({
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|size:4096'),
      expression: "'required|size:4096'"
    }],
    staticClass: "input-file",
    attrs: {
      "id": _vm.uploadFieldName,
      "name": _vm.uploadFieldName,
      "data-qa": "Dialog-UploadFirmwareImage-UploadField",
      "required": "",
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.name, $event.target.files)
      }
    }
  }, 'input', _vm.data.imgFile, false)), _vm._v(" "), _c('label', {
    staticClass: "el-button el-button--default",
    attrs: {
      "for": _vm.uploadFieldName
    }
  }, [_vm._v(_vm._s(_vm.$t('firmwareUploadInputUploadFieldNameLabel')))]), _vm._v(" "), _c('div', {
    staticClass: "selected-file-name"
  }, [_vm._v(_vm._s(_vm.getFileName))])]), _vm._v(" "), (_vm.errors.has(_vm.uploadFieldName)) ? _c('div', {
    staticClass: "help is-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('firmwareUploadTipImage')) + "\n      ")]) : _vm._e()])], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('el-button', {
    staticClass: "btn-close",
    attrs: {
      "data-qa": "Dialog-UploadFirmware-Button-Close",
      "type": "text"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('firmwareUploadDialogButtonCloseText')) + "\n    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading || _vm.errors.any(),
      "loading": _vm.loading,
      "data-qa": "Dialog-UploadFirmware-Button-Upload",
      "type": "warning"
    },
    on: {
      "click": _vm.uploadFirmware
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('firmwareUploadDialogButtonUploadText')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "primary-header"
  }, [_c('h1', {
    attrs: {
      "data-qa": "Content-Notifications-Title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.componentTitle) + "\n      "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), (!_vm.noQuotaBlockShows) ? _c('div', {
    staticClass: "create-new-block"
  }, [_c('span', {
    staticClass: "limitation",
    class: {
      alert: _vm.isRulesLimitReached
    },
    attrs: {
      "data-qa": "Content-LimitationNotifacations-Text"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('notificationsLimitationText', {
    ownRules: _vm.ownRules,
    limitRules: _vm.limitRules
  })) + "\n      ")]), _vm._v(" "), (_vm.canAddNotification) ? _c('el-button', {
    attrs: {
      "data-qa": "Content-AddNotification-Button",
      "id": "btn-notification-form",
      "type": "warning"
    },
    on: {
      "click": _vm.showAddNotification
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('notificationsButtonAddNotificationText')) + "\n      ")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (!_vm.noQuotaBlockShows) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "notifications-table",
    attrs: {
      "data": _vm.notificationsList,
      "default-sort": _vm.defaultSort,
      "element-loading-text": _vm.$t('notificationsTableLoadingText'),
      "empty-text": _vm.$t('notificationsTableEmptyText'),
      "data-qa": "Content-Notifications-Table",
      "element-loading-background": "#FFFFFF",
      "fit": "",
      "header-row-class-name": "notifications-table__header",
      "max-height": "100%",
      "show-header": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('notificationsTableColRuleLabel'),
      "prop": "rule",
      "sortable": "",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('notificationsTableColInfoModelLabel'),
      "sortable": "",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "word-break"
        }, [_vm._v(_vm._s(props.row.familyNames))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('notificationsTableColTitleLabel'),
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "word-break"
        }, [_vm._v(_vm._s(props.row.title))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('notificationsTableColMessageLabel'),
      "min-width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "word-break"
        }, [_vm._v(_vm._s(props.row.message))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "fixed": "right",
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('notificationsTooltipEditText'),
            "effect": "dark",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "data-qa": ("Content-EditNotification-Button-" + (scope.row.title)),
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.editNotification(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil operation-icons"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('notificationsTooltipDeleteText'),
            "effect": "dark",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "data-qa": ("Content-DeleteNotification-Button-" + (scope.row.title)),
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.delNotification(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash operation-icons"
        })])], 1)]
      }
    }])
  })], 1) : _c('div', {
    staticClass: "notify-limited-block",
    attrs: {
      "data-qa": "Content-LimitedBlockNotifications-Text"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('NotificationsLimitedBlockNotificationsTitle')) + "\n    ")]), _vm._v(" "), _c('i18n', {
    attrs: {
      "path": "NotificationsLimitedBlockNotificationsBody",
      "tag": "p"
    }
  }, [_c('br', {
    attrs: {
      "place": "br"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "place": "p"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:support@exosite.com",
      "place": "support"
    }
  }, [_vm._v(_vm._s(_vm.$t('solutionStatusTestDialogSupport')))])])], 1), _vm._v(" "), _c('notifications-edit', {
    attrs: {
      "familyMembers": _vm.familyMembers,
      "familyNames": _vm.familyNames,
      "uid": _vm.uid
    }
  }), _vm._v(" "), _c('notifications-delete'), _vm._v(" "), _c('notifications-create', {
    attrs: {
      "familyMembers": _vm.familyMembers,
      "familyNames": _vm.familyNames,
      "noQuota": _vm.isRulesLimitReached,
      "uid": _vm.uid
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-aside', {
    staticClass: "main-sidebar",
    class: _vm.expandWidth
  }, [_c('el-menu', {
    attrs: {
      "collapse": _vm.collapse
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('el-menu-item', {
    staticClass: "logo-item",
    attrs: {
      "data-qa": "SideBar-ProductName-MenuItem",
      "index": "logo"
    }
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": "/src/assets/img/logo-navbar.png",
      "alt": "Logo"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("ExoHome")])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/device"
    }
  }, [_c('el-menu-item', {
    class: _vm.showDevicesActive,
    attrs: {
      "data-qa": "SideBar-Devices-MenuItem",
      "index": "/device"
    }
  }, [_c('i', {
    staticClass: "fa fa-lightbulb-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('sidebarMenuDevices')))])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/user"
    }
  }, [_c('el-menu-item', {
    class: _vm.showUsersActive,
    attrs: {
      "data-qa": "SideBar-Users-MenuItem",
      "index": "/user"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('sidebarMenuUsers')))])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/firmware"
    }
  }, [_c('el-menu-item', {
    class: _vm.showFirmwareActive,
    attrs: {
      "data-qa": "SideBar-Firmware-MenuItem",
      "index": "/firmware"
    }
  }, [_c('i', {
    staticClass: "fa fa-folder",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('sidebarMenuFirmware')))])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/theme"
    }
  }, [_c('el-menu-item', {
    class: _vm.showThemeActive,
    attrs: {
      "data-qa": "SideBar-Theme-MenuItem",
      "index": "/theme"
    }
  }, [_c('i', {
    staticClass: "fa fa-magic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('sidebarMenuTheme')))])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/informationModel"
    }
  }, [_c('el-menu-item', {
    class: _vm.showIMActive,
    attrs: {
      "data-qa": "SideBar-InformationModel-MenuItem",
      "index": "/informationModel"
    }
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('sidebarMenuInformationModel')))])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/notifications"
    }
  }, [_c('el-menu-item', {
    class: _vm.showNotifyActive,
    attrs: {
      "data-qa": "SideBar-Notifications-MenuItem",
      "index": "/notifications"
    }
  }, [_c('i', {
    staticClass: "fa fa-comment",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('sidebarMenuNotifications')))])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/export"
    }
  }, [_c('el-menu-item', {
    class: _vm.showExportActive,
    attrs: {
      "data-qa": "SideBar-Export-MenuItem",
      "index": "/export"
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('sidebarMenuExport')))])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-DeleteUser-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('userDeleteDialogTitle')))]), _vm._v(" "), _c('i18n', {
    attrs: {
      "path": "userDeleteDialogConfirmText",
      "data-qa": "Dialog-DeleteUser-ConfirmText",
      "tag": "span"
    }
  }, [_c('el-tag', {
    attrs: {
      "place": "email",
      "type": "info"
    }
  }, [_vm._v(_vm._s(_vm.email))])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, _vm._l((_vm.buttons), function(button, index) {
    return _c('el-button', {
      key: index,
      class: button.class,
      attrs: {
        "data-qa": ("Dialog-DeleteUser-Button-" + (button.id)),
        "type": button.type || 'warning'
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return button.click($event)
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.$t(button.text)) + "\n    ")])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "primary-header"
  }, [_c('h1', {
    attrs: {
      "data-qa": "Content-Firmware-Title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.componentTitle) + "\n      "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "data-qa": "Content-AddFirmware-Button",
      "id": "btn-firmware-form",
      "type": "warning"
    },
    on: {
      "click": _vm.showAddFirmware
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('firmwareButtonAddFirmwareText')) + "\n    ")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "firmware-table",
    attrs: {
      "data": _vm.firmwareList,
      "default-sort": _vm.defaultSort,
      "element-loading-text": _vm.$t('firmwareTableLoadingText'),
      "data-qa": "Content-Firmware-Table",
      "element-loading-background": "#FFFFFF",
      "fit": "",
      "header-row-class-name": "firmware-table__header",
      "max-height": "100%",
      "show-header": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('firmwareTableColVersionLabel'),
      "prop": "version",
      "sortable": "",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('firmwareTableColPreviousVersionLabel'),
      "prop": "previousVersion",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('firmwareTableColSHA1Label'),
      "prop": "sha1",
      "min-width": "320"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('firmwareTableColModelLabel'),
      "prop": "model",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('firmwareTableColSizeLabel'),
      "prop": "size",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('firmwareTableColTriggerLabel'),
      "prop": "trigger",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "disabled": "true",
            "value": !!scope.row.trigger
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "fixed": "right",
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('firmwareTooltipDownloadText'),
            "effect": "dark",
            "placement": "top-start"
          }
        }, [_c('a', {
          staticClass: "el-button el-button--mini el-button--text",
          attrs: {
            "data-qa": ("Content-DownloadFirmware-Button-" + (scope.row.index)),
            "href": scope.row.url
          }
        }, [_c('i', {
          staticClass: "fa fa-download fa-2 operation-icons"
        })])]), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('firmwareTooltipDeleteText'),
            "effect": "dark",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "data-qa": 'Content-DeleteFirmware-Button-' + scope.row.index,
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.delFirmware(_vm.firmwareList[scope.row.index])
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash fa-2 operation-icons"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('firmware-delete'), _vm._v(" "), _c('firmware-upload')], 1)
},staticRenderFns: []}

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "theme-block"
  }, [(_vm.title) ? _c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "data",
    attrs: {
      "element-loading-text": _vm.$t('themeLegalFormLoadingText'),
      "model": _vm.data,
      "id": "updateForm",
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.data.text), function(item, id) {
    return _c('el-form-item', {
      key: id,
      attrs: {
        "data-qa": ("Content-ThemeForm-Item-" + id),
        "error": _vm.errors.has(item.label) ? _vm.errors.first(item.label) : '',
        "label": _vm.$t(item.label),
        "label-width": _vm.labelWidth,
        "show-message": _vm.errors.has(item.label)
      }
    }, [(_vm.isText(item.type)) ? _c('el-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (item.validate),
        expression: "item.validate"
      }],
      attrs: {
        "data-qa": ("Content-ThemeForm-Input-" + id),
        "data-vv-as": _vm.$t(item.label),
        "id": id,
        "name": item.label,
        "placeholder": _vm.$t(item.placeholder) || '',
        "clearable": "",
        "type": "text"
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isTextarea(item.type)) ? _c('el-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (item.validate),
        expression: "item.validate"
      }],
      class: item.class,
      attrs: {
        "data-qa": ("Content-ThemeForm-Textarea-" + id),
        "data-vv-as": _vm.$t(item.label),
        "id": id,
        "name": item.label,
        "placeholder": _vm.$t(item.placeholder) || '',
        "rows": 20,
        "type": "textarea"
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }) : _vm._e(), _vm._v(" "), (item.description) ? _c('div', {
      staticClass: "column-describe",
      attrs: {
        "data-qa": ("Content-ThemeForm-Description-" + id)
      }
    }, [_c('i', [_vm._v(_vm._s(_vm.$t(item.description)))])]) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "btn-display-end",
    attrs: {
      "size": "large"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.saving || _vm.errors.any(),
      "loading": _vm.saving,
      "data-qa": "Content-ThemeForm-Button-Save",
      "native-type": "submit",
      "type": "warning"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('themeLegalButtonSaveText')) + "\n      ")])], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('el-container') : _c('el-container', [_c('sidebar', {
    attrs: {
      "collapse": _vm.isCollapse
    }
  }), _vm._v(" "), _c('el-container', {
    staticClass: "wrapper"
  }, [_c('el-header', [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-button', {
    staticClass: "menu-btn",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": function($event) {
        _vm.isCollapse = !_vm.isCollapse
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "lang-selection",
    attrs: {
      "span": 6,
      "hide-on-click": false
    }
  }, [(_vm.isAnalyticsEnabled) ? _c('a', {
    staticClass: "analytics-link",
    attrs: {
      "href": _vm.analytics.href,
      "data-qa": "Header-Analytics-Link",
      "target": _vm.analytics.target
    }
  }, [_c('el-button', [_vm._v("\n              " + _vm._s(_vm.$t(_vm.analytics.text)) + "\n            ")])], 1) : _vm._e(), _vm._v(" "), _c('el-dropdown', {
    class: _vm.dropdown.lang.class,
    attrs: {
      "data-qa": "Header-Lang-DropDown",
      "trigger": _vm.dropdown.lang.trigger
    },
    on: {
      "command": _vm.dropdown.lang.command
    }
  }, [_c('el-button', {
    attrs: {
      "data-qa": "Header-Lang-Button"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.currentLang)), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.dropdown.lang.items), function(item) {
    return _c('el-dropdown-item', {
      key: item.text,
      attrs: {
        "command": item.command,
        "data-qa": item['data-qa'],
        "id": item.id
      }
    }, [_vm._v(_vm._s(item.text))])
  }))], 1), _vm._v(" "), _c('el-dropdown', {
    staticClass: "user-dropdown",
    attrs: {
      "data-qa": "Header-User-DropDown",
      "trigger": "click"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('el-button', {
    attrs: {
      "data-qa": "Header-User-Button"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.username)), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "solutionStatusTest",
      "data-qa": "Header-UserDropdown-Item-SolutionStatusTest",
      "id": "solutionStatusTest"
    }
  }, [_vm._v(_vm._s(_vm.$t('dashUserDropDownSolutionTestText')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "signOut",
      "data-qa": "Header-UserDropdown-Item-SignOut",
      "divided": "",
      "id": "signOut"
    }
  }, [_vm._v(_vm._s(_vm.$t('dashUserDropDownSignOutText')))])], 1)], 1)], 1), _vm._v(" "), _c('solution-status-test')], 1)], 1), _vm._v(" "), _c('el-main', [_c('router-view')], 1), _vm._v(" "), _c('el-footer', [_c('div', {
    attrs: {
      "data-qa": "Footer-ExositeCopyRight-Text"
    }
  }, [_vm._v("\n        © " + _vm._s(_vm.year) + "\n        "), _c('a', {
    attrs: {
      "href": _vm.footer.exosite.href,
      "target": _vm.footer.exosite.target,
      "data-qa": "Footer-ExositeCopyRight-Link"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.footer.exosite.text) + "\n        ")]), _vm._v(".\n        " + _vm._s(_vm.$t(_vm.footer.copyRight.text)) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "links-group"
  }, [_c('a', {
    attrs: {
      "data-qa": "Footer-Documentation-Link-Documentation",
      "href": _vm.footer.documentation.href
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.footer.documentation.text)))]), _vm._v(" "), _c('a', {
    attrs: {
      "data-qa": "Footer-Support-Link-Support",
      "href": _vm.footer.support.href
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.footer.support.text)))]), _vm._v(" "), _c('a', {
    attrs: {
      "data-qa": "Footer-Terms-Link-Terms",
      "href": _vm.footer.terms.href
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.footer.terms.text)))]), _vm._v(" "), _c('a', {
    attrs: {
      "data-qa": "Footer-Privacy-Link-Privacy",
      "href": _vm.footer.privacy.href
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.footer.privacy.text)))]), _vm._v(" "), (_vm.hasVersion) ? _c('span', {
    attrs: {
      "data-qa": ("Footer-Version-Link-" + (_vm.footer.version))
    }
  }, [_vm._v(_vm._s(_vm.currentVersion))]) : _vm._e()])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-DeleteInformationModel-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('informationModelDeleteDialogTitle')))]), _vm._v(" "), _c('i18n', {
    attrs: {
      "path": "informationModelDeleteConfirmText",
      "tag": "span"
    }
  }, [_c('el-tag', {
    attrs: {
      "place": "familyName",
      "type": "info"
    }
  }, [_vm._v(_vm._s(_vm.familyName))])], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer-content"
    },
    slot: "footer-content"
  }, [_c('el-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alert$.show),
      expression: "alert$.show"
    }],
    attrs: {
      "closable": false,
      "title": _vm.alert$.message,
      "type": _vm.alert$.type,
      "data-qa": "Dialog-DeleteInformationModel-Alert",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, _vm._l((_vm.buttons), function(button, index) {
    return _c('el-button', {
      key: index,
      class: button.class,
      attrs: {
        "data-qa": button.dataQA,
        "disabled": _vm.loading || _vm.errors.any(),
        "loading": _vm.loading,
        "type": button.type || 'warning'
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return button.click($event)
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.$t(button.text)) + "\n    ")])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "alt": "alt_text",
      "aria-hidden": "true",
      "border": "0",
      "height": "100",
      "src": _vm.imgUrl,
      "width": "100"
    },
    on: {
      "error": _vm.useDefaultImage
    }
  }), _vm._v(" "), _c('h1', {
    style: ({
      'color': _vm.primaryColor
    }),
    attrs: {
      "id": "title"
    }
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer legal-footer-padding"
  }, [_c('a', {
    staticClass: "company",
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_vm._v(_vm._s(_vm.address))]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_vm._v(_vm._s(_vm.contact))]), _vm._v(" "), _c('a', {
    staticClass: "terms",
    style: ({
      'color': _vm.primaryColor
    }),
    attrs: {
      "href": "/#/legal"
    }
  }, [_vm._v("Terms of Service")])])
},staticRenderFns: []}

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    staticClass: "info-icon"
  }, [_c('i', {
    class: _vm.classes
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "info-total"
  }, [_vm._v(_vm._s(_vm.total))])])])
},staticRenderFns: []}

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    attrs: {
      "offset": 4,
      "span": 16
    }
  }, [_c('logo', {
    attrs: {
      "title": _vm.legal.title,
      "primary-color": _vm.primaryColor
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._v(_vm._s(_vm.legal.content))]), _vm._v(" "), (_vm.isUpdated) ? _c('div', {
    staticClass: "last_update"
  }, [_vm._v("Last Updated on "), _c('span', {
    attrs: {
      "id": "last_update"
    }
  }, [_vm._v(_vm._s(_vm.legal.lastUpdate))])]) : _c('div', {
    staticClass: "last_update"
  }, [_vm._v("Never Updated.")]), _vm._v(" "), _c('company', {
    attrs: {
      "name": _vm.footer.companyName,
      "url": _vm.footer.companyUrl,
      "address": _vm.footer.companyAddress,
      "contact": _vm.footer.companyContact,
      "primary-color": _vm.primaryColor
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.noQuota) ? _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-CreateNotificationAdd-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('notificationsCreateTitleAdd')))]), _vm._v(" "), _c('el-form', {
    ref: "data",
    attrs: {
      "model": _vm.data,
      "id": "createForm",
      "enctype": "multipart/form-data",
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createNotification($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('familyName') ? _vm.errors.first('familyName') : '',
      "label": _vm.$t('notificationsCreateInputFamilyNameLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('familyName'),
      "data-qa": "Dialog-CreateNotificationFamilyName-Item"
    }
  }, [_c('el-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    staticClass: "full-width",
    attrs: {
      "placeholder": _vm.$t('notificationsCreateInputFamilyNamePlaceholder'),
      "data-vv-as": _vm.$t('notificationsCreateInputFamilyNameLabel'),
      "data-qa": "Dialog-CreateNotificationFamilyName-Select",
      "multiple": "",
      "name": "familyName",
      "required": ""
    },
    model: {
      value: (_vm.data.familyNames),
      callback: function($$v) {
        _vm.$set(_vm.data, "familyNames", $$v)
      },
      expression: "data.familyNames"
    }
  }, _vm._l((_vm.familyNames), function(name) {
    return _c('el-option', {
      key: name,
      attrs: {
        "label": name,
        "value": name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "column-describe",
    attrs: {
      "label-width": _vm.labelWidth,
      "data-qa": "Dialog-CreateNotificationFamilyName-Description"
    }
  }, [_c('div', {
    staticClass: "fit-line-height"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('notificationsCreateInputFamilyNameHint')))])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('ruleType') ? _vm.errors.first('ruleType') : '',
      "label": _vm.$t('notificationsCreateInputRuleTypeLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('ruleType'),
      "data-qa": "Dialog-CreateNotificationRuleType-Item"
    }
  }, [_c('el-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    staticClass: "full-width",
    attrs: {
      "placeholder": _vm.$t('notificationsCreateInputRuleTypePlaceholder'),
      "data-vv-as": _vm.$t('notificationsCreateInputRuleTypePlaceholder'),
      "data-qa": "Dialog-CreateNotificationRuleType-Select",
      "name": "ruleType",
      "required": ""
    },
    model: {
      value: (_vm.data.ruleType),
      callback: function($$v) {
        _vm.$set(_vm.data, "ruleType", $$v)
      },
      expression: "data.ruleType"
    }
  }, _vm._l((_vm.ruleTypes), function(type) {
    return _c('el-option', {
      key: type.key,
      attrs: {
        "label": type.label,
        "value": type.value
      }
    })
  })), _vm._v(" "), (_vm.isStatusRule) ? _c('el-row', {
    staticClass: "status-rule-block",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('key') ? _vm.errors.first('key') : '',
      "show-message": false
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: _vm.validate.deviceKey
        }
      }),
      expression: "{ rules: { required: true, regex: validate.deviceKey } }"
    }],
    attrs: {
      "placeholder": _vm.$t('notificationsCreateInputKeyPlaceholder'),
      "data-vv-as": _vm.$t('notificationsCreateInputKeyPlaceholder'),
      "clearable": "",
      "data-qa": "Dialog-CreateNotificationRuleTypeConditionsKey-Input",
      "name": "key",
      "required": "",
      "type": "text"
    },
    model: {
      value: (_vm.data.conditions.key),
      callback: function($$v) {
        _vm.$set(_vm.data.conditions, "key", $$v)
      },
      expression: "data.conditions.key"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('operator') ? _vm.errors.first('operator') : '',
      "show-message": false
    }
  }, [_c('el-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    attrs: {
      "placeholder": _vm.$t('notificationsCreateInputOperatorPlaceholder'),
      "data-vv-as": _vm.$t('notificationsCreateInputOperatorPlaceholder'),
      "data-qa": "Dialog-CreateNotificationRuleTypeConditionsOperators-Select",
      "name": "operator",
      "required": ""
    },
    model: {
      value: (_vm.data.conditions.op),
      callback: function($$v) {
        _vm.$set(_vm.data.conditions, "op", $$v)
      },
      expression: "data.conditions.op"
    }
  }, _vm._l((_vm.operators), function(op) {
    return _c('el-option', {
      key: op.key,
      attrs: {
        "label": op.label,
        "value": op.value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('target') ? _vm.errors.first('target') : '',
      "show-message": false
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          numeric: true
        }
      }),
      expression: "{ rules: { required: true, numeric: true } }"
    }],
    attrs: {
      "placeholder": _vm.$t('notificationsCreateInputTargetPlaceholder'),
      "data-vv-as": _vm.$t('notificationsCreateInputTargetPlaceholder'),
      "clearable": "",
      "data-qa": "Dialog-CreateNotificationRuleTypeConditionsTarget-Input",
      "name": "target",
      "required": "",
      "type": "text"
    },
    model: {
      value: (_vm.data.conditions.target),
      callback: function($$v) {
        _vm.$set(_vm.data.conditions, "target", $$v)
      },
      expression: "data.conditions.target"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hasConditionsError) ? _c('div', {
    staticClass: "help is-danger conditions-error"
  }, [(_vm.errors.has('key')) ? _c('p', [_vm._v(_vm._s(_vm.$t('notificationsCreateInputKeyError')))]) : _vm._e(), _vm._v(" "), (_vm.errors.has('operator')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('operator')))]) : _vm._e(), _vm._v(" "), (_vm.errors.has('target')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('target')))]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "column-describe",
    attrs: {
      "label-width": _vm.labelWidth,
      "data-qa": "Dialog-CreateNotificationRuleType-Description"
    }
  }, [_c('div', {
    staticClass: "fit-line-height"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('notificationsCreateInputRuleTypeHint')))])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('title') ? _vm.errors.first('title') : '',
      "label": _vm.$t('notificationsCreateInputTitleLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('title'),
      "data-qa": "Dialog-CreateNotificationTitle-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          max: 40
        }
      }),
      expression: "{ rules: { required: true, max: 40 } }"
    }],
    attrs: {
      "placeholder": _vm.$t('notificationsCreateInputTitlePlaceholder'),
      "data-vv-as": _vm.$t('notificationsCreateInputTitleLabel'),
      "clearable": "",
      "data-qa": "Dialog-CreateNotificationTitle-Input",
      "name": "title",
      "required": "",
      "type": "text"
    },
    model: {
      value: (_vm.data.title),
      callback: function($$v) {
        _vm.$set(_vm.data, "title", $$v)
      },
      expression: "data.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "column-describe",
    attrs: {
      "label-width": _vm.labelWidth,
      "data-qa": "Dialog-CreateNotificationTitle-Description"
    }
  }, [_c('div', {
    staticClass: "fit-line-height"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('notificationsCreateInputTitleHint1')))]), _c('br'), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.$t('notificationsCreateInputTitleHint2')))])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('message') ? _vm.errors.first('message') : '',
      "label": _vm.$t('notificationsCreateInputMessageLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('message'),
      "data-qa": "Dialog-CreateNotificationMessage-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          max: 160
        }
      }),
      expression: "{ rules: { required: true, max: 160 } }"
    }],
    attrs: {
      "placeholder": _vm.$t('notificationsCreateInputMessagePlaceholder'),
      "data-vv-as": _vm.$t('notificationsCreateInputMessageLabel'),
      "clearable": "",
      "data-qa": "Dialog-CreateNotificationMessage-Input",
      "name": "message",
      "required": "",
      "type": "text"
    },
    model: {
      value: (_vm.data.message),
      callback: function($$v) {
        _vm.$set(_vm.data, "message", $$v)
      },
      expression: "data.message"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "column-describe",
    attrs: {
      "label-width": _vm.labelWidth,
      "data-qa": "Dialog-CreateNotificationMessage-Description"
    }
  }, [_c('div', {
    staticClass: "fit-line-height"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('notificationsCreateInputMessageHint1')))]), _c('br'), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.$t('notificationsCreateInputMessageHint2')))])])])], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('el-button', {
    staticClass: "btn-close",
    attrs: {
      "data-qa": "Dialog-CreateNotification-Button-Close",
      "type": "text"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('notificationsCreateDialogButtonCloseText')) + "\n    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading || _vm.errors.any(),
      "loading": _vm.loading,
      "data-qa": "Dialog-CreateNotification-Button-Save",
      "type": "warning"
    },
    on: {
      "click": _vm.createNotification
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('notificationsCreateDialogButtonSaveText')) + "\n    ")])], 1)], 1) : _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-CreateNotificationNoQuota-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('notificationsCreateTitleNoQuota')))]), _vm._v(" "), _c('i18n', {
    attrs: {
      "path": "notificationsCreateBodyNoQuota",
      "data-qa": "Dialog-CreateNotificationNoQuota-Text",
      "tag": "span"
    }
  }, [_c('a', {
    attrs: {
      "place": "support",
      "href": "mailto:support@exosite.com"
    }
  }, [_vm._v("support")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('el-button', {
    attrs: {
      "data-qa": "Dialog-CreateNotificationNoQuota-Button-OK",
      "type": "warning"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('notificationsCreateDialogButtonOKText')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('time-line', {
    attrs: {
      "target": _vm.user.email
    }
  }), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "header": _vm.$t('userInfoCardDevicesHeaderText', {
        devicesCount: _vm.devicesCount
      }),
      "data-qa": "Content-UserInfo-Card-Devices"
    }
  }, [(_vm.devicesCount > 0) ? _c('div', _vm._l((_vm.devices), function(device, index) {
    return _c('p', {
      key: ((device.id) + "-" + index)
    }, [_c('router-link', {
      attrs: {
        "data-qa": ("Content-UserInfo-DeviceLink-" + (device.id)),
        "to": ("/device/" + (device.id)),
        "replace": ""
      }
    }, [_vm._v(_vm._s(device.id))])], 1)
  })) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('userInfoCardDevicesEmptyText')))])])]), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "header": _vm.$t('userInfoCardGroupsHeaderText', {
        groupsCount: _vm.groupsCount
      }),
      "data-qa": "Content-UserInfo-Card-Groups"
    }
  }, [(_vm.groupsCount > 0) ? _c('div', _vm._l((_vm.groups), function(group, index) {
    return _c('p', {
      key: ((group.name) + "-" + index)
    }, [_vm._v(_vm._s(_vm.getGroupName(group)))])
  })) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('userInfoCardGroupEmptyText')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "primary-header"
  }, [_c('h1', {
    attrs: {
      "data-qa": "Content-Export-Title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.componentTitle) + "\n      "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])])]), _vm._v(" "), _c('div', [_c('el-date-picker', {
    attrs: {
      "picker-options": _vm.pickerOptions,
      "end-placeholder": "End Date",
      "start-placeholder": "Start Date",
      "type": "daterange"
    },
    on: {
      "change": function($event) {
        _vm.onPickerChange(_vm.dateRange)
      }
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.isExportDisabled,
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.exportData(_vm.dateRange)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('exportButton')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.error))])])
},staticRenderFns: []}

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-DeleteFirmware-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('firmwareDeleteDialogTitle')))]), _vm._v(" "), _c('i18n', {
    attrs: {
      "path": "firmwareDeleteDialogConfirmText",
      "data-qa": "Dialog-DeleteFirmware-ConfirmText",
      "tag": "span"
    }
  }, [_c('el-tag', {
    attrs: {
      "place": "version",
      "type": "info"
    }
  }, [_vm._v(_vm._s(_vm.version))])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, _vm._l((_vm.buttons), function(button, index) {
    return _c('el-button', {
      key: index,
      class: button.class,
      attrs: {
        "data-qa": ("Dialog-DeleteFirmware-Button-" + (button.id)),
        "type": button.type || 'warning'
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return button.click($event)
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.$t(button.text)) + "\n    ")])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "primary-header"
  }, [_c('h1', {
    attrs: {
      "data-qa": "Content-User-Title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.componentTitle) + "\n      "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])])]), _vm._v(" "), _c('hamv-info-box', {
    attrs: {
      "title": _vm.$t('userInfoBoxTitleUsersText'),
      "total": _vm.total.users || '--',
      "classes": "fa fa-user"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-search"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:4|max:50'),
      expression: "'min:4|max:50'"
    }],
    attrs: {
      "placeholder": _vm.$t('userInputSearchBarPlaceholder'),
      "clearable": "",
      "name": "searchQuery",
      "type": "text"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.userSearch(_vm.searchQuery)
      }
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "disabled": _vm.errors.has('searchQuery'),
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        _vm.userSearch(_vm.searchQuery)
      }
    },
    slot: "append"
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('searchQuery')),
      expression: "errors.has('searchQuery')"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.$t('userInputSearchBarError')))])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    ref: "userListTable",
    staticClass: "user-table",
    attrs: {
      "element-loading-text": _vm.$t('userTableLoadingText'),
      "empty-text": _vm.$t('userTableEmptyText'),
      "expand-row-keys": _vm.expanded,
      "data": _vm.userList,
      "row-key": _vm.getRowKey,
      "data-qa": "Content-User-Table",
      "element-loading-background": "#FFFFFF",
      "fit": "",
      "max-height": "100%",
      "row-class-name": "pointer",
      "show-header": ""
    },
    on: {
      "expand-change": _vm.handleExpand,
      "row-click": _vm.toggleRowExpansion
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('user-info', {
          attrs: {
            "user": _vm.userInfo,
            "loading": _vm.isLoadingInfo
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('userTableColEmailLabel'),
      "sortable": "",
      "prop": "email",
      "min-width": "210"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('userTableColRegisteredTimeLabel'),
      "min-width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.convertTime(scope.row.creation_date)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('userTooltipDeleteText'),
            "effect": "dark",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "data-qa": 'Content-DeleteUser-Button-' + scope.row.id,
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.deleteUser(scope.row.id, scope.row.email)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash fa-2 operation-icons"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.showPagination) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.pagination.currentPage,
      "disabled": _vm.isLoading,
      "layout": _vm.pagination.layout,
      "page-size": _vm.pagination.limit,
      "total": _vm.searchedTotal,
      "background": ""
    },
    on: {
      "update:currentPage": function($event) {
        _vm.$set(_vm.pagination, "currentPage", $event)
      },
      "current-change": _vm.getCurrentPageUser
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('user-delete')], 1)
},staticRenderFns: []}

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    attrs: {
      "offset": 4,
      "span": 16
    }
  }, [_c('logo', {
    attrs: {
      "title": _vm.title,
      "primary-color": _vm.primaryColor
    }
  }), _vm._v("\n    " + _vm._s(_vm.welcomeBody) + "\n    "), _c('br'), _c('br'), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin": "auto",
      "width": "90%"
    },
    attrs: {
      "role": "presentation",
      "aria-hidden": "true",
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.appleStore
    }
  }, [_c('img', {
    staticStyle: {
      "width": "95%",
      "height": "auto",
      "font-family": "sans-serif"
    },
    attrs: {
      "src": "/src/assets/img/appStoreBadge@2x.png",
      "aria-hidden": "true",
      "alt": "alt_text",
      "border": "0"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.googlePlay
    }
  }, [_c('img', {
    staticStyle: {
      "width": "95%",
      "height": "auto",
      "font-family": "sans-serif"
    },
    attrs: {
      "src": "/src/assets/img/googlePlayBadge@2x.png",
      "aria-hidden": "true",
      "alt": "alt_text",
      "border": "0"
    }
  })])])])]), _vm._v(" "), (_vm.isMobile) ? _c('table', {
    staticStyle: {
      "margin": "auto",
      "width": "90%"
    },
    attrs: {
      "role": "presentation",
      "aria-hidden": "true",
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "button-td",
    staticStyle: {
      "border-radius": "30px",
      "text-align": "center"
    },
    style: ({
      background: _vm.primaryColor
    })
  }, [_c('a', {
    staticClass: "button-a",
    staticStyle: {
      "border": "15px solid",
      "font-family": "'Nunito Sans', sans-serif",
      "font-size": "17px",
      "font-weight": "700",
      "line-height": "1.1",
      "text-align": "center",
      "text-decoration": "none",
      "display": "block",
      "border-radius": "30px"
    },
    style: ({
      background: _vm.primaryColor,
      'border-color': _vm.primaryColor
    }),
    attrs: {
      "href": _vm.url
    }
  }, [_c('span', {
    staticClass: "button-link",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("    Open App    ")])])])])]) : _vm._e(), _vm._v(" "), _c('company', {
    attrs: {
      "name": _vm.footer.companyName,
      "url": _vm.footer.companyUrl,
      "address": _vm.footer.companyAddress,
      "contact": _vm.footer.companyContact,
      "primary-color": _vm.primaryColor
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "device-info-boxes"
  }, [_c('hamv-info-box', {
    attrs: {
      "title": _vm.$t('deviceInfoBoxesTitleDevicesText'),
      "total": _vm.numberOfDevices,
      "classes": "fa fa-lightbulb-o"
    }
  }), _vm._v(" "), _c('hamv-info-box', {
    attrs: {
      "title": _vm.$t('deviceInfoBoxesTitleOnlineText'),
      "total": _vm.numberOfConnection,
      "classes": "fa fa-wifi"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-SolutionStatusTest-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('solutionStatusTestDialogTitle')) + "\n  "), _c('p', {
    class: _vm.description.class
  }, [_vm._v("\n    " + _vm._s(_vm.$t(_vm.description.text)) + "\n    "), _c('u', [_c('a', {
    attrs: {
      "href": _vm.support.href,
      "target": _vm.support.target
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.support.text)))])]), _vm._v(".\n  ")])]), _vm._v(" "), _c('el-form', {
    ref: "data",
    attrs: {
      "model": _vm.data,
      "id": "testform",
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.triggerTest($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('account') ? _vm.$t('solutionStatusTestInputAccountError') : '',
      "label": _vm.$t('solutionStatusTestInputAccountLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('account'),
      "data-qa": "Dialog-SolutionStatusTestAccount-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true} }"
    }],
    attrs: {
      "disabled": true,
      "data-qa": "Dialog-SolutionStatusTestAccount-Input",
      "name": "account",
      "required": "",
      "type": "email"
    },
    model: {
      value: (_vm.data.SolutionAccount),
      callback: function($$v) {
        _vm.$set(_vm.data, "SolutionAccount", $$v)
      },
      expression: "data.SolutionAccount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('password') ? _vm.$t('solutionStatusTestInputPasswordError') : '',
      "label": _vm.$t('solutionStatusTestInputPasswordLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('password'),
      "data-qa": "Dialog-SolutionStatusTestPassword-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true} }"
    }],
    attrs: {
      "clearable": "",
      "data-qa": "Dialog-SolutionStatusTestPassword-Input",
      "name": "password",
      "required": "",
      "type": "password"
    },
    model: {
      value: (_vm.data.SolutionPassword),
      callback: function($$v) {
        _vm.$set(_vm.data, "SolutionPassword", $$v)
      },
      expression: "data.SolutionPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('recipients') ? 'error' : '',
      "label": _vm.$t(_vm.recipients.label),
      "label-width": _vm.labelWidth,
      "show-message": false,
      "data-qa": "Dialog-SolutionStatusTestRecipients-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|emails'),
      expression: "'required|emails'"
    }],
    attrs: {
      "clearable": "",
      "autosize": {
        minRows: 3
      },
      "data-vv-as": _vm.$t(_vm.recipients.label),
      "name": "recipients",
      "required": "",
      "placeholder": "example1@email.com,example2@email.com",
      "type": "textarea"
    },
    model: {
      value: (_vm.data.RecipientList),
      callback: function($$v) {
        _vm.$set(_vm.data, "RecipientList", $$v)
      },
      expression: "data.RecipientList"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('recipients')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(_vm.recipients.tips)))])], 1)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('el-button', {
    staticClass: "btn-close",
    attrs: {
      "data-qa": "Dialog-SolutionStatusTest-Button-Close",
      "type": "text"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('solutionStatusTestDialogButtonCloseText')) + "\n    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading || _vm.errors.any(),
      "loading": _vm.loading,
      "data-qa": "Dialog-SolutionStatusTest-Button-Save",
      "type": "warning"
    },
    on: {
      "click": _vm.triggerTest
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('solutionStatusTestDialogButtonOKText')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    attrs: {
      "offset": 4,
      "span": 16
    }
  }, [_c('logo', {
    attrs: {
      "title": _vm.title,
      "primary-color": _vm.primaryColor
    }
  }), _vm._v("\n    " + _vm._s(_vm.welcomeBody) + "\n    "), _c('br'), _c('br'), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin": "auto",
      "width": "90%"
    },
    attrs: {
      "role": "presentation",
      "aria-hidden": "true",
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.appleStore
    }
  }, [_c('img', {
    staticStyle: {
      "width": "95%",
      "height": "auto",
      "font-family": "sans-serif"
    },
    attrs: {
      "src": "/src/assets/img/appStoreBadge@2x.png",
      "aria-hidden": "true",
      "alt": "alt_text",
      "border": "0"
    }
  })])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.googlePlay
    }
  }, [_c('img', {
    staticStyle: {
      "width": "95%",
      "height": "auto",
      "font-family": "sans-serif"
    },
    attrs: {
      "src": "/src/assets/img/googlePlayBadge@2x.png",
      "aria-hidden": "true",
      "alt": "alt_text",
      "border": "0"
    }
  })])])])]), _vm._v(" "), (_vm.isMobile) ? _c('table', {
    staticStyle: {
      "margin": "auto",
      "width": "90%"
    },
    attrs: {
      "role": "presentation",
      "aria-hidden": "true",
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "button-td",
    staticStyle: {
      "border-radius": "30px",
      "text-align": "center"
    },
    style: ({
      background: _vm.primaryColor
    })
  }, [_c('a', {
    staticClass: "button-a",
    staticStyle: {
      "border": "15px solid",
      "font-family": "'Nunito Sans', sans-serif",
      "font-size": "17px",
      "font-weight": "700",
      "line-height": "1.1",
      "text-align": "center",
      "text-decoration": "none",
      "display": "block",
      "border-radius": "30px"
    },
    style: ({
      background: _vm.primaryColor,
      'border-color': _vm.primaryColor
    }),
    attrs: {
      "href": _vm.url
    }
  }, [_c('span', {
    staticClass: "button-link",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("    Open App    ")])])])])]) : _vm._e(), _vm._v(" "), _c('company', {
    attrs: {
      "name": _vm.footer.companyName,
      "url": _vm.footer.companyUrl,
      "address": _vm.footer.companyAddress,
      "contact": _vm.footer.companyContact,
      "primary-color": _vm.primaryColor
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    attrs: {
      "offset": 4,
      "span": 16
    }
  }, [_c('logo', {
    attrs: {
      "title": _vm.title,
      "primary-color": _vm.primaryColor
    }
  }), _vm._v(" "), (_vm.state === 'reset') ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('p', [_vm._v("To reset your password, enter a new password below.")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin": "auto",
      "width": "90%"
    },
    attrs: {
      "role": "presentation",
      "aria-hidden": "true",
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left",
      "font-weight": "bold",
      "padding": "1.2em 0.8em"
    }
  }, [_vm._v("\n            NEW PASSWORD"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pw_new1),
      expression: "pw_new1"
    }],
    staticClass: "input password-input",
    staticStyle: {
      "margin": "auto",
      "width": "90%",
      "border-style": "none none solid none",
      "border-bottom-color": "rgb(210, 210, 210)"
    },
    attrs: {
      "placeholder": "Enter your new password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.pw_new1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pw_new1 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left",
      "font-weight": "bold",
      "padding": "1.2em 0.8em"
    }
  }, [_vm._v("\n            RETYPE NEW PASSWORD"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pw_new2),
      expression: "pw_new2"
    }],
    staticClass: "input password-input",
    staticStyle: {
      "margin": "auto",
      "width": "90%",
      "border-style": "none none solid none",
      "border-bottom-color": "rgb(210, 210, 210)"
    },
    attrs: {
      "placeholder": "Retype your new password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.pw_new2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pw_new2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [(_vm.reset_error1) ? _c('td', {
    staticClass: "reset_error"
  }, [_c('h3', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Password too short or too long.")]), _vm._v("\n            Passwords must be between 8-20 characters.\n          ")]) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.reset_error2) ? _c('td', {
    staticClass: "reset_error"
  }, [_c('h3', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Passwords not matching.")]), _vm._v("\n            Make sure your new passwords match.\n          ")]) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.reset_error3) ? _c('td', {
    staticClass: "reset_error"
  }, [_c('h3', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Server error.")]), _vm._v("\n            Please try again later.\n          ")]) : _vm._e()])]), _vm._v(" "), _c('button', {
    style: ({
      background: _vm.primaryColor,
      'border-color': _vm.primaryColor
    }),
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Reset Password")])]) : _vm._e(), _vm._v(" "), (_vm.state === 'expired') ? _c('p', [_vm._v("Your link expires after 24 hours or once a new password is set. If you still wish to reset your password, please use the mobile app to request a new password reset link.")]) : _vm._e(), _vm._v(" "), (_vm.state === 'done') ? _c('p', [_vm._v("Please reopen the myProduct app and try logging into your account.")]) : _vm._e(), _vm._v(" "), _c('company', {
    attrs: {
      "name": _vm.footer.companyName,
      "url": _vm.footer.companyUrl,
      "address": _vm.footer.companyAddress,
      "contact": _vm.footer.companyContact,
      "primary-color": _vm.primaryColor
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-main', {
    staticClass: "reset-password"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "data-qa": "Content-Logo-Image",
      "src": "/src/assets/img/admin-logo.png"
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "reset-form",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('resetFormTitle')))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('resetFormDescription')) + "\n    ")]), _vm._v(" "), _c('el-form', {
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.errors.first('email'),
      "show-message": _vm.errors.has('email'),
      "prop": "email"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "placeholder": _vm.$t('resetInputEmailPlaceholder'),
      "clearable": "",
      "data-qa": "Content-ResetPasswordEmail-Input",
      "name": "email",
      "type": "text"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.validateForm($event)
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-open email",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "disabled": _vm.loading || _vm.errors.any(),
      "loading": _vm.loading,
      "data-qa": "Content-ResetPassword-Button",
      "id": "signIn",
      "type": "primary"
    },
    on: {
      "click": _vm.validateForm
    }
  }, [_vm._v(_vm._s(_vm.$t('resetButtonSignInText')))])], 1)], 1), _vm._v(" "), _c('router-link', {
    staticClass: "go-back",
    attrs: {
      "data-qa": "Content-ResetPasswordBack-Link",
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm.$t('resetLinkSignInText')))])], 1), _vm._v(" "), (_vm.response) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-card', [_c('div', {
    attrs: {
      "slot": "header",
      "data-qa": "Content-ResetPasswordError-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('resetErrorResponseTitle')))]), _vm._v(" "), _c('div', {
    attrs: {
      "data-qa": "Content-ResetPasswordError-Body"
    }
  }, [_vm._v(_vm._s(_vm.response))])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "theme-block"
  }, [(_vm.title) ? _c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "data",
    attrs: {
      "element-loading-text": _vm.$t('themeViewFormLoadingText'),
      "model": _vm.data,
      "enctype": "multipart/form-data",
      "id": "uploadform",
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.data.file), function(item, id) {
    return (_vm.data.file) ? _c('el-form-item', {
      key: id,
      attrs: {
        "data-qa": ("Content-ThemeForm-Item-" + id),
        "label-width": _vm.labelWidth,
        "label": _vm.$t(item.label)
      }
    }, [_c('div', {
      staticClass: "image-block"
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.currentImgSrc || !item.isLocal),
        expression: "item.currentImgSrc || !item.isLocal"
      }],
      attrs: {
        "src": item.currentImgSrc,
        "height": "34"
      },
      on: {
        "error": function($event) {
          _vm.whenImageNotFound(id)
        }
      }
    }), _vm._v(" "), (item.isLocal) ? _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (item.validate),
        expression: "item.validate"
      }],
      staticClass: "input-file",
      class: item.class,
      attrs: {
        "data-qa": ("Content-ThemeForm-Upload-" + id),
        "id": item.name,
        "name": item.name,
        "accept": "image/*",
        "type": "file"
      },
      on: {
        "change": function($event) {
          _vm.onFileChange(id, $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.isLocal) ? _c('label', {
      staticClass: "el-button el-button--default",
      attrs: {
        "for": item.name
      }
    }, [_vm._v(_vm._s(_vm.$t('themeViewButtonUploadImageText')))]) : _vm._e(), _vm._v(" "), (item.isLocal) ? _c('div', {
      staticClass: "selected-file-name"
    }, [_vm._v(_vm._s(item.selectedFileName || _vm.$t('NoFileChosen')))]) : _vm._e(), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.isLocal),
        expression: "!item.isLocal"
      }],
      attrs: {
        "data-qa": ("Content-ThemeForm-Button-" + id)
      },
      on: {
        "click": function($event) {
          _vm.removeImage(id)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t('themeViewButtonRemoveImageText')) + "\n        ")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "name": 'remove_' + id
      },
      domProps: {
        "value": item.isLocal ? id : ''
      }
    })], 1), _vm._v(" "), (_vm.errors.has(item.name)) ? _c('div', {
      staticClass: "help is-danger"
    }, [_vm._v("\n        " + _vm._s(_vm.errors.first(item.name)) + "\n      ")]) : _vm._e(), _vm._v(" "), (item.description) ? _c('div', {
      staticClass: "column-describe",
      attrs: {
        "data-qa": ("Content-ThemeForm-Description-" + id)
      }
    }, [_c('i', [_vm._v(_vm._s(_vm.$t(item.description)))])]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.data.text), function(item, id) {
    return _c('el-form-item', {
      key: id,
      attrs: {
        "data-qa": ("Content-ThemeForm-Item-" + id),
        "error": _vm.errors.has(id) ? _vm.errors.first(id) : '',
        "label": _vm.$t(item.label),
        "label-width": _vm.labelWidth,
        "show-message": _vm.errors.has(id)
      }
    }, [(_vm.isText(item.type) || _vm.isPassword(item.type)) ? _c('el-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (item.validate),
        expression: "item.validate"
      }],
      attrs: {
        "auto-complete": _vm.isPassword(item.type) ? 'new-password' : 'off',
        "data-qa": ("Content-ThemeForm-Input-" + id),
        "id": id,
        "name": id,
        "data-vv-as": _vm.$t(item.label),
        "placeholder": _vm.$t(item.placeholder) || '',
        "clearable": "",
        "type": item.type,
        "data-vv-validate-on": _vm.isPassword(item.type) ? 'change' : 'input|blur'
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isNumber(item.type)) ? _c('el-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (item.validate),
        expression: "item.validate"
      }],
      attrs: {
        "data-qa": ("Content-ThemeForm-Input-" + id),
        "id": id,
        "name": id,
        "data-vv-as": _vm.$t(item.label),
        "placeholder": _vm.$t(item.placeholder) || '',
        "clearable": "",
        "type": item.type
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", _vm._n($$v))
        },
        expression: "item.model"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isColorPicker(item.type)) ? _c('el-color-picker', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (item.validate),
        expression: "item.validate"
      }],
      attrs: {
        "data-qa": ("Content-ThemeForm-ColorPicker-" + id),
        "data-vv-as": _vm.$t(item.label),
        "id": id,
        "name": id,
        "placeholder": _vm.$t(item.placeholder),
        "popper-class": item.class
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isColorPicker(item.type)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.model),
        expression: "item.model"
      }],
      attrs: {
        "name": id,
        "type": "hidden"
      },
      domProps: {
        "value": (item.model)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "model", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isTextarea(item.type)) ? _c('el-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (item.validate),
        expression: "item.validate"
      }],
      class: item.class,
      attrs: {
        "data-qa": ("Content-ThemeForm-Textarea-" + id),
        "id": id,
        "name": id,
        "placeholder": _vm.$t(item.placeholder) || '',
        "rows": 20,
        "type": "textarea"
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }) : _vm._e(), _vm._v(" "), (item.description) ? _c('div', {
      staticClass: "column-describe",
      attrs: {
        "data-qa": ("Content-ThemeForm-Description-" + id)
      }
    }, [_c('i', [_vm._v(_vm._s(_vm.$t(item.description)))])]) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "btn-display-end",
    attrs: {
      "size": "large"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.saving || _vm.errors.any(),
      "loading": _vm.saving,
      "data-qa": "Content-ThemeForm-Button-Save",
      "native-type": "submit",
      "type": "warning"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('themeViewButtonSaveText')) + "\n      ")])], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-main', {
    staticClass: "not-found"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "data-qa": "Content-Logo-Image",
      "src": "/src/assets/img/admin-logo.png"
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('notFoundTitle')))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('notFoundDescription')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons-block"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('notFoundButtonHomeText')))])], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.goSupportPage
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('notFoundButtonSupportText')))])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en": [
		104
	],
	"./en.js": [
		104
	],
	"./en.json": [
		396
	],
	"./index": [
		130
	],
	"./index.js": [
		130
	],
	"./zh": [
		190,
		0
	],
	"./zh.js": [
		190,
		0
	],
	"./zh.json": [
		997,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 994;

/***/ }),
/* 995 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(189);
module.exports = __webpack_require__(397);


/***/ })
],[996]);


// WEBPACK FOOTER //
// src/assets/js/app.da78c946b571d467ab63.js